var app = function() {
    "use strict";
    function t(t, e) {
        return e.forEach((function(e) {
            e && "string" != typeof e && !Array.isArray(e) && Object.keys(e).forEach((function(i) {
                if ("default" !== i && !(i in t)) {
                    var s = Object.getOwnPropertyDescriptor(e, i);
                    Object.defineProperty(t, i, s.get ? s : {
                        enumerable: !0,
                        get: function() {
                            return e[i]
                        }
                    })
                }
            }
            ))
        }
        )),
        Object.freeze(t)
    }
    class e {
        static formatWithDelimiters(t, e, i, s) {
            if (e = e || 2,
            i = i || ",",
            s = s || ".",
            isNaN(t) || null == t)
                return 0;
            const n = (t = (t / 100).toFixed(e)).split(".");
            return n[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + i) + (n[1] ? s + n[1] : "")
        }
        static searchEnabled() {
            let t = !0;
            try {
                let e = document.querySelector("#shopify-features");
                e && !JSON.parse(e.innerHTML).predictiveSearch && (t = !1)
            } catch (t) {
                console.error(t)
            }
            return t
        }
        static nextFrame(t) {
            window.requestAnimationFrame(( () => {
                window.requestAnimationFrame(t)
            }
            ))
        }
        static stripHTML(t) {
            let e = document.createElement("DIV");
            return e.innerHTML = t,
            e.textContent || e.innerText || ""
        }
        static gidToId(t) {
            let e = t.split("/");
            return Number(e[e.length - 1])
        }
        static idToGid(t, e) {
            return `gid://shopify/${e}/${t}`
        }
        static stringToColor(t, e=100, i=75) {
            let s = 0;
            for (let e = 0; e < t.length; e++)
                s = t.charCodeAt(e) + ((s << 5) - s),
                s |= 0;
            return `hsl(${s % 360}, ${e}%, ${i}%)`
        }
        static makeid(t) {
            let e = "";
            const i = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
            let s = 0;
            for (; s < t; )
                e += i.charAt(Math.floor(62 * Math.random())),
                s += 1;
            return e
        }
        static getEndpoint(t) {
            return t.includes("?") ? `${t}&v=${Math.random()}` : `${t}?v=${Math.random()}`
        }
        static formatMoney(t, i) {
            "string" == typeof t && (t = t.replace(".", ""));
            let s = "";
            const n = /\{\{\s*(\w+)\s*\}\}/;
            switch (i.match(n)[1]) {
            case "amount":
                s = e.formatWithDelimiters(t, 2);
                break;
            case "amount_no_decimals":
                s = e.formatWithDelimiters(t, 0);
                break;
            case "amount_with_comma_separator":
                s = e.formatWithDelimiters(t, 2, ".", ",");
                break;
            case "amount_no_decimals_with_comma_separator":
                s = e.formatWithDelimiters(t, 0, ".", ",");
                break;
            case "amount_no_decimals_with_space_separator":
                s = e.formatWithDelimiters(t, 0, " ")
            }
            return i.replace(n, s)
        }
        static removeProtocol(t) {
            return t.replace(/http(s)?:/, "")
        }
        static getSizedImageUrl(t, i) {
            if (null === i || null === t)
                return t;
            if ("master" === i)
                return e.removeProtocol(t);
            let s = t.match(/\.(avif|webp|jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?/i);
            if (s) {
                let n = t.split(s[0])
                  , r = s[0];
                return e.removeProtocol(n[0] + "_" + i + r)
            }
            return null
        }
        static anyBitElementInViewport(t) {
            for (var e = t.offsetTop, i = t.offsetLeft, s = t.offsetWidth, n = t.offsetHeight; t.offsetParent; )
                e += (t = t.offsetParent).offsetTop,
                i += t.offsetLeft;
            return e < window.pageYOffset + window.innerHeight && i < window.pageXOffset + window.innerWidth && e + n > window.pageYOffset && i + s > window.pageXOffset
        }
        static handleize(t) {
            t = t.toLowerCase().trim();
            let e = ['"', "'", "\\", "(", ")", "[", "]"];
            for (let i = 0; i < e.length; ++i)
                t = t.replace(e[i], "");
            return "-" == (t = t.replace(/\W+/g, "-")).charAt(t.length - 1) && (t = t.replace(/-+\z/, "")),
            "-" == t.charAt(0) && (t = t.replace(/\A-+/, "")),
            t
        }
        static merge(t, i) {
            const s = t => t && "object" == typeof t;
            return s(t) && s(i) ? (Object.keys(i).forEach((n => {
                const r = t[n]
                  , o = i[n];
                Array.isArray(r) && Array.isArray(o) ? t[n] = r.concat(o) : s(r) && s(o) ? t[n] = e.merge(Object.assign({}, r), o) : t[n] = o
            }
            )),
            t) : i
        }
    }
    let i = {
        cart: {
            clear: "cart/clear.json",
            get: "cart.json",
            add: "cart/add.js",
            change: "cart/change.js",
            update: "cart/update.js"
        },
        product: {
            get: "products/[handle].json",
            getCustom: "products/[handle]?view=json"
        },
        search: {
            products: "search/suggest.json?resources[type]=product&q=[query]"
        }
    };
    const s = {
        "Content-Type": "application/json"
    };
    let n = {};
    class r {
        static async searchProducts(t, n=Shopify.routes.root) {
            let r = e.searchEnabled() ? n + e.getEndpoint(i.search.products.replace("[query]", t)) : `${n}search?q=${t}&view=uploadify-json&type=product`
              , o = await fetch(r, {
                headers: s
            });
            return await o.json()
        }
        static async getCart(t=Shopify.routes.root) {
            let n = await fetch(t + e.getEndpoint(i.cart.get), {
                headers: s
            });
            return await n.json()
        }
        static async addToCart(t, n=Shopify.routes.root) {
            let r = await fetch(n + e.getEndpoint(i.cart.add), {
                method: "POST",
                body: JSON.stringify(t),
                headers: s
            });
            return await r.json()
        }
        static async changeCart(t, n=Shopify.routes.root) {
            let r = await fetch(n + e.getEndpoint(i.cart.change), {
                method: "POST",
                body: JSON.stringify(t),
                headers: s
            });
            return await r.json()
        }
        static async updateCart(t, n=Shopify.routes.root) {
            let r = await fetch(n + e.getEndpoint(i.cart.update), {
                method: "POST",
                body: JSON.stringify(t),
                headers: s
            });
            return await r.json()
        }
        static async emptyCart(t, n=Shopify.routes.root) {
            let r = await fetch(n + e.getEndpoint(i.cart.clear), {
                method: "POST",
                body: JSON.stringify(t),
                headers: s
            });
            return await r.json()
        }
        static async updateCartItem(t, e, i={}, s=Shopify.routes.root) {
            return await r.changeCart({
                line: `${t}`,
                quantity: e,
                properties: i
            }, state)
        }
        static async removeCartItem(t) {
            return await r.updateCartItem(t, 0)
        }
        static async getProduct(t, r=Shopify.routes.root) {
            if (n[t])
                return JSON.parse(JSON.stringify(n[t]));
            let o = i.product.get.replace("[handle]", t)
              , a = await fetch(r + e.getEndpoint(o), {
                headers: s
            })
              , l = (await a.json()).product;
            return l.price = l.variants[0].price,
            l.compare_at_price = l.variants[0].compare_at_price,
            l.hasOnlyDefaultVariant = "Default Title" === l.variants[0].title,
            l.currentVariant = l.variants[0],
            l.currentVariantId = l.currentVariant.id,
            l.url = `${r}products/${l.handle}`,
            n[l.handle] = l,
            l
        }
    }
    function o(t, e) {
        return function() {
            return t.apply(e, arguments)
        }
    }
    const {toString: a} = Object.prototype
      , {getPrototypeOf: l} = Object
      , c = (t => e => {
        const i = a.call(e);
        return t[i] || (t[i] = i.slice(8, -1).toLowerCase())
    }
    )(Object.create(null))
      , h = t => (t = t.toLowerCase(),
    e => c(e) === t)
      , d = t => e => typeof e === t
      , {isArray: u} = Array
      , p = d("undefined");
    const m = h("ArrayBuffer");
    const f = d("string")
      , g = d("function")
      , v = d("number")
      , y = t => null !== t && "object" == typeof t
      , _ = t => {
        if ("object" !== c(t))
            return !1;
        const e = l(t);
        return !(null !== e && e !== Object.prototype && null !== Object.getPrototypeOf(e) || Symbol.toStringTag in t || Symbol.iterator in t)
    }
      , b = h("Date")
      , w = h("File")
      , S = h("Blob")
      , E = h("FileList")
      , x = h("URLSearchParams");
    function L(t, e, {allOwnKeys: i=!1}={}) {
        if (null == t)
            return;
        let s, n;
        if ("object" != typeof t && (t = [t]),
        u(t))
            for (s = 0,
            n = t.length; s < n; s++)
                e.call(null, t[s], s, t);
        else {
            const n = i ? Object.getOwnPropertyNames(t) : Object.keys(t)
              , r = n.length;
            let o;
            for (s = 0; s < r; s++)
                o = n[s],
                e.call(null, t[o], o, t)
        }
    }
    function O(t, e) {
        e = e.toLowerCase();
        const i = Object.keys(t);
        let s, n = i.length;
        for (; n-- > 0; )
            if (s = i[n],
            e === s.toLowerCase())
                return s;
        return null
    }
    const P = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : "undefined" != typeof window ? window : global
      , C = t => !p(t) && t !== P;
    const A = (M = "undefined" != typeof Uint8Array && l(Uint8Array),
    t => M && t instanceof M);
    var M;
    const T = h("HTMLFormElement")
      , I = ( ({hasOwnProperty: t}) => (e, i) => t.call(e, i))(Object.prototype)
      , D = h("RegExp")
      , k = (t, e) => {
        const i = Object.getOwnPropertyDescriptors(t)
          , s = {};
        L(i, ( (i, n) => {
            let r;
            !1 !== (r = e(i, n, t)) && (s[n] = r || i)
        }
        )),
        Object.defineProperties(t, s)
    }
      , z = "abcdefghijklmnopqrstuvwxyz"
      , F = "0123456789"
      , N = {
        DIGIT: F,
        ALPHA: z,
        ALPHA_DIGIT: z + z.toUpperCase() + F
    };
    const R = h("AsyncFunction");
    var Y = {
        isArray: u,
        isArrayBuffer: m,
        isBuffer: function(t) {
            return null !== t && !p(t) && null !== t.constructor && !p(t.constructor) && g(t.constructor.isBuffer) && t.constructor.isBuffer(t)
        },
        isFormData: t => {
            let e;
            return t && ("function" == typeof FormData && t instanceof FormData || g(t.append) && ("formdata" === (e = c(t)) || "object" === e && g(t.toString) && "[object FormData]" === t.toString()))
        }
        ,
        isArrayBufferView: function(t) {
            let e;
            return e = "undefined" != typeof ArrayBuffer && ArrayBuffer.isView ? ArrayBuffer.isView(t) : t && t.buffer && m(t.buffer),
            e
        },
        isString: f,
        isNumber: v,
        isBoolean: t => !0 === t || !1 === t,
        isObject: y,
        isPlainObject: _,
        isUndefined: p,
        isDate: b,
        isFile: w,
        isBlob: S,
        isRegExp: D,
        isFunction: g,
        isStream: t => y(t) && g(t.pipe),
        isURLSearchParams: x,
        isTypedArray: A,
        isFileList: E,
        forEach: L,
        merge: function t() {
            const {caseless: e} = C(this) && this || {}
              , i = {}
              , s = (s, n) => {
                const r = e && O(i, n) || n;
                _(i[r]) && _(s) ? i[r] = t(i[r], s) : _(s) ? i[r] = t({}, s) : u(s) ? i[r] = s.slice() : i[r] = s
            }
            ;
            for (let t = 0, e = arguments.length; t < e; t++)
                arguments[t] && L(arguments[t], s);
            return i
        },
        extend: (t, e, i, {allOwnKeys: s}={}) => (L(e, ( (e, s) => {
            i && g(e) ? t[s] = o(e, i) : t[s] = e
        }
        ), {
            allOwnKeys: s
        }),
        t),
        trim: t => t.trim ? t.trim() : t.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, ""),
        stripBOM: t => (65279 === t.charCodeAt(0) && (t = t.slice(1)),
        t),
        inherits: (t, e, i, s) => {
            t.prototype = Object.create(e.prototype, s),
            t.prototype.constructor = t,
            Object.defineProperty(t, "super", {
                value: e.prototype
            }),
            i && Object.assign(t.prototype, i)
        }
        ,
        toFlatObject: (t, e, i, s) => {
            let n, r, o;
            const a = {};
            if (e = e || {},
            null == t)
                return e;
            do {
                for (n = Object.getOwnPropertyNames(t),
                r = n.length; r-- > 0; )
                    o = n[r],
                    s && !s(o, t, e) || a[o] || (e[o] = t[o],
                    a[o] = !0);
                t = !1 !== i && l(t)
            } while (t && (!i || i(t, e)) && t !== Object.prototype);
            return e
        }
        ,
        kindOf: c,
        kindOfTest: h,
        endsWith: (t, e, i) => {
            t = String(t),
            (void 0 === i || i > t.length) && (i = t.length),
            i -= e.length;
            const s = t.indexOf(e, i);
            return -1 !== s && s === i
        }
        ,
        toArray: t => {
            if (!t)
                return null;
            if (u(t))
                return t;
            let e = t.length;
            if (!v(e))
                return null;
            const i = new Array(e);
            for (; e-- > 0; )
                i[e] = t[e];
            return i
        }
        ,
        forEachEntry: (t, e) => {
            const i = (t && t[Symbol.iterator]).call(t);
            let s;
            for (; (s = i.next()) && !s.done; ) {
                const i = s.value;
                e.call(t, i[0], i[1])
            }
        }
        ,
        matchAll: (t, e) => {
            let i;
            const s = [];
            for (; null !== (i = t.exec(e)); )
                s.push(i);
            return s
        }
        ,
        isHTMLForm: T,
        hasOwnProperty: I,
        hasOwnProp: I,
        reduceDescriptors: k,
        freezeMethods: t => {
            k(t, ( (e, i) => {
                if (g(t) && -1 !== ["arguments", "caller", "callee"].indexOf(i))
                    return !1;
                const s = t[i];
                g(s) && (e.enumerable = !1,
                "writable"in e ? e.writable = !1 : e.set || (e.set = () => {
                    throw Error("Can not rewrite read-only method '" + i + "'")
                }
                ))
            }
            ))
        }
        ,
        toObjectSet: (t, e) => {
            const i = {}
              , s = t => {
                t.forEach((t => {
                    i[t] = !0
                }
                ))
            }
            ;
            return u(t) ? s(t) : s(String(t).split(e)),
            i
        }
        ,
        toCamelCase: t => t.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, (function(t, e, i) {
            return e.toUpperCase() + i
        }
        )),
        noop: () => {}
        ,
        toFiniteNumber: (t, e) => (t = +t,
        Number.isFinite(t) ? t : e),
        findKey: O,
        global: P,
        isContextDefined: C,
        ALPHABET: N,
        generateString: (t=16, e=N.ALPHA_DIGIT) => {
            let i = "";
            const {length: s} = e;
            for (; t--; )
                i += e[Math.random() * s | 0];
            return i
        }
        ,
        isSpecCompliantForm: function(t) {
            return !!(t && g(t.append) && "FormData" === t[Symbol.toStringTag] && t[Symbol.iterator])
        },
        toJSONObject: t => {
            const e = new Array(10)
              , i = (t, s) => {
                if (y(t)) {
                    if (e.indexOf(t) >= 0)
                        return;
                    if (!("toJSON"in t)) {
                        e[s] = t;
                        const n = u(t) ? [] : {};
                        return L(t, ( (t, e) => {
                            const r = i(t, s + 1);
                            !p(r) && (n[e] = r)
                        }
                        )),
                        e[s] = void 0,
                        n
                    }
                }
                return t
            }
            ;
            return i(t, 0)
        }
        ,
        isAsyncFn: R,
        isThenable: t => t && (y(t) || g(t)) && g(t.then) && g(t.catch)
    };
    function j(t, e, i, s, n) {
        Error.call(this),
        Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = (new Error).stack,
        this.message = t,
        this.name = "AxiosError",
        e && (this.code = e),
        i && (this.config = i),
        s && (this.request = s),
        n && (this.response = n)
    }
    Y.inherits(j, Error, {
        toJSON: function() {
            return {
                message: this.message,
                name: this.name,
                description: this.description,
                number: this.number,
                fileName: this.fileName,
                lineNumber: this.lineNumber,
                columnNumber: this.columnNumber,
                stack: this.stack,
                config: Y.toJSONObject(this.config),
                code: this.code,
                status: this.response && this.response.status ? this.response.status : null
            }
        }
    });
    const H = j.prototype
      , $ = {};
    ["ERR_BAD_OPTION_VALUE", "ERR_BAD_OPTION", "ECONNABORTED", "ETIMEDOUT", "ERR_NETWORK", "ERR_FR_TOO_MANY_REDIRECTS", "ERR_DEPRECATED", "ERR_BAD_RESPONSE", "ERR_BAD_REQUEST", "ERR_CANCELED", "ERR_NOT_SUPPORT", "ERR_INVALID_URL"].forEach((t => {
        $[t] = {
            value: t
        }
    }
    )),
    Object.defineProperties(j, $),
    Object.defineProperty(H, "isAxiosError", {
        value: !0
    }),
    j.from = (t, e, i, s, n, r) => {
        const o = Object.create(H);
        return Y.toFlatObject(t, o, (function(t) {
            return t !== Error.prototype
        }
        ), (t => "isAxiosError" !== t)),
        j.call(o, t.message, e, i, s, n),
        o.cause = t,
        o.name = t.name,
        r && Object.assign(o, r),
        o
    }
    ;
    function B(t) {
        return Y.isPlainObject(t) || Y.isArray(t)
    }
    function Z(t) {
        return Y.endsWith(t, "[]") ? t.slice(0, -2) : t
    }
    function V(t, e, i) {
        return t ? t.concat(e).map((function(t, e) {
            return t = Z(t),
            !i && e ? "[" + t + "]" : t
        }
        )).join(i ? "." : "") : e
    }
    const q = Y.toFlatObject(Y, {}, null, (function(t) {
        return /^is[A-Z]/.test(t)
    }
    ));
    function U(t, e, i) {
        if (!Y.isObject(t))
            throw new TypeError("target must be an object");
        e = e || new FormData;
        const s = (i = Y.toFlatObject(i, {
            metaTokens: !0,
            dots: !1,
            indexes: !1
        }, !1, (function(t, e) {
            return !Y.isUndefined(e[t])
        }
        ))).metaTokens
          , n = i.visitor || c
          , r = i.dots
          , o = i.indexes
          , a = (i.Blob || "undefined" != typeof Blob && Blob) && Y.isSpecCompliantForm(e);
        if (!Y.isFunction(n))
            throw new TypeError("visitor must be a function");
        function l(t) {
            if (null === t)
                return "";
            if (Y.isDate(t))
                return t.toISOString();
            if (!a && Y.isBlob(t))
                throw new j("Blob is not supported. Use a Buffer instead.");
            return Y.isArrayBuffer(t) || Y.isTypedArray(t) ? a && "function" == typeof Blob ? new Blob([t]) : Buffer.from(t) : t
        }
        function c(t, i, n) {
            let a = t;
            if (t && !n && "object" == typeof t)
                if (Y.endsWith(i, "{}"))
                    i = s ? i : i.slice(0, -2),
                    t = JSON.stringify(t);
                else if (Y.isArray(t) && function(t) {
                    return Y.isArray(t) && !t.some(B)
                }(t) || (Y.isFileList(t) || Y.endsWith(i, "[]")) && (a = Y.toArray(t)))
                    return i = Z(i),
                    a.forEach((function(t, s) {
                        !Y.isUndefined(t) && null !== t && e.append(!0 === o ? V([i], s, r) : null === o ? i : i + "[]", l(t))
                    }
                    )),
                    !1;
            return !!B(t) || (e.append(V(n, i, r), l(t)),
            !1)
        }
        const h = []
          , d = Object.assign(q, {
            defaultVisitor: c,
            convertValue: l,
            isVisitable: B
        });
        if (!Y.isObject(t))
            throw new TypeError("data must be an object");
        return function t(i, s) {
            if (!Y.isUndefined(i)) {
                if (-1 !== h.indexOf(i))
                    throw Error("Circular reference detected in " + s.join("."));
                h.push(i),
                Y.forEach(i, (function(i, r) {
                    !0 === (!(Y.isUndefined(i) || null === i) && n.call(e, i, Y.isString(r) ? r.trim() : r, s, d)) && t(i, s ? s.concat(r) : [r])
                }
                )),
                h.pop()
            }
        }(t),
        e
    }
    function W(t) {
        const e = {
            "!": "%21",
            "'": "%27",
            "(": "%28",
            ")": "%29",
            "~": "%7E",
            "%20": "+",
            "%00": "\0"
        };
        return encodeURIComponent(t).replace(/[!'()~]|%20|%00/g, (function(t) {
            return e[t]
        }
        ))
    }
    function X(t, e) {
        this._pairs = [],
        t && U(t, this, e)
    }
    const G = X.prototype;
    function J(t) {
        return encodeURIComponent(t).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]")
    }
    function K(t, e, i) {
        if (!e)
            return t;
        const s = i && i.encode || J
          , n = i && i.serialize;
        let r;
        if (r = n ? n(e, i) : Y.isURLSearchParams(e) ? e.toString() : new X(e,i).toString(s),
        r) {
            const e = t.indexOf("#");
            -1 !== e && (t = t.slice(0, e)),
            t += (-1 === t.indexOf("?") ? "?" : "&") + r
        }
        return t
    }
    G.append = function(t, e) {
        this._pairs.push([t, e])
    }
    ,
    G.toString = function(t) {
        const e = t ? function(e) {
            return t.call(this, e, W)
        }
        : W;
        return this._pairs.map((function(t) {
            return e(t[0]) + "=" + e(t[1])
        }
        ), "").join("&")
    }
    ;
    class Q {
        constructor() {
            this.handlers = []
        }
        use(t, e, i) {
            return this.handlers.push({
                fulfilled: t,
                rejected: e,
                synchronous: !!i && i.synchronous,
                runWhen: i ? i.runWhen : null
            }),
            this.handlers.length - 1
        }
        eject(t) {
            this.handlers[t] && (this.handlers[t] = null)
        }
        clear() {
            this.handlers && (this.handlers = [])
        }
        forEach(t) {
            Y.forEach(this.handlers, (function(e) {
                null !== e && t(e)
            }
            ))
        }
    }
    var tt = {
        silentJSONParsing: !0,
        forcedJSONParsing: !0,
        clarifyTimeoutError: !1
    }
      , et = {
        isBrowser: !0,
        classes: {
            URLSearchParams: "undefined" != typeof URLSearchParams ? URLSearchParams : X,
            FormData: "undefined" != typeof FormData ? FormData : null,
            Blob: "undefined" != typeof Blob ? Blob : null
        },
        protocols: ["http", "https", "file", "blob", "url", "data"]
    };
    const it = "undefined" != typeof window && "undefined" != typeof document
      , st = (nt = "undefined" != typeof navigator && navigator.product,
    it && ["ReactNative", "NativeScript", "NS"].indexOf(nt) < 0);
    var nt;
    const rt = "undefined" != typeof WorkerGlobalScope && self instanceof WorkerGlobalScope && "function" == typeof self.importScripts;
    var ot = {
        ...Object.freeze({
            __proto__: null,
            hasBrowserEnv: it,
            hasStandardBrowserEnv: st,
            hasStandardBrowserWebWorkerEnv: rt
        }),
        ...et
    };
    function at(t) {
        function e(t, i, s, n) {
            let r = t[n++];
            if ("__proto__" === r)
                return !0;
            const o = Number.isFinite(+r)
              , a = n >= t.length;
            if (r = !r && Y.isArray(s) ? s.length : r,
            a)
                return Y.hasOwnProp(s, r) ? s[r] = [s[r], i] : s[r] = i,
                !o;
            s[r] && Y.isObject(s[r]) || (s[r] = []);
            return e(t, i, s[r], n) && Y.isArray(s[r]) && (s[r] = function(t) {
                const e = {}
                  , i = Object.keys(t);
                let s;
                const n = i.length;
                let r;
                for (s = 0; s < n; s++)
                    r = i[s],
                    e[r] = t[r];
                return e
            }(s[r])),
            !o
        }
        if (Y.isFormData(t) && Y.isFunction(t.entries)) {
            const i = {};
            return Y.forEachEntry(t, ( (t, s) => {
                e(function(t) {
                    return Y.matchAll(/\w+|\[(\w*)]/g, t).map((t => "[]" === t[0] ? "" : t[1] || t[0]))
                }(t), s, i, 0)
            }
            )),
            i
        }
        return null
    }
    const lt = {
        transitional: tt,
        adapter: ["xhr", "http"],
        transformRequest: [function(t, e) {
            const i = e.getContentType() || ""
              , s = i.indexOf("application/json") > -1
              , n = Y.isObject(t);
            n && Y.isHTMLForm(t) && (t = new FormData(t));
            if (Y.isFormData(t))
                return s ? JSON.stringify(at(t)) : t;
            if (Y.isArrayBuffer(t) || Y.isBuffer(t) || Y.isStream(t) || Y.isFile(t) || Y.isBlob(t))
                return t;
            if (Y.isArrayBufferView(t))
                return t.buffer;
            if (Y.isURLSearchParams(t))
                return e.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1),
                t.toString();
            let r;
            if (n) {
                if (i.indexOf("application/x-www-form-urlencoded") > -1)
                    return function(t, e) {
                        return U(t, new ot.classes.URLSearchParams, Object.assign({
                            visitor: function(t, e, i, s) {
                                return ot.isNode && Y.isBuffer(t) ? (this.append(e, t.toString("base64")),
                                !1) : s.defaultVisitor.apply(this, arguments)
                            }
                        }, e))
                    }(t, this.formSerializer).toString();
                if ((r = Y.isFileList(t)) || i.indexOf("multipart/form-data") > -1) {
                    const e = this.env && this.env.FormData;
                    return U(r ? {
                        "files[]": t
                    } : t, e && new e, this.formSerializer)
                }
            }
            return n || s ? (e.setContentType("application/json", !1),
            function(t, e, i) {
                if (Y.isString(t))
                    try {
                        return (e || JSON.parse)(t),
                        Y.trim(t)
                    } catch (t) {
                        if ("SyntaxError" !== t.name)
                            throw t
                    }
                return (0,
                JSON.stringify)(t)
            }(t)) : t
        }
        ],
        transformResponse: [function(t) {
            const e = this.transitional || lt.transitional
              , i = e && e.forcedJSONParsing
              , s = "json" === this.responseType;
            if (t && Y.isString(t) && (i && !this.responseType || s)) {
                const i = !(e && e.silentJSONParsing) && s;
                try {
                    return JSON.parse(t)
                } catch (t) {
                    if (i) {
                        if ("SyntaxError" === t.name)
                            throw j.from(t, j.ERR_BAD_RESPONSE, this, null, this.response);
                        throw t
                    }
                }
            }
            return t
        }
        ],
        timeout: 0,
        xsrfCookieName: "XSRF-TOKEN",
        xsrfHeaderName: "X-XSRF-TOKEN",
        maxContentLength: -1,
        maxBodyLength: -1,
        env: {
            FormData: ot.classes.FormData,
            Blob: ot.classes.Blob
        },
        validateStatus: function(t) {
            return t >= 200 && t < 300
        },
        headers: {
            common: {
                Accept: "application/json, text/plain, */*",
                "Content-Type": void 0
            }
        }
    };
    Y.forEach(["delete", "get", "head", "post", "put", "patch"], (t => {
        lt.headers[t] = {}
    }
    ));
    const ct = Y.toObjectSet(["age", "authorization", "content-length", "content-type", "etag", "expires", "from", "host", "if-modified-since", "if-unmodified-since", "last-modified", "location", "max-forwards", "proxy-authorization", "referer", "retry-after", "user-agent"]);
    const ht = Symbol("internals");
    function dt(t) {
        return t && String(t).trim().toLowerCase()
    }
    function ut(t) {
        return !1 === t || null == t ? t : Y.isArray(t) ? t.map(ut) : String(t)
    }
    function pt(t, e, i, s, n) {
        return Y.isFunction(s) ? s.call(this, e, i) : (n && (e = i),
        Y.isString(e) ? Y.isString(s) ? -1 !== e.indexOf(s) : Y.isRegExp(s) ? s.test(e) : void 0 : void 0)
    }
    class mt {
        constructor(t) {
            t && this.set(t)
        }
        set(t, e, i) {
            const s = this;
            function n(t, e, i) {
                const n = dt(e);
                if (!n)
                    throw new Error("header name must be a non-empty string");
                const r = Y.findKey(s, n);
                (!r || void 0 === s[r] || !0 === i || void 0 === i && !1 !== s[r]) && (s[r || e] = ut(t))
            }
            const r = (t, e) => Y.forEach(t, ( (t, i) => n(t, i, e)));
            return Y.isPlainObject(t) || t instanceof this.constructor ? r(t, e) : Y.isString(t) && (t = t.trim()) && !/^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(t.trim()) ? r((t => {
                const e = {};
                let i, s, n;
                return t && t.split("\n").forEach((function(t) {
                    n = t.indexOf(":"),
                    i = t.substring(0, n).trim().toLowerCase(),
                    s = t.substring(n + 1).trim(),
                    !i || e[i] && ct[i] || ("set-cookie" === i ? e[i] ? e[i].push(s) : e[i] = [s] : e[i] = e[i] ? e[i] + ", " + s : s)
                }
                )),
                e
            }
            )(t), e) : null != t && n(e, t, i),
            this
        }
        get(t, e) {
            if (t = dt(t)) {
                const i = Y.findKey(this, t);
                if (i) {
                    const t = this[i];
                    if (!e)
                        return t;
                    if (!0 === e)
                        return function(t) {
                            const e = Object.create(null)
                              , i = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
                            let s;
                            for (; s = i.exec(t); )
                                e[s[1]] = s[2];
                            return e
                        }(t);
                    if (Y.isFunction(e))
                        return e.call(this, t, i);
                    if (Y.isRegExp(e))
                        return e.exec(t);
                    throw new TypeError("parser must be boolean|regexp|function")
                }
            }
        }
        has(t, e) {
            if (t = dt(t)) {
                const i = Y.findKey(this, t);
                return !(!i || void 0 === this[i] || e && !pt(0, this[i], i, e))
            }
            return !1
        }
        delete(t, e) {
            const i = this;
            let s = !1;
            function n(t) {
                if (t = dt(t)) {
                    const n = Y.findKey(i, t);
                    !n || e && !pt(0, i[n], n, e) || (delete i[n],
                    s = !0)
                }
            }
            return Y.isArray(t) ? t.forEach(n) : n(t),
            s
        }
        clear(t) {
            const e = Object.keys(this);
            let i = e.length
              , s = !1;
            for (; i--; ) {
                const n = e[i];
                t && !pt(0, this[n], n, t, !0) || (delete this[n],
                s = !0)
            }
            return s
        }
        normalize(t) {
            const e = this
              , i = {};
            return Y.forEach(this, ( (s, n) => {
                const r = Y.findKey(i, n);
                if (r)
                    return e[r] = ut(s),
                    void delete e[n];
                const o = t ? function(t) {
                    return t.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, ( (t, e, i) => e.toUpperCase() + i))
                }(n) : String(n).trim();
                o !== n && delete e[n],
                e[o] = ut(s),
                i[o] = !0
            }
            )),
            this
        }
        concat(...t) {
            return this.constructor.concat(this, ...t)
        }
        toJSON(t) {
            const e = Object.create(null);
            return Y.forEach(this, ( (i, s) => {
                null != i && !1 !== i && (e[s] = t && Y.isArray(i) ? i.join(", ") : i)
            }
            )),
            e
        }
        [Symbol.iterator]() {
            return Object.entries(this.toJSON())[Symbol.iterator]()
        }
        toString() {
            return Object.entries(this.toJSON()).map(( ([t,e]) => t + ": " + e)).join("\n")
        }
        get[Symbol.toStringTag]() {
            return "AxiosHeaders"
        }
        static from(t) {
            return t instanceof this ? t : new this(t)
        }
        static concat(t, ...e) {
            const i = new this(t);
            return e.forEach((t => i.set(t))),
            i
        }
        static accessor(t) {
            const e = (this[ht] = this[ht] = {
                accessors: {}
            }).accessors
              , i = this.prototype;
            function s(t) {
                const s = dt(t);
                e[s] || (!function(t, e) {
                    const i = Y.toCamelCase(" " + e);
                    ["get", "set", "has"].forEach((s => {
                        Object.defineProperty(t, s + i, {
                            value: function(t, i, n) {
                                return this[s].call(this, e, t, i, n)
                            },
                            configurable: !0
                        })
                    }
                    ))
                }(i, t),
                e[s] = !0)
            }
            return Y.isArray(t) ? t.forEach(s) : s(t),
            this
        }
    }
    function ft(t, e) {
        const i = this || lt
          , s = e || i
          , n = mt.from(s.headers);
        let r = s.data;
        return Y.forEach(t, (function(t) {
            r = t.call(i, r, n.normalize(), e ? e.status : void 0)
        }
        )),
        n.normalize(),
        r
    }
    function gt(t) {
        return !(!t || !t.__CANCEL__)
    }
    function vt(t, e, i) {
        j.call(this, null == t ? "canceled" : t, j.ERR_CANCELED, e, i),
        this.name = "CanceledError"
    }
    mt.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]),
    Y.reduceDescriptors(mt.prototype, ( ({value: t}, e) => {
        let i = e[0].toUpperCase() + e.slice(1);
        return {
            get: () => t,
            set(t) {
                this[i] = t
            }
        }
    }
    )),
    Y.freezeMethods(mt),
    Y.inherits(vt, j, {
        __CANCEL__: !0
    });
    var yt = ot.hasStandardBrowserEnv ? {
        write(t, e, i, s, n, r) {
            const o = [t + "=" + encodeURIComponent(e)];
            Y.isNumber(i) && o.push("expires=" + new Date(i).toGMTString()),
            Y.isString(s) && o.push("path=" + s),
            Y.isString(n) && o.push("domain=" + n),
            !0 === r && o.push("secure"),
            document.cookie = o.join("; ")
        },
        read(t) {
            const e = document.cookie.match(new RegExp("(^|;\\s*)(" + t + ")=([^;]*)"));
            return e ? decodeURIComponent(e[3]) : null
        },
        remove(t) {
            this.write(t, "", Date.now() - 864e5)
        }
    } : {
        write() {},
        read: () => null,
        remove() {}
    };
    function _t(t, e) {
        return t && !/^([a-z][a-z\d+\-.]*:)?\/\//i.test(e) ? function(t, e) {
            return e ? t.replace(/\/?\/$/, "") + "/" + e.replace(/^\/+/, "") : t
        }(t, e) : e
    }
    var bt = ot.hasStandardBrowserEnv ? function() {
        const t = /(msie|trident)/i.test(navigator.userAgent)
          , e = document.createElement("a");
        let i;
        function s(i) {
            let s = i;
            return t && (e.setAttribute("href", s),
            s = e.href),
            e.setAttribute("href", s),
            {
                href: e.href,
                protocol: e.protocol ? e.protocol.replace(/:$/, "") : "",
                host: e.host,
                search: e.search ? e.search.replace(/^\?/, "") : "",
                hash: e.hash ? e.hash.replace(/^#/, "") : "",
                hostname: e.hostname,
                port: e.port,
                pathname: "/" === e.pathname.charAt(0) ? e.pathname : "/" + e.pathname
            }
        }
        return i = s(window.location.href),
        function(t) {
            const e = Y.isString(t) ? s(t) : t;
            return e.protocol === i.protocol && e.host === i.host
        }
    }() : function() {
        return !0
    }
    ;
    function wt(t, e) {
        let i = 0;
        const s = function(t, e) {
            t = t || 10;
            const i = new Array(t)
              , s = new Array(t);
            let n, r = 0, o = 0;
            return e = void 0 !== e ? e : 1e3,
            function(a) {
                const l = Date.now()
                  , c = s[o];
                n || (n = l),
                i[r] = a,
                s[r] = l;
                let h = o
                  , d = 0;
                for (; h !== r; )
                    d += i[h++],
                    h %= t;
                if (r = (r + 1) % t,
                r === o && (o = (o + 1) % t),
                l - n < e)
                    return;
                const u = c && l - c;
                return u ? Math.round(1e3 * d / u) : void 0
            }
        }(50, 250);
        return n => {
            const r = n.loaded
              , o = n.lengthComputable ? n.total : void 0
              , a = r - i
              , l = s(a);
            i = r;
            const c = {
                loaded: r,
                total: o,
                progress: o ? r / o : void 0,
                bytes: a,
                rate: l || void 0,
                estimated: l && o && r <= o ? (o - r) / l : void 0,
                event: n
            };
            c[e ? "download" : "upload"] = !0,
            t(c)
        }
    }
    const St = {
        http: null,
        xhr: "undefined" != typeof XMLHttpRequest && function(t) {
            return new Promise((function(e, i) {
                let s = t.data;
                const n = mt.from(t.headers).normalize();
                let r, o, {responseType: a, withXSRFToken: l} = t;
                function c() {
                    t.cancelToken && t.cancelToken.unsubscribe(r),
                    t.signal && t.signal.removeEventListener("abort", r)
                }
                if (Y.isFormData(s))
                    if (ot.hasStandardBrowserEnv || ot.hasStandardBrowserWebWorkerEnv)
                        n.setContentType(!1);
                    else if (!1 !== (o = n.getContentType())) {
                        const [t,...e] = o ? o.split(";").map((t => t.trim())).filter(Boolean) : [];
                        n.setContentType([t || "multipart/form-data", ...e].join("; "))
                    }
                let h = new XMLHttpRequest;
                if (t.auth) {
                    const e = t.auth.username || ""
                      , i = t.auth.password ? unescape(encodeURIComponent(t.auth.password)) : "";
                    n.set("Authorization", "Basic " + btoa(e + ":" + i))
                }
                const d = _t(t.baseURL, t.url);
                function u() {
                    if (!h)
                        return;
                    const s = mt.from("getAllResponseHeaders"in h && h.getAllResponseHeaders());
                    !function(t, e, i) {
                        const s = i.config.validateStatus;
                        i.status && s && !s(i.status) ? e(new j("Request failed with status code " + i.status,[j.ERR_BAD_REQUEST, j.ERR_BAD_RESPONSE][Math.floor(i.status / 100) - 4],i.config,i.request,i)) : t(i)
                    }((function(t) {
                        e(t),
                        c()
                    }
                    ), (function(t) {
                        i(t),
                        c()
                    }
                    ), {
                        data: a && "text" !== a && "json" !== a ? h.response : h.responseText,
                        status: h.status,
                        statusText: h.statusText,
                        headers: s,
                        config: t,
                        request: h
                    }),
                    h = null
                }
                if (h.open(t.method.toUpperCase(), K(d, t.params, t.paramsSerializer), !0),
                h.timeout = t.timeout,
                "onloadend"in h ? h.onloadend = u : h.onreadystatechange = function() {
                    h && 4 === h.readyState && (0 !== h.status || h.responseURL && 0 === h.responseURL.indexOf("file:")) && setTimeout(u)
                }
                ,
                h.onabort = function() {
                    h && (i(new j("Request aborted",j.ECONNABORTED,t,h)),
                    h = null)
                }
                ,
                h.onerror = function() {
                    i(new j("Network Error",j.ERR_NETWORK,t,h)),
                    h = null
                }
                ,
                h.ontimeout = function() {
                    let e = t.timeout ? "timeout of " + t.timeout + "ms exceeded" : "timeout exceeded";
                    const s = t.transitional || tt;
                    t.timeoutErrorMessage && (e = t.timeoutErrorMessage),
                    i(new j(e,s.clarifyTimeoutError ? j.ETIMEDOUT : j.ECONNABORTED,t,h)),
                    h = null
                }
                ,
                ot.hasStandardBrowserEnv && (l && Y.isFunction(l) && (l = l(t)),
                l || !1 !== l && bt(d))) {
                    const e = t.xsrfHeaderName && t.xsrfCookieName && yt.read(t.xsrfCookieName);
                    e && n.set(t.xsrfHeaderName, e)
                }
                void 0 === s && n.setContentType(null),
                "setRequestHeader"in h && Y.forEach(n.toJSON(), (function(t, e) {
                    h.setRequestHeader(e, t)
                }
                )),
                Y.isUndefined(t.withCredentials) || (h.withCredentials = !!t.withCredentials),
                a && "json" !== a && (h.responseType = t.responseType),
                "function" == typeof t.onDownloadProgress && h.addEventListener("progress", wt(t.onDownloadProgress, !0)),
                "function" == typeof t.onUploadProgress && h.upload && h.upload.addEventListener("progress", wt(t.onUploadProgress)),
                (t.cancelToken || t.signal) && (r = e => {
                    h && (i(!e || e.type ? new vt(null,t,h) : e),
                    h.abort(),
                    h = null)
                }
                ,
                t.cancelToken && t.cancelToken.subscribe(r),
                t.signal && (t.signal.aborted ? r() : t.signal.addEventListener("abort", r)));
                const p = function(t) {
                    const e = /^([-+\w]{1,25})(:?\/\/|:)/.exec(t);
                    return e && e[1] || ""
                }(d);
                p && -1 === ot.protocols.indexOf(p) ? i(new j("Unsupported protocol " + p + ":",j.ERR_BAD_REQUEST,t)) : h.send(s || null)
            }
            ))
        }
    };
    Y.forEach(St, ( (t, e) => {
        if (t) {
            try {
                Object.defineProperty(t, "name", {
                    value: e
                })
            } catch (t) {}
            Object.defineProperty(t, "adapterName", {
                value: e
            })
        }
    }
    ));
    const Et = t => `- ${t}`
      , xt = t => Y.isFunction(t) || null === t || !1 === t;
    var Lt = t => {
        t = Y.isArray(t) ? t : [t];
        const {length: e} = t;
        let i, s;
        const n = {};
        for (let r = 0; r < e; r++) {
            let e;
            if (i = t[r],
            s = i,
            !xt(i) && (s = St[(e = String(i)).toLowerCase()],
            void 0 === s))
                throw new j(`Unknown adapter '${e}'`);
            if (s)
                break;
            n[e || "#" + r] = s
        }
        if (!s) {
            const t = Object.entries(n).map(( ([t,e]) => `adapter ${t} ` + (!1 === e ? "is not supported by the environment" : "is not available in the build")));
            throw new j("There is no suitable adapter to dispatch the request " + (e ? t.length > 1 ? "since :\n" + t.map(Et).join("\n") : " " + Et(t[0]) : "as no adapter specified"),"ERR_NOT_SUPPORT")
        }
        return s
    }
    ;
    function Ot(t) {
        if (t.cancelToken && t.cancelToken.throwIfRequested(),
        t.signal && t.signal.aborted)
            throw new vt(null,t)
    }
    function Pt(t) {
        Ot(t),
        t.headers = mt.from(t.headers),
        t.data = ft.call(t, t.transformRequest),
        -1 !== ["post", "put", "patch"].indexOf(t.method) && t.headers.setContentType("application/x-www-form-urlencoded", !1);
        return Lt(t.adapter || lt.adapter)(t).then((function(e) {
            return Ot(t),
            e.data = ft.call(t, t.transformResponse, e),
            e.headers = mt.from(e.headers),
            e
        }
        ), (function(e) {
            return gt(e) || (Ot(t),
            e && e.response && (e.response.data = ft.call(t, t.transformResponse, e.response),
            e.response.headers = mt.from(e.response.headers))),
            Promise.reject(e)
        }
        ))
    }
    const Ct = t => t instanceof mt ? {
        ...t
    } : t;
    function At(t, e) {
        e = e || {};
        const i = {};
        function s(t, e, i) {
            return Y.isPlainObject(t) && Y.isPlainObject(e) ? Y.merge.call({
                caseless: i
            }, t, e) : Y.isPlainObject(e) ? Y.merge({}, e) : Y.isArray(e) ? e.slice() : e
        }
        function n(t, e, i) {
            return Y.isUndefined(e) ? Y.isUndefined(t) ? void 0 : s(void 0, t, i) : s(t, e, i)
        }
        function r(t, e) {
            if (!Y.isUndefined(e))
                return s(void 0, e)
        }
        function o(t, e) {
            return Y.isUndefined(e) ? Y.isUndefined(t) ? void 0 : s(void 0, t) : s(void 0, e)
        }
        function a(i, n, r) {
            return r in e ? s(i, n) : r in t ? s(void 0, i) : void 0
        }
        const l = {
            url: r,
            method: r,
            data: r,
            baseURL: o,
            transformRequest: o,
            transformResponse: o,
            paramsSerializer: o,
            timeout: o,
            timeoutMessage: o,
            withCredentials: o,
            withXSRFToken: o,
            adapter: o,
            responseType: o,
            xsrfCookieName: o,
            xsrfHeaderName: o,
            onUploadProgress: o,
            onDownloadProgress: o,
            decompress: o,
            maxContentLength: o,
            maxBodyLength: o,
            beforeRedirect: o,
            transport: o,
            httpAgent: o,
            httpsAgent: o,
            cancelToken: o,
            socketPath: o,
            responseEncoding: o,
            validateStatus: a,
            headers: (t, e) => n(Ct(t), Ct(e), !0)
        };
        return Y.forEach(Object.keys(Object.assign({}, t, e)), (function(s) {
            const r = l[s] || n
              , o = r(t[s], e[s], s);
            Y.isUndefined(o) && r !== a || (i[s] = o)
        }
        )),
        i
    }
    const Mt = "1.6.8"
      , Tt = {};
    ["object", "boolean", "number", "function", "string", "symbol"].forEach(( (t, e) => {
        Tt[t] = function(i) {
            return typeof i === t || "a" + (e < 1 ? "n " : " ") + t
        }
    }
    ));
    const It = {};
    Tt.transitional = function(t, e, i) {
        function s(t, e) {
            return "[Axios v1.6.8] Transitional option '" + t + "'" + e + (i ? ". " + i : "")
        }
        return (i, n, r) => {
            if (!1 === t)
                throw new j(s(n, " has been removed" + (e ? " in " + e : "")),j.ERR_DEPRECATED);
            return e && !It[n] && (It[n] = !0,
            console.warn(s(n, " has been deprecated since v" + e + " and will be removed in the near future"))),
            !t || t(i, n, r)
        }
    }
    ;
    var Dt = {
        assertOptions: function(t, e, i) {
            if ("object" != typeof t)
                throw new j("options must be an object",j.ERR_BAD_OPTION_VALUE);
            const s = Object.keys(t);
            let n = s.length;
            for (; n-- > 0; ) {
                const r = s[n]
                  , o = e[r];
                if (o) {
                    const e = t[r]
                      , i = void 0 === e || o(e, r, t);
                    if (!0 !== i)
                        throw new j("option " + r + " must be " + i,j.ERR_BAD_OPTION_VALUE)
                } else if (!0 !== i)
                    throw new j("Unknown option " + r,j.ERR_BAD_OPTION)
            }
        },
        validators: Tt
    };
    const kt = Dt.validators;
    class zt {
        constructor(t) {
            this.defaults = t,
            this.interceptors = {
                request: new Q,
                response: new Q
            }
        }
        async request(t, e) {
            try {
                return await this._request(t, e)
            } catch (t) {
                if (t instanceof Error) {
                    let e;
                    Error.captureStackTrace ? Error.captureStackTrace(e = {}) : e = new Error;
                    const i = e.stack ? e.stack.replace(/^.+\n/, "") : "";
                    t.stack ? i && !String(t.stack).endsWith(i.replace(/^.+\n.+\n/, "")) && (t.stack += "\n" + i) : t.stack = i
                }
                throw t
            }
        }
        _request(t, e) {
            "string" == typeof t ? (e = e || {}).url = t : e = t || {},
            e = At(this.defaults, e);
            const {transitional: i, paramsSerializer: s, headers: n} = e;
            void 0 !== i && Dt.assertOptions(i, {
                silentJSONParsing: kt.transitional(kt.boolean),
                forcedJSONParsing: kt.transitional(kt.boolean),
                clarifyTimeoutError: kt.transitional(kt.boolean)
            }, !1),
            null != s && (Y.isFunction(s) ? e.paramsSerializer = {
                serialize: s
            } : Dt.assertOptions(s, {
                encode: kt.function,
                serialize: kt.function
            }, !0)),
            e.method = (e.method || this.defaults.method || "get").toLowerCase();
            let r = n && Y.merge(n.common, n[e.method]);
            n && Y.forEach(["delete", "get", "head", "post", "put", "patch", "common"], (t => {
                delete n[t]
            }
            )),
            e.headers = mt.concat(r, n);
            const o = [];
            let a = !0;
            this.interceptors.request.forEach((function(t) {
                "function" == typeof t.runWhen && !1 === t.runWhen(e) || (a = a && t.synchronous,
                o.unshift(t.fulfilled, t.rejected))
            }
            ));
            const l = [];
            let c;
            this.interceptors.response.forEach((function(t) {
                l.push(t.fulfilled, t.rejected)
            }
            ));
            let h, d = 0;
            if (!a) {
                const t = [Pt.bind(this), void 0];
                for (t.unshift.apply(t, o),
                t.push.apply(t, l),
                h = t.length,
                c = Promise.resolve(e); d < h; )
                    c = c.then(t[d++], t[d++]);
                return c
            }
            h = o.length;
            let u = e;
            for (d = 0; d < h; ) {
                const t = o[d++]
                  , e = o[d++];
                try {
                    u = t(u)
                } catch (t) {
                    e.call(this, t);
                    break
                }
            }
            try {
                c = Pt.call(this, u)
            } catch (t) {
                return Promise.reject(t)
            }
            for (d = 0,
            h = l.length; d < h; )
                c = c.then(l[d++], l[d++]);
            return c
        }
        getUri(t) {
            return K(_t((t = At(this.defaults, t)).baseURL, t.url), t.params, t.paramsSerializer)
        }
    }
    Y.forEach(["delete", "get", "head", "options"], (function(t) {
        zt.prototype[t] = function(e, i) {
            return this.request(At(i || {}, {
                method: t,
                url: e,
                data: (i || {}).data
            }))
        }
    }
    )),
    Y.forEach(["post", "put", "patch"], (function(t) {
        function e(e) {
            return function(i, s, n) {
                return this.request(At(n || {}, {
                    method: t,
                    headers: e ? {
                        "Content-Type": "multipart/form-data"
                    } : {},
                    url: i,
                    data: s
                }))
            }
        }
        zt.prototype[t] = e(),
        zt.prototype[t + "Form"] = e(!0)
    }
    ));
    class Ft {
        constructor(t) {
            if ("function" != typeof t)
                throw new TypeError("executor must be a function.");
            let e;
            this.promise = new Promise((function(t) {
                e = t
            }
            ));
            const i = this;
            this.promise.then((t => {
                if (!i._listeners)
                    return;
                let e = i._listeners.length;
                for (; e-- > 0; )
                    i._listeners[e](t);
                i._listeners = null
            }
            )),
            this.promise.then = t => {
                let e;
                const s = new Promise((t => {
                    i.subscribe(t),
                    e = t
                }
                )).then(t);
                return s.cancel = function() {
                    i.unsubscribe(e)
                }
                ,
                s
            }
            ,
            t((function(t, s, n) {
                i.reason || (i.reason = new vt(t,s,n),
                e(i.reason))
            }
            ))
        }
        throwIfRequested() {
            if (this.reason)
                throw this.reason
        }
        subscribe(t) {
            this.reason ? t(this.reason) : this._listeners ? this._listeners.push(t) : this._listeners = [t]
        }
        unsubscribe(t) {
            if (!this._listeners)
                return;
            const e = this._listeners.indexOf(t);
            -1 !== e && this._listeners.splice(e, 1)
        }
        static source() {
            let t;
            return {
                token: new Ft((function(e) {
                    t = e
                }
                )),
                cancel: t
            }
        }
    }
    const Nt = {
        Continue: 100,
        SwitchingProtocols: 101,
        Processing: 102,
        EarlyHints: 103,
        Ok: 200,
        Created: 201,
        Accepted: 202,
        NonAuthoritativeInformation: 203,
        NoContent: 204,
        ResetContent: 205,
        PartialContent: 206,
        MultiStatus: 207,
        AlreadyReported: 208,
        ImUsed: 226,
        MultipleChoices: 300,
        MovedPermanently: 301,
        Found: 302,
        SeeOther: 303,
        NotModified: 304,
        UseProxy: 305,
        Unused: 306,
        TemporaryRedirect: 307,
        PermanentRedirect: 308,
        BadRequest: 400,
        Unauthorized: 401,
        PaymentRequired: 402,
        Forbidden: 403,
        NotFound: 404,
        MethodNotAllowed: 405,
        NotAcceptable: 406,
        ProxyAuthenticationRequired: 407,
        RequestTimeout: 408,
        Conflict: 409,
        Gone: 410,
        LengthRequired: 411,
        PreconditionFailed: 412,
        PayloadTooLarge: 413,
        UriTooLong: 414,
        UnsupportedMediaType: 415,
        RangeNotSatisfiable: 416,
        ExpectationFailed: 417,
        ImATeapot: 418,
        MisdirectedRequest: 421,
        UnprocessableEntity: 422,
        Locked: 423,
        FailedDependency: 424,
        TooEarly: 425,
        UpgradeRequired: 426,
        PreconditionRequired: 428,
        TooManyRequests: 429,
        RequestHeaderFieldsTooLarge: 431,
        UnavailableForLegalReasons: 451,
        InternalServerError: 500,
        NotImplemented: 501,
        BadGateway: 502,
        ServiceUnavailable: 503,
        GatewayTimeout: 504,
        HttpVersionNotSupported: 505,
        VariantAlsoNegotiates: 506,
        InsufficientStorage: 507,
        LoopDetected: 508,
        NotExtended: 510,
        NetworkAuthenticationRequired: 511
    };
    Object.entries(Nt).forEach(( ([t,e]) => {
        Nt[e] = t
    }
    ));
    const Rt = function t(e) {
        const i = new zt(e)
          , s = o(zt.prototype.request, i);
        return Y.extend(s, zt.prototype, i, {
            allOwnKeys: !0
        }),
        Y.extend(s, i, null, {
            allOwnKeys: !0
        }),
        s.create = function(i) {
            return t(At(e, i))
        }
        ,
        s
    }(lt);
    Rt.Axios = zt,
    Rt.CanceledError = vt,
    Rt.CancelToken = Ft,
    Rt.isCancel = gt,
    Rt.VERSION = Mt,
    Rt.toFormData = U,
    Rt.AxiosError = j,
    Rt.Cancel = Rt.CanceledError,
    Rt.all = function(t) {
        return Promise.all(t)
    }
    ,
    Rt.spread = function(t) {
        return function(e) {
            return t.apply(null, e)
        }
    }
    ,
    Rt.isAxiosError = function(t) {
        return Y.isObject(t) && !0 === t.isAxiosError
    }
    ,
    Rt.mergeConfig = At,
    Rt.AxiosHeaders = mt,
    Rt.formToJSON = t => at(Y.isHTMLForm(t) ? new FormData(t) : t),
    Rt.getAdapter = Lt,
    Rt.HttpStatusCode = Nt,
    Rt.default = Rt;
    class Yt {
        constructor(t) {
            this._canceled = !1,
            this.data = t
        }
        get type() {
            return this.constructor.type
        }
        get cancelable() {
            return this.constructor.cancelable
        }
        cancel() {
            this._canceled = !0
        }
        canceled() {
            return this._canceled
        }
        clone(t) {
            return new this.constructor({
                ...this.data,
                ...t
            })
        }
    }
    Yt.type = "event",
    Yt.cancelable = !1;
    class jt {
        constructor(t) {
            this.draggable = t
        }
        attach() {
            throw new Error("Not Implemented")
        }
        detach() {
            throw new Error("Not Implemented")
        }
    }
    const Ht = {
        mouse: 0,
        drag: 0,
        touch: 100
    };
    class $t {
        constructor(t=[], e={}) {
            this.containers = [...t],
            this.options = {
                ...e
            },
            this.dragging = !1,
            this.currentContainer = null,
            this.originalSource = null,
            this.startEvent = null,
            this.delay = function(t) {
                const e = {};
                if (void 0 === t)
                    return {
                        ...Ht
                    };
                if ("number" == typeof t) {
                    for (const i in Ht)
                        Object.prototype.hasOwnProperty.call(Ht, i) && (e[i] = t);
                    return e
                }
                for (const i in Ht)
                    Object.prototype.hasOwnProperty.call(Ht, i) && (void 0 === t[i] ? e[i] = Ht[i] : e[i] = t[i]);
                return e
            }(e.delay)
        }
        attach() {
            return this
        }
        detach() {
            return this
        }
        addContainer(...t) {
            this.containers = [...this.containers, ...t]
        }
        removeContainer(...t) {
            this.containers = this.containers.filter((e => !t.includes(e)))
        }
        trigger(t, e) {
            const i = document.createEvent("Event");
            return i.detail = e,
            i.initEvent(e.type, !0, !0),
            t.dispatchEvent(i),
            this.lastEvent = e,
            e
        }
    }
    function Bt(t, e) {
        if (null == t)
            return null;
        function i(t) {
            return null != t && null != e && (function(t) {
                return Boolean("string" == typeof t)
            }(e) ? Element.prototype.matches.call(t, e) : function(t) {
                return Boolean(t instanceof NodeList || t instanceof Array)
            }(e) ? [...e].includes(t) : function(t) {
                return Boolean(t instanceof Node)
            }(e) ? e === t : !!function(t) {
                return Boolean("function" == typeof t)
            }(e) && e(t))
        }
        let s = t;
        do {
            if (s = s.correspondingUseElement || s.correspondingElement || s,
            i(s))
                return s;
            s = s?.parentNode || null
        } while (null != s && s !== document.body && s !== document);
        return null
    }
    function Zt(t, e, i, s) {
        return Math.sqrt((i - t) ** 2 + (s - e) ** 2)
    }
    class Vt extends Yt {
        get originalEvent() {
            return this.data.originalEvent
        }
        get clientX() {
            return this.data.clientX
        }
        get clientY() {
            return this.data.clientY
        }
        get target() {
            return this.data.target
        }
        get container() {
            return this.data.container
        }
        get originalSource() {
            return this.data.originalSource
        }
        get pressure() {
            return this.data.pressure
        }
    }
    class qt extends Vt {
    }
    qt.type = "drag:start";
    class Ut extends Vt {
    }
    Ut.type = "drag:move";
    class Wt extends Vt {
    }
    Wt.type = "drag:stop";
    (class extends Vt {
    }
    ).type = "drag:pressure";
    const Xt = Symbol("onContextMenuWhileDragging")
      , Gt = Symbol("onMouseDown")
      , Jt = Symbol("onMouseMove")
      , Kt = Symbol("onMouseUp")
      , Qt = Symbol("startDrag")
      , te = Symbol("onDistanceChange");
    function ee(t) {
        t.preventDefault()
    }
    function ie(t) {
        const {touches: e, changedTouches: i} = t;
        return e && e[0] || i && i[0]
    }
    const se = Symbol("onTouchStart")
      , ne = Symbol("onTouchEnd")
      , re = Symbol("onTouchMove")
      , oe = Symbol("startDrag")
      , ae = Symbol("onDistanceChange");
    let le = !1;
    window.addEventListener("touchmove", (t => {
        le && t.preventDefault()
    }
    ), {
        passive: !1
    });
    function ce(t) {
        t.preventDefault(),
        t.stopPropagation()
    }
    class he extends Yt {
        constructor(t) {
            super(t),
            this.data = t
        }
        get dragEvent() {
            return this.data.dragEvent
        }
    }
    he.type = "collidable";
    (class extends he {
        get collidingElement() {
            return this.data.collidingElement
        }
    }
    ).type = "collidable:in";
    function de(t, e) {
        return function(i) {
            (function(t, e) {
                if (t.v)
                    throw new Error("attempted to call " + e + " after decoration was finished")
            }
            )(e, "addInitializer"),
            me(i, "An initializer"),
            t.push(i)
        }
    }
    function ue(t, e) {
        if (!t(e))
            throw new TypeError("Attempted to access private element on non-instance")
    }
    function pe(t, e, i, s, n, r, o, a, l, c, h) {
        var d;
        switch (r) {
        case 1:
            d = "accessor";
            break;
        case 2:
            d = "method";
            break;
        case 3:
            d = "getter";
            break;
        case 4:
            d = "setter";
            break;
        default:
            d = "field"
        }
        var u, p, m = {
            kind: d,
            name: a ? "#" + i : i,
            static: o,
            private: a,
            metadata: h
        }, f = {
            v: !1
        };
        if (0 !== r && (m.addInitializer = de(n, f)),
        a || 0 !== r && 2 !== r)
            if (2 === r)
                u = function(t) {
                    return ue(c, t),
                    s.value
                }
                ;
            else {
                var g = 0 === r || 1 === r;
                (g || 3 === r) && (u = a ? function(t) {
                    return ue(c, t),
                    s.get.call(t)
                }
                : function(t) {
                    return s.get.call(t)
                }
                ),
                (g || 4 === r) && (p = a ? function(t, e) {
                    ue(c, t),
                    s.set.call(t, e)
                }
                : function(t, e) {
                    s.set.call(t, e)
                }
                )
            }
        else
            u = function(t) {
                return t[i]
            }
            ,
            0 === r && (p = function(t, e) {
                t[i] = e
            }
            );
        var v = a ? c.bind() : function(t) {
            return i in t
        }
        ;
        m.access = u && p ? {
            get: u,
            set: p,
            has: v
        } : u ? {
            get: u,
            has: v
        } : {
            set: p,
            has: v
        };
        try {
            return t.call(e, l, m)
        } finally {
            f.v = !0
        }
    }
    function me(t, e) {
        if ("function" != typeof t)
            throw new TypeError(e + " must be a function")
    }
    function fe(t, e) {
        var i = typeof e;
        if (1 === t) {
            if ("object" !== i || null === e)
                throw new TypeError("accessor decorators must return an object with get, set, or init properties or void 0");
            void 0 !== e.get && me(e.get, "accessor.get"),
            void 0 !== e.set && me(e.set, "accessor.set"),
            void 0 !== e.init && me(e.init, "accessor.init")
        } else if ("function" !== i) {
            throw new TypeError((0 === t ? "field" : 5 === t ? "class" : "method") + " decorators must return a function or void 0")
        }
    }
    function ge(t) {
        return function() {
            return t(this)
        }
    }
    function ve(t) {
        return function(e) {
            t(this, e)
        }
    }
    function ye(t, e, i, s, n, r, o, a, l, c, h) {
        var d, u, p, m, f, g, v = i[0];
        s || Array.isArray(v) || (v = [v]),
        a ? d = 0 === r || 1 === r ? {
            get: ge(i[3]),
            set: ve(i[4])
        } : 3 === r ? {
            get: i[3]
        } : 4 === r ? {
            set: i[3]
        } : {
            value: i[3]
        } : 0 !== r && (d = Object.getOwnPropertyDescriptor(e, n)),
        1 === r ? p = {
            get: d.get,
            set: d.set
        } : 2 === r ? p = d.value : 3 === r ? p = d.get : 4 === r && (p = d.set);
        for (var y = s ? 2 : 1, _ = v.length - 1; _ >= 0; _ -= y) {
            var b;
            void 0 !== (m = pe(v[_], s ? v[_ - 1] : void 0, n, d, l, r, o, a, p, c, h)) && (fe(r, m),
            0 === r ? b = m : 1 === r ? (b = m.init,
            f = m.get || p.get,
            g = m.set || p.set,
            p = {
                get: f,
                set: g
            }) : p = m,
            void 0 !== b && (void 0 === u ? u = b : "function" == typeof u ? u = [u, b] : u.push(b)))
        }
        if (0 === r || 1 === r) {
            if (void 0 === u)
                u = function(t, e) {
                    return e
                }
                ;
            else if ("function" != typeof u) {
                var w = u;
                u = function(t, e) {
                    for (var i = e, s = w.length - 1; s >= 0; s--)
                        i = w[s].call(t, i);
                    return i
                }
            } else {
                var S = u;
                u = function(t, e) {
                    return S.call(t, e)
                }
            }
            t.push(u)
        }
        0 !== r && (1 === r ? (d.get = p.get,
        d.set = p.set) : 2 === r ? d.value = p : 3 === r ? d.get = p : 4 === r && (d.set = p),
        a ? 1 === r ? (t.push((function(t, e) {
            return p.get.call(t, e)
        }
        )),
        t.push((function(t, e) {
            return p.set.call(t, e)
        }
        ))) : 2 === r ? t.push(p) : t.push((function(t, e) {
            return p.call(t, e)
        }
        )) : Object.defineProperty(e, n, d))
    }
    function _e(t, e) {
        e && t.push((function(t) {
            for (var i = 0; i < e.length; i++)
                e[i].call(t);
            return t
        }
        ))
    }
    function be(t, e) {
        return Object.defineProperty(t, Symbol.metadata || Symbol.for("Symbol.metadata"), {
            configurable: !0,
            enumerable: !0,
            value: e
        })
    }
    function we(t, e, i, s, n, r) {
        if (arguments.length >= 6)
            var o = r[Symbol.metadata || Symbol.for("Symbol.metadata")];
        var a = Object.create(void 0 === o ? null : o)
          , l = function(t, e, i, s) {
            for (var n, r, o, a = [], l = new Map, c = new Map, h = 0; h < e.length; h++) {
                var d = e[h];
                if (Array.isArray(d)) {
                    var u, p, m = d[1], f = d[2], g = d.length > 3, v = 16 & m, y = !!(8 & m), _ = i;
                    if (m &= 7,
                    y ? (u = t,
                    0 !== m && (p = r = r || []),
                    g && !o && (o = function(e) {
                        return Se(e) === t
                    }
                    ),
                    _ = o) : (u = t.prototype,
                    0 !== m && (p = n = n || [])),
                    0 !== m && !g) {
                        var b = y ? c : l
                          , w = b.get(f) || 0;
                        if (!0 === w || 3 === w && 4 !== m || 4 === w && 3 !== m)
                            throw new Error("Attempted to decorate a public method/accessor that has the same name as a previously decorated public method/accessor. This is not currently supported by the decorators plugin. Property name was: " + f);
                        b.set(f, !(!w && m > 2) || m)
                    }
                    ye(a, u, d, v, f, m, y, g, p, _, s)
                }
            }
            return _e(a, n),
            _e(a, r),
            a
        }(t, e, n, a);
        return i.length || be(t, a),
        {
            e: l,
            get c() {
                return function(t, e, i, s) {
                    if (e.length) {
                        for (var n = [], r = t, o = t.name, a = e.length - 1; a >= 0; a -= 1) {
                            var l = {
                                v: !1
                            };
                            try {
                                var c = e[a].call(i ? e[a - 1] : void 0, r, {
                                    kind: "class",
                                    name: o,
                                    addInitializer: de(n, l),
                                    metadata: s
                                })
                            } finally {
                                l.v = !0
                            }
                            void 0 !== c && (fe(5, c),
                            r = c)
                        }
                        return [be(r, s), function() {
                            for (var t = 0; t < n.length; t++)
                                n[t].call(r)
                        }
                        ]
                    }
                }(t, i, s, a)
            }
        }
    }
    function Se(t) {
        if (Object(t) !== t)
            throw TypeError("right-hand side of 'in' should be an object, got " + (null !== t ? typeof t : "null"));
        return t
    }
    function Ee(t, {name: e, addInitializer: i}) {
        i((function() {
            this[e] = t.bind(this)
        }
        ))
    }
    (class extends he {
        get collidingElement() {
            return this.data.collidingElement
        }
    }
    ).type = "collidable:out";
    class xe extends Yt {
        constructor(t) {
            super(t),
            this.data = t
        }
        get source() {
            return this.data.source
        }
        get originalSource() {
            return this.data.originalSource
        }
        get mirror() {
            return this.data.mirror
        }
        get sourceContainer() {
            return this.data.sourceContainer
        }
        get sensorEvent() {
            return this.data.sensorEvent
        }
        get originalEvent() {
            return this.sensorEvent ? this.sensorEvent.originalEvent : null
        }
    }
    xe.type = "drag";
    class Le extends xe {
    }
    Le.type = "drag:start",
    Le.cancelable = !0;
    class Oe extends xe {
    }
    Oe.type = "drag:move";
    class Pe extends xe {
        get overContainer() {
            return this.data.overContainer
        }
        get over() {
            return this.data.over
        }
    }
    Pe.type = "drag:over",
    Pe.cancelable = !0;
    class Ce extends xe {
        get overContainer() {
            return this.data.overContainer
        }
        get over() {
            return this.data.over
        }
    }
    Ce.type = "drag:out";
    class Ae extends xe {
        get overContainer() {
            return this.data.overContainer
        }
    }
    Ae.type = "drag:over:container";
    class Me extends xe {
        get overContainer() {
            return this.data.overContainer
        }
    }
    Me.type = "drag:out:container";
    class Te extends xe {
        get pressure() {
            return this.data.pressure
        }
    }
    Te.type = "drag:pressure";
    class Ie extends xe {
    }
    Ie.type = "drag:stop",
    Ie.cancelable = !0;
    class De extends xe {
    }
    var ke, ze, Fe, Ne;
    De.type = "drag:stopped";
    ze = class extends jt {
        constructor(t) {
            ke(super(t)),
            this.lastWidth = 0,
            this.lastHeight = 0,
            this.mirror = null
        }
        attach() {
            this.draggable.on("mirror:created", this.onMirrorCreated).on("drag:over", this.onDragOver).on("drag:over:container", this.onDragOver)
        }
        detach() {
            this.draggable.off("mirror:created", this.onMirrorCreated).off("mirror:destroy", this.onMirrorDestroy).off("drag:over", this.onDragOver).off("drag:over:container", this.onDragOver)
        }
        getOptions() {
            return this.draggable.options.resizeMirror || {}
        }
        onMirrorCreated({mirror: t}) {
            this.mirror = t
        }
        onMirrorDestroy() {
            this.mirror = null
        }
        onDragOver(t) {
            this.resize(t)
        }
        resize(t) {
            requestAnimationFrame(( () => {
                let e = null;
                const {overContainer: i} = t;
                if (null == this.mirror || null == this.mirror.parentNode)
                    return;
                this.mirror.parentNode !== i && i.appendChild(this.mirror),
                t.type === Pe.type && (e = t.over);
                const s = e || this.draggable.getDraggableElementsForContainer(i)[0];
                var n;
                s && (n = () => {
                    const t = s.getBoundingClientRect();
                    null == this.mirror || this.lastHeight === t.height && this.lastWidth === t.width || (this.mirror.style.width = `${t.width}px`,
                    this.mirror.style.height = `${t.height}px`,
                    this.lastWidth = t.width,
                    this.lastHeight = t.height)
                }
                ,
                requestAnimationFrame(( () => {
                    requestAnimationFrame(n)
                }
                )))
            }
            ))
        }
    }
    ,
    [ke] = we(ze, [[Ee, 2, "onMirrorCreated"], [Ee, 2, "onMirrorDestroy"], [Ee, 2, "onDragOver"]], [], 0, void 0, jt).e;
    class Re extends Yt {
        get dragEvent() {
            return this.data.dragEvent
        }
        get snappable() {
            return this.data.snappable
        }
    }
    Re.type = "snap";
    class Ye extends Re {
    }
    Ye.type = "snap:in",
    Ye.cancelable = !0;
    class je extends Re {
    }
    je.type = "snap:out",
    je.cancelable = !0;
    const He = {
        duration: 150,
        easingFunction: "ease-in-out",
        horizontal: !1
    };
    function $e(t, e, {duration: i, easingFunction: s, horizontal: n}) {
        for (const i of [t, e])
            i.style.pointerEvents = "none";
        if (n) {
            const i = t.offsetWidth;
            t.style.transform = `translate3d(${i}px, 0, 0)`,
            e.style.transform = `translate3d(-${i}px, 0, 0)`
        } else {
            const i = t.offsetHeight;
            t.style.transform = `translate3d(0, ${i}px, 0)`,
            e.style.transform = `translate3d(0, -${i}px, 0)`
        }
        requestAnimationFrame(( () => {
            for (const n of [t, e])
                n.addEventListener("transitionend", Be),
                n.style.transition = `transform ${i}ms ${s}`,
                n.style.transform = ""
        }
        ))
    }
    function Be(t) {
        var e;
        null != t.target && (e = t.target,
        Boolean("style"in e)) && (t.target.style.transition = "",
        t.target.style.pointerEvents = "",
        t.target.removeEventListener("transitionend", Be))
    }
    Ne = class extends jt {
        constructor(t) {
            Fe(super(t)),
            this.options = {
                ...He,
                ...this.getOptions()
            },
            this.lastAnimationFrame = null
        }
        attach() {
            this.draggable.on("sortable:sorted", this.onSortableSorted)
        }
        detach() {
            this.draggable.off("sortable:sorted", this.onSortableSorted)
        }
        getOptions() {
            return this.draggable.options.swapAnimation || {}
        }
        onSortableSorted({oldIndex: t, newIndex: e, dragEvent: i}) {
            const {source: s, over: n} = i;
            this.lastAnimationFrame && cancelAnimationFrame(this.lastAnimationFrame),
            this.lastAnimationFrame = requestAnimationFrame(( () => {
                t >= e ? $e(s, n, this.options) : $e(n, s, this.options)
            }
            ))
        }
    }
    ,
    [Fe] = we(Ne, [[Ee, 2, "onSortableSorted"]], [], 0, void 0, jt).e;
    const Ze = Symbol("onInitialize")
      , Ve = Symbol("onDestroy")
      , qe = Symbol("announceEvent")
      , Ue = Symbol("announceMessage")
      , We = {
        expire: 7e3
    };
    const Xe = function() {
        const t = document.createElement("div");
        return t.setAttribute("id", "draggable-live-region"),
        t.setAttribute("aria-relevant", "additions"),
        t.setAttribute("aria-atomic", "true"),
        t.setAttribute("aria-live", "assertive"),
        t.setAttribute("role", "log"),
        t.style.position = "fixed",
        t.style.width = "1px",
        t.style.height = "1px",
        t.style.top = "-1px",
        t.style.overflow = "hidden",
        t
    }();
    document.addEventListener("DOMContentLoaded", ( () => {
        document.body.appendChild(Xe)
    }
    ));
    const Ge = Symbol("onInitialize")
      , Je = Symbol("onDestroy")
      , Ke = {};
    const Qe = [];
    class ti extends Yt {
        constructor(t) {
            super(t),
            this.data = t
        }
        get source() {
            return this.data.source
        }
        get originalSource() {
            return this.data.originalSource
        }
        get sourceContainer() {
            return this.data.sourceContainer
        }
        get sensorEvent() {
            return this.data.sensorEvent
        }
        get dragEvent() {
            return this.data.dragEvent
        }
        get originalEvent() {
            return this.sensorEvent ? this.sensorEvent.originalEvent : null
        }
    }
    class ei extends ti {
    }
    ei.type = "mirror:create";
    class ii extends ti {
        get mirror() {
            return this.data.mirror
        }
    }
    ii.type = "mirror:created";
    class si extends ti {
        get mirror() {
            return this.data.mirror
        }
    }
    si.type = "mirror:attached";
    class ni extends ti {
        get mirror() {
            return this.data.mirror
        }
        get passedThreshX() {
            return this.data.passedThreshX
        }
        get passedThreshY() {
            return this.data.passedThreshY
        }
    }
    ni.type = "mirror:move",
    ni.cancelable = !0;
    class ri extends ti {
        get mirror() {
            return this.data.mirror
        }
        get passedThreshX() {
            return this.data.passedThreshX
        }
        get passedThreshY() {
            return this.data.passedThreshY
        }
    }
    ri.type = "mirror:moved";
    class oi extends ti {
        get mirror() {
            return this.data.mirror
        }
    }
    oi.type = "mirror:destroy",
    oi.cancelable = !0;
    const ai = Symbol("onDragStart")
      , li = Symbol("onDragMove")
      , ci = Symbol("onDragStop")
      , hi = Symbol("onMirrorCreated")
      , di = Symbol("onMirrorMove")
      , ui = Symbol("onScroll")
      , pi = Symbol("getAppendableContainer")
      , mi = {
        constrainDimensions: !1,
        xAxis: !0,
        yAxis: !0,
        cursorOffsetX: null,
        cursorOffsetY: null,
        thresholdX: null,
        thresholdY: null
    };
    function fi({source: t, ...e}) {
        return wi((i => {
            const s = t.getBoundingClientRect();
            i({
                source: t,
                sourceRect: s,
                ...e
            })
        }
        ))
    }
    function gi({sensorEvent: t, sourceRect: e, options: i, ...s}) {
        return wi((n => {
            const r = null === i.cursorOffsetY ? t.clientY - e.top : i.cursorOffsetY
              , o = null === i.cursorOffsetX ? t.clientX - e.left : i.cursorOffsetX;
            n({
                sensorEvent: t,
                sourceRect: e,
                mirrorOffset: {
                    top: r,
                    left: o
                },
                options: i,
                ...s
            })
        }
        ))
    }
    function vi({mirror: t, source: e, options: i, ...s}) {
        return wi((n => {
            let r, o;
            if (i.constrainDimensions) {
                const t = getComputedStyle(e);
                r = t.getPropertyValue("height"),
                o = t.getPropertyValue("width")
            }
            t.style.display = null,
            t.style.position = "fixed",
            t.style.pointerEvents = "none",
            t.style.top = 0,
            t.style.left = 0,
            t.style.margin = 0,
            i.constrainDimensions && (t.style.height = r,
            t.style.width = o),
            n({
                mirror: t,
                source: e,
                options: i,
                ...s
            })
        }
        ))
    }
    function yi({mirror: t, mirrorClasses: e, ...i}) {
        return wi((s => {
            t.classList.add(...e),
            s({
                mirror: t,
                mirrorClasses: e,
                ...i
            })
        }
        ))
    }
    function _i({mirror: t, ...e}) {
        return wi((i => {
            t.removeAttribute("id"),
            delete t.id,
            i({
                mirror: t,
                ...e
            })
        }
        ))
    }
    function bi({withFrame: t=!1, initial: e=!1}={}) {
        return ({mirror: i, sensorEvent: s, mirrorOffset: n, initialY: r, initialX: o, scrollOffset: a, options: l, passedThreshX: c, passedThreshY: h, lastMovedX: d, lastMovedY: u, ...p}) => wi((t => {
            const m = {
                mirror: i,
                sensorEvent: s,
                mirrorOffset: n,
                options: l,
                ...p
            };
            if (n) {
                const t = c ? Math.round((s.clientX - n.left - a.x) / (l.thresholdX || 1)) * (l.thresholdX || 1) : Math.round(d)
                  , p = h ? Math.round((s.clientY - n.top - a.y) / (l.thresholdY || 1)) * (l.thresholdY || 1) : Math.round(u);
                l.xAxis && l.yAxis || e ? i.style.transform = `translate3d(${t}px, ${p}px, 0)` : l.xAxis && !l.yAxis ? i.style.transform = `translate3d(${t}px, ${r}px, 0)` : l.yAxis && !l.xAxis && (i.style.transform = `translate3d(${o}px, ${p}px, 0)`),
                e && (m.initialX = t,
                m.initialY = p),
                m.lastMovedX = t,
                m.lastMovedY = p
            }
            t(m)
        }
        ), {
            frame: t
        })
    }
    function wi(t, {raf: e=!1}={}) {
        return new Promise(( (i, s) => {
            e ? requestAnimationFrame(( () => {
                t(i, s)
            }
            )) : t(i, s)
        }
        ))
    }
    const Si = Symbol("onDragStart")
      , Ei = Symbol("onDragMove")
      , xi = Symbol("onDragStop")
      , Li = Symbol("scroll")
      , Oi = {
        speed: 6,
        sensitivity: 50,
        scrollableElements: []
    };
    function Pi() {
        return document.scrollingElement || document.documentElement
    }
    class Ci {
        constructor() {
            this.callbacks = {}
        }
        on(t, ...e) {
            return this.callbacks[t] || (this.callbacks[t] = []),
            this.callbacks[t].push(...e),
            this
        }
        off(t, e) {
            if (!this.callbacks[t])
                return null;
            const i = this.callbacks[t].slice(0);
            for (let s = 0; s < i.length; s++)
                e === i[s] && this.callbacks[t].splice(s, 1);
            return this
        }
        trigger(t) {
            if (!this.callbacks[t.type])
                return null;
            const e = [...this.callbacks[t.type]]
              , i = [];
            for (let s = e.length - 1; s >= 0; s--) {
                const n = e[s];
                try {
                    n(t)
                } catch (t) {
                    i.push(t)
                }
            }
            return i.length && console.error(`Draggable caught errors while triggering '${t.type}'`, i),
            this
        }
    }
    class Ai extends Yt {
        get draggable() {
            return this.data.draggable
        }
    }
    Ai.type = "draggable";
    class Mi extends Ai {
    }
    Mi.type = "draggable:initialize";
    class Ti extends Ai {
    }
    Ti.type = "draggable:destroy";
    const Ii = Symbol("onDragStart")
      , Di = Symbol("onDragMove")
      , ki = Symbol("onDragStop")
      , zi = Symbol("onDragPressure")
      , Fi = Symbol("dragStop")
      , Ni = {
        "drag:start": t => `Picked up ${t.source.textContent.trim() || t.source.id || "draggable element"}`,
        "drag:stop": t => `Released ${t.source.textContent.trim() || t.source.id || "draggable element"}`
    }
      , Ri = {
        "container:dragging": "draggable-container--is-dragging",
        "source:dragging": "draggable-source--is-dragging",
        "source:placed": "draggable-source--placed",
        "container:placed": "draggable-container--placed",
        "body:dragging": "draggable--is-dragging",
        "draggable:over": "draggable--over",
        "container:over": "draggable-container--over",
        "source:original": "draggable--original",
        mirror: "draggable-mirror"
    }
      , Yi = {
        draggable: ".draggable-source",
        handle: null,
        delay: {},
        distance: 0,
        placedTimeout: 800,
        plugins: [],
        sensors: [],
        exclude: {
            plugins: [],
            sensors: []
        }
    };
    class ji {
        constructor(t=[document.body], e={}) {
            if (t instanceof NodeList || t instanceof Array)
                this.containers = [...t];
            else {
                if (!(t instanceof HTMLElement))
                    throw new Error("Draggable containers are expected to be of type `NodeList`, `HTMLElement[]` or `HTMLElement`");
                this.containers = [t]
            }
            this.options = {
                ...Yi,
                ...e,
                classes: {
                    ...Ri,
                    ...e.classes || {}
                },
                announcements: {
                    ...Ni,
                    ...e.announcements || {}
                },
                exclude: {
                    plugins: e.exclude && e.exclude.plugins || [],
                    sensors: e.exclude && e.exclude.sensors || []
                }
            },
            this.emitter = new Ci,
            this.dragging = !1,
            this.plugins = [],
            this.sensors = [],
            this[Ii] = this[Ii].bind(this),
            this[Di] = this[Di].bind(this),
            this[ki] = this[ki].bind(this),
            this[zi] = this[zi].bind(this),
            this[Fi] = this[Fi].bind(this),
            document.addEventListener("drag:start", this[Ii], !0),
            document.addEventListener("drag:move", this[Di], !0),
            document.addEventListener("drag:stop", this[ki], !0),
            document.addEventListener("drag:pressure", this[zi], !0);
            const i = Object.values(ji.Plugins).filter((t => !this.options.exclude.plugins.includes(t)))
              , s = Object.values(ji.Sensors).filter((t => !this.options.exclude.sensors.includes(t)));
            this.addPlugin(...i, ...this.options.plugins),
            this.addSensor(...s, ...this.options.sensors);
            const n = new Mi({
                draggable: this
            });
            this.on("mirror:created", ( ({mirror: t}) => this.mirror = t)),
            this.on("mirror:destroy", ( () => this.mirror = null)),
            this.trigger(n)
        }
        destroy() {
            document.removeEventListener("drag:start", this[Ii], !0),
            document.removeEventListener("drag:move", this[Di], !0),
            document.removeEventListener("drag:stop", this[ki], !0),
            document.removeEventListener("drag:pressure", this[zi], !0);
            const t = new Ti({
                draggable: this
            });
            this.trigger(t),
            this.removePlugin(...this.plugins.map((t => t.constructor))),
            this.removeSensor(...this.sensors.map((t => t.constructor)))
        }
        addPlugin(...t) {
            const e = t.map((t => new t(this)));
            return e.forEach((t => t.attach())),
            this.plugins = [...this.plugins, ...e],
            this
        }
        removePlugin(...t) {
            return this.plugins.filter((e => t.includes(e.constructor))).forEach((t => t.detach())),
            this.plugins = this.plugins.filter((e => !t.includes(e.constructor))),
            this
        }
        addSensor(...t) {
            const e = t.map((t => new t(this.containers,this.options)));
            return e.forEach((t => t.attach())),
            this.sensors = [...this.sensors, ...e],
            this
        }
        removeSensor(...t) {
            return this.sensors.filter((e => t.includes(e.constructor))).forEach((t => t.detach())),
            this.sensors = this.sensors.filter((e => !t.includes(e.constructor))),
            this
        }
        addContainer(...t) {
            return this.containers = [...this.containers, ...t],
            this.sensors.forEach((e => e.addContainer(...t))),
            this
        }
        removeContainer(...t) {
            return this.containers = this.containers.filter((e => !t.includes(e))),
            this.sensors.forEach((e => e.removeContainer(...t))),
            this
        }
        on(t, ...e) {
            return this.emitter.on(t, ...e),
            this
        }
        off(t, e) {
            return this.emitter.off(t, e),
            this
        }
        trigger(t) {
            return this.emitter.trigger(t),
            this
        }
        getClassNameFor(t) {
            return this.getClassNamesFor(t)[0]
        }
        getClassNamesFor(t) {
            const e = this.options.classes[t];
            return e instanceof Array ? e : "string" == typeof e || e instanceof String ? [e] : []
        }
        isDragging() {
            return Boolean(this.dragging)
        }
        getDraggableElements() {
            return this.containers.reduce(( (t, e) => [...t, ...this.getDraggableElementsForContainer(e)]), [])
        }
        getDraggableElementsForContainer(t) {
            return [...t.querySelectorAll(this.options.draggable)].filter((t => t !== this.originalSource && t !== this.mirror))
        }
        cancel() {
            this[Fi]()
        }
        [Ii](t) {
            const e = Hi(t)
              , {target: i, container: s, originalSource: n} = e;
            if (!this.containers.includes(s))
                return;
            if (this.options.handle && i && !Bt(i, this.options.handle))
                return void e.cancel();
            this.originalSource = n,
            this.sourceContainer = s,
            this.lastPlacedSource && this.lastPlacedContainer && (clearTimeout(this.placedTimeoutID),
            this.lastPlacedSource.classList.remove(...this.getClassNamesFor("source:placed")),
            this.lastPlacedContainer.classList.remove(...this.getClassNamesFor("container:placed"))),
            this.source = this.originalSource.cloneNode(!0),
            this.originalSource.parentNode.insertBefore(this.source, this.originalSource),
            this.originalSource.style.display = "none";
            const r = new Le({
                source: this.source,
                originalSource: this.originalSource,
                sourceContainer: s,
                sensorEvent: e
            });
            if (this.trigger(r),
            this.dragging = !r.canceled(),
            r.canceled())
                return this.source.remove(),
                void (this.originalSource.style.display = null);
            this.originalSource.classList.add(...this.getClassNamesFor("source:original")),
            this.source.classList.add(...this.getClassNamesFor("source:dragging")),
            this.sourceContainer.classList.add(...this.getClassNamesFor("container:dragging")),
            document.body.classList.add(...this.getClassNamesFor("body:dragging")),
            $i(document.body, "none"),
            requestAnimationFrame(( () => {
                const e = Hi(t).clone({
                    target: this.source
                });
                this[Di]({
                    ...t,
                    detail: e
                })
            }
            ))
        }
        [Di](t) {
            if (!this.dragging)
                return;
            const e = Hi(t)
              , {container: i} = e;
            let s = e.target;
            const n = new Oe({
                source: this.source,
                originalSource: this.originalSource,
                sourceContainer: i,
                sensorEvent: e
            });
            this.trigger(n),
            n.canceled() && e.cancel(),
            s = Bt(s, this.options.draggable);
            const r = Bt(e.target, this.containers)
              , o = e.overContainer || r
              , a = this.currentOverContainer && o !== this.currentOverContainer
              , l = this.currentOver && s !== this.currentOver
              , c = o && this.currentOverContainer !== o
              , h = r && s && this.currentOver !== s;
            if (l) {
                const t = new Ce({
                    source: this.source,
                    originalSource: this.originalSource,
                    sourceContainer: i,
                    sensorEvent: e,
                    over: this.currentOver,
                    overContainer: this.currentOverContainer
                });
                this.currentOver.classList.remove(...this.getClassNamesFor("draggable:over")),
                this.currentOver = null,
                this.trigger(t)
            }
            if (a) {
                const t = new Me({
                    source: this.source,
                    originalSource: this.originalSource,
                    sourceContainer: i,
                    sensorEvent: e,
                    overContainer: this.currentOverContainer
                });
                this.currentOverContainer.classList.remove(...this.getClassNamesFor("container:over")),
                this.currentOverContainer = null,
                this.trigger(t)
            }
            if (c) {
                o.classList.add(...this.getClassNamesFor("container:over"));
                const t = new Ae({
                    source: this.source,
                    originalSource: this.originalSource,
                    sourceContainer: i,
                    sensorEvent: e,
                    overContainer: o
                });
                this.currentOverContainer = o,
                this.trigger(t)
            }
            if (h) {
                s.classList.add(...this.getClassNamesFor("draggable:over"));
                const t = new Pe({
                    source: this.source,
                    originalSource: this.originalSource,
                    sourceContainer: i,
                    sensorEvent: e,
                    overContainer: o,
                    over: s
                });
                this.currentOver = s,
                this.trigger(t)
            }
        }
        [Fi](t) {
            if (!this.dragging)
                return;
            this.dragging = !1;
            const e = new Ie({
                source: this.source,
                originalSource: this.originalSource,
                sensorEvent: t ? t.sensorEvent : null,
                sourceContainer: this.sourceContainer
            });
            this.trigger(e),
            e.canceled() || this.source.parentNode.insertBefore(this.originalSource, this.source),
            this.source.remove(),
            this.originalSource.style.display = "",
            this.source.classList.remove(...this.getClassNamesFor("source:dragging")),
            this.originalSource.classList.remove(...this.getClassNamesFor("source:original")),
            this.originalSource.classList.add(...this.getClassNamesFor("source:placed")),
            this.sourceContainer.classList.add(...this.getClassNamesFor("container:placed")),
            this.sourceContainer.classList.remove(...this.getClassNamesFor("container:dragging")),
            document.body.classList.remove(...this.getClassNamesFor("body:dragging")),
            $i(document.body, ""),
            this.currentOver && this.currentOver.classList.remove(...this.getClassNamesFor("draggable:over")),
            this.currentOverContainer && this.currentOverContainer.classList.remove(...this.getClassNamesFor("container:over")),
            this.lastPlacedSource = this.originalSource,
            this.lastPlacedContainer = this.sourceContainer,
            this.placedTimeoutID = setTimeout(( () => {
                this.lastPlacedSource && this.lastPlacedSource.classList.remove(...this.getClassNamesFor("source:placed")),
                this.lastPlacedContainer && this.lastPlacedContainer.classList.remove(...this.getClassNamesFor("container:placed")),
                this.lastPlacedSource = null,
                this.lastPlacedContainer = null
            }
            ), this.options.placedTimeout);
            const i = new De({
                source: this.source,
                originalSource: this.originalSource,
                sensorEvent: t ? t.sensorEvent : null,
                sourceContainer: this.sourceContainer
            });
            this.trigger(i),
            this.source = null,
            this.originalSource = null,
            this.currentOverContainer = null,
            this.currentOver = null,
            this.sourceContainer = null
        }
        [ki](t) {
            this[Fi](t)
        }
        [zi](t) {
            if (!this.dragging)
                return;
            const e = Hi(t)
              , i = this.source || Bt(e.originalEvent.target, this.options.draggable)
              , s = new Te({
                sensorEvent: e,
                source: i,
                pressure: e.pressure
            });
            this.trigger(s)
        }
    }
    function Hi(t) {
        return t.detail
    }
    function $i(t, e) {
        t.style.webkitUserSelect = e,
        t.style.mozUserSelect = e,
        t.style.msUserSelect = e,
        t.style.oUserSelect = e,
        t.style.userSelect = e
    }
    ji.Plugins = {
        Announcement: class extends jt {
            constructor(t) {
                super(t),
                this.options = {
                    ...We,
                    ...this.getOptions()
                },
                this.originalTriggerMethod = this.draggable.trigger,
                this[Ze] = this[Ze].bind(this),
                this[Ve] = this[Ve].bind(this)
            }
            attach() {
                this.draggable.on("draggable:initialize", this[Ze])
            }
            detach() {
                this.draggable.off("draggable:destroy", this[Ve])
            }
            getOptions() {
                return this.draggable.options.announcements || {}
            }
            [qe](t) {
                const e = this.options[t.type];
                e && "string" == typeof e && this[Ue](e),
                e && "function" == typeof e && this[Ue](e(t))
            }
            [Ue](t) {
                !function(t, {expire: e}) {
                    const i = document.createElement("div");
                    i.textContent = t,
                    Xe.appendChild(i),
                    setTimeout(( () => {
                        Xe.removeChild(i)
                    }
                    ), e)
                }(t, {
                    expire: this.options.expire
                })
            }
            [Ze]() {
                this.draggable.trigger = t => {
                    try {
                        this[qe](t)
                    } finally {
                        this.originalTriggerMethod.call(this.draggable, t)
                    }
                }
            }
            [Ve]() {
                this.draggable.trigger = this.originalTriggerMethod
            }
        }
        ,
        Focusable: class extends jt {
            constructor(t) {
                super(t),
                this.options = {
                    ...Ke,
                    ...this.getOptions()
                },
                this[Ge] = this[Ge].bind(this),
                this[Je] = this[Je].bind(this)
            }
            attach() {
                this.draggable.on("draggable:initialize", this[Ge]).on("draggable:destroy", this[Je])
            }
            detach() {
                this.draggable.off("draggable:initialize", this[Ge]).off("draggable:destroy", this[Je]),
                this[Je]()
            }
            getOptions() {
                return this.draggable.options.focusable || {}
            }
            getElements() {
                return [...this.draggable.containers, ...this.draggable.getDraggableElements()]
            }
            [Ge]() {
                requestAnimationFrame(( () => {
                    this.getElements().forEach((t => function(t) {
                        const e = Boolean(!t.getAttribute("tabindex") && -1 === t.tabIndex);
                        e && (Qe.push(t),
                        t.tabIndex = 0)
                    }(t)))
                }
                ))
            }
            [Je]() {
                requestAnimationFrame(( () => {
                    this.getElements().forEach((t => function(t) {
                        const e = Qe.indexOf(t);
                        -1 !== e && (t.tabIndex = -1,
                        Qe.splice(e, 1))
                    }(t)))
                }
                ))
            }
        }
        ,
        Mirror: class extends jt {
            constructor(t) {
                super(t),
                this.options = {
                    ...mi,
                    ...this.getOptions()
                },
                this.scrollOffset = {
                    x: 0,
                    y: 0
                },
                this.initialScrollOffset = {
                    x: window.scrollX,
                    y: window.scrollY
                },
                this[ai] = this[ai].bind(this),
                this[li] = this[li].bind(this),
                this[ci] = this[ci].bind(this),
                this[hi] = this[hi].bind(this),
                this[di] = this[di].bind(this),
                this[ui] = this[ui].bind(this)
            }
            attach() {
                this.draggable.on("drag:start", this[ai]).on("drag:move", this[li]).on("drag:stop", this[ci]).on("mirror:created", this[hi]).on("mirror:move", this[di])
            }
            detach() {
                this.draggable.off("drag:start", this[ai]).off("drag:move", this[li]).off("drag:stop", this[ci]).off("mirror:created", this[hi]).off("mirror:move", this[di])
            }
            getOptions() {
                return this.draggable.options.mirror || {}
            }
            [ai](t) {
                if (t.canceled())
                    return;
                "ontouchstart"in window && document.addEventListener("scroll", this[ui], !0),
                this.initialScrollOffset = {
                    x: window.scrollX,
                    y: window.scrollY
                };
                const {source: e, originalSource: i, sourceContainer: s, sensorEvent: n} = t;
                this.lastMirrorMovedClient = {
                    x: n.clientX,
                    y: n.clientY
                };
                const r = new ei({
                    source: e,
                    originalSource: i,
                    sourceContainer: s,
                    sensorEvent: n,
                    dragEvent: t
                });
                if (this.draggable.trigger(r),
                function(t) {
                    return /^drag/.test(t.originalEvent.type)
                }(n) || r.canceled())
                    return;
                const o = this[pi](e) || s;
                this.mirror = e.cloneNode(!0);
                const a = new ii({
                    source: e,
                    originalSource: i,
                    sourceContainer: s,
                    sensorEvent: n,
                    dragEvent: t,
                    mirror: this.mirror
                })
                  , l = new si({
                    source: e,
                    originalSource: i,
                    sourceContainer: s,
                    sensorEvent: n,
                    dragEvent: t,
                    mirror: this.mirror
                });
                this.draggable.trigger(a),
                o.appendChild(this.mirror),
                this.draggable.trigger(l)
            }
            [li](t) {
                if (!this.mirror || t.canceled())
                    return;
                const {source: e, originalSource: i, sourceContainer: s, sensorEvent: n} = t;
                let r = !0
                  , o = !0;
                if (this.options.thresholdX || this.options.thresholdY) {
                    const {x: t, y: e} = this.lastMirrorMovedClient;
                    if (Math.abs(t - n.clientX) < this.options.thresholdX ? r = !1 : this.lastMirrorMovedClient.x = n.clientX,
                    Math.abs(e - n.clientY) < this.options.thresholdY ? o = !1 : this.lastMirrorMovedClient.y = n.clientY,
                    !r && !o)
                        return
                }
                const a = new ni({
                    source: e,
                    originalSource: i,
                    sourceContainer: s,
                    sensorEvent: n,
                    dragEvent: t,
                    mirror: this.mirror,
                    passedThreshX: r,
                    passedThreshY: o
                });
                this.draggable.trigger(a)
            }
            [ci](t) {
                if ("ontouchstart"in window && document.removeEventListener("scroll", this[ui], !0),
                this.initialScrollOffset = {
                    x: 0,
                    y: 0
                },
                this.scrollOffset = {
                    x: 0,
                    y: 0
                },
                !this.mirror)
                    return;
                const {source: e, sourceContainer: i, sensorEvent: s} = t
                  , n = new oi({
                    source: e,
                    mirror: this.mirror,
                    sourceContainer: i,
                    sensorEvent: s,
                    dragEvent: t
                });
                this.draggable.trigger(n),
                n.canceled() || this.mirror.remove()
            }
            [ui]() {
                this.scrollOffset = {
                    x: window.scrollX - this.initialScrollOffset.x,
                    y: window.scrollY - this.initialScrollOffset.y
                }
            }
            [hi]({mirror: t, source: e, sensorEvent: i}) {
                const s = this.draggable.getClassNamesFor("mirror");
                t.style.display = "none";
                const n = {
                    mirror: t,
                    source: e,
                    sensorEvent: i,
                    mirrorClasses: s,
                    scrollOffset: this.scrollOffset,
                    options: this.options,
                    passedThreshX: !0,
                    passedThreshY: !0
                };
                return Promise.resolve(n).then(fi).then(gi).then(vi).then(yi).then(bi({
                    initial: !0
                })).then(_i).then(( ({mirrorOffset: t, initialX: e, initialY: i, ...s}) => (this.mirrorOffset = t,
                this.initialX = e,
                this.initialY = i,
                this.lastMovedX = e,
                this.lastMovedY = i,
                {
                    mirrorOffset: t,
                    initialX: e,
                    initialY: i,
                    ...s
                })))
            }
            [di](t) {
                if (t.canceled())
                    return null;
                const e = {
                    mirror: t.mirror,
                    sensorEvent: t.sensorEvent,
                    mirrorOffset: this.mirrorOffset,
                    options: this.options,
                    initialX: this.initialX,
                    initialY: this.initialY,
                    scrollOffset: this.scrollOffset,
                    passedThreshX: t.passedThreshX,
                    passedThreshY: t.passedThreshY,
                    lastMovedX: this.lastMovedX,
                    lastMovedY: this.lastMovedY
                };
                return Promise.resolve(e).then(bi({
                    raf: !0
                })).then(( ({lastMovedX: t, lastMovedY: e, ...i}) => (this.lastMovedX = t,
                this.lastMovedY = e,
                {
                    lastMovedX: t,
                    lastMovedY: e,
                    ...i
                }))).then((e => {
                    const i = new ri({
                        source: t.source,
                        originalSource: t.originalSource,
                        sourceContainer: t.sourceContainer,
                        sensorEvent: t.sensorEvent,
                        dragEvent: t.dragEvent,
                        mirror: this.mirror,
                        passedThreshX: t.passedThreshX,
                        passedThreshY: t.passedThreshY
                    });
                    return this.draggable.trigger(i),
                    e
                }
                ))
            }
            [pi](t) {
                const e = this.options.appendTo;
                return "string" == typeof e ? document.querySelector(e) : e instanceof HTMLElement ? e : "function" == typeof e ? e(t) : t.parentNode
            }
        }
        ,
        Scrollable: class extends jt {
            constructor(t) {
                super(t),
                this.options = {
                    ...Oi,
                    ...this.getOptions()
                },
                this.currentMousePosition = null,
                this.scrollAnimationFrame = null,
                this.scrollableElement = null,
                this.findScrollableElementFrame = null,
                this[Si] = this[Si].bind(this),
                this[Ei] = this[Ei].bind(this),
                this[xi] = this[xi].bind(this),
                this[Li] = this[Li].bind(this)
            }
            attach() {
                this.draggable.on("drag:start", this[Si]).on("drag:move", this[Ei]).on("drag:stop", this[xi])
            }
            detach() {
                this.draggable.off("drag:start", this[Si]).off("drag:move", this[Ei]).off("drag:stop", this[xi])
            }
            getOptions() {
                return this.draggable.options.scrollable || {}
            }
            getScrollableElement(t) {
                return this.hasDefinedScrollableElements() ? Bt(t, this.options.scrollableElements) || document.documentElement : function(t) {
                    if (!t)
                        return Pi();
                    const e = getComputedStyle(t).getPropertyValue("position")
                      , i = "absolute" === e
                      , s = Bt(t, (t => (!i || !function(t) {
                        const e = getComputedStyle(t).getPropertyValue("position");
                        return "static" === e
                    }(t)) && function(t) {
                        const e = /(auto|scroll)/
                          , i = getComputedStyle(t, null)
                          , s = i.getPropertyValue("overflow") + i.getPropertyValue("overflow-y") + i.getPropertyValue("overflow-x");
                        return e.test(s)
                    }(t)));
                    return "fixed" !== e && s ? s : Pi()
                }(t)
            }
            hasDefinedScrollableElements() {
                return Boolean(0 !== this.options.scrollableElements.length)
            }
            [Si](t) {
                this.findScrollableElementFrame = requestAnimationFrame(( () => {
                    this.scrollableElement = this.getScrollableElement(t.source)
                }
                ))
            }
            [Ei](t) {
                if (this.findScrollableElementFrame = requestAnimationFrame(( () => {
                    this.scrollableElement = this.getScrollableElement(t.sensorEvent.target)
                }
                )),
                !this.scrollableElement)
                    return;
                const e = t.sensorEvent
                  , i = {
                    x: 0,
                    y: 0
                };
                "ontouchstart"in window && (i.y = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0,
                i.x = window.pageXOffset || document.documentElement.scrollLeft || document.body.scrollLeft || 0),
                this.currentMousePosition = {
                    clientX: e.clientX - i.x,
                    clientY: e.clientY - i.y
                },
                this.scrollAnimationFrame = requestAnimationFrame(this[Li])
            }
            [xi]() {
                cancelAnimationFrame(this.scrollAnimationFrame),
                cancelAnimationFrame(this.findScrollableElementFrame),
                this.scrollableElement = null,
                this.scrollAnimationFrame = null,
                this.findScrollableElementFrame = null,
                this.currentMousePosition = null
            }
            [Li]() {
                if (!this.scrollableElement || !this.currentMousePosition)
                    return;
                cancelAnimationFrame(this.scrollAnimationFrame);
                const {speed: t, sensitivity: e} = this.options
                  , i = this.scrollableElement.getBoundingClientRect()
                  , s = i.bottom > window.innerHeight
                  , n = i.top < 0 || s
                  , r = Pi()
                  , o = this.scrollableElement
                  , a = this.currentMousePosition.clientX
                  , l = this.currentMousePosition.clientY;
                if (o === document.body || o === document.documentElement || n) {
                    const {innerHeight: i, innerWidth: s} = window;
                    l < e ? r.scrollTop -= t : i - l < e && (r.scrollTop += t),
                    a < e ? r.scrollLeft -= t : s - a < e && (r.scrollLeft += t)
                } else {
                    const {offsetHeight: s, offsetWidth: n} = o;
                    i.top + s - l < e ? o.scrollTop += t : l - i.top < e && (o.scrollTop -= t),
                    i.left + n - a < e ? o.scrollLeft += t : a - i.left < e && (o.scrollLeft -= t)
                }
                this.scrollAnimationFrame = requestAnimationFrame(this[Li])
            }
        }
    },
    ji.Sensors = {
        MouseSensor: class extends $t {
            constructor(t=[], e={}) {
                super(t, e),
                this.mouseDownTimeout = null,
                this.pageX = null,
                this.pageY = null,
                this[Xt] = this[Xt].bind(this),
                this[Gt] = this[Gt].bind(this),
                this[Jt] = this[Jt].bind(this),
                this[Kt] = this[Kt].bind(this),
                this[Qt] = this[Qt].bind(this),
                this[te] = this[te].bind(this)
            }
            attach() {
                document.addEventListener("mousedown", this[Gt], !0)
            }
            detach() {
                document.removeEventListener("mousedown", this[Gt], !0)
            }
            [Gt](t) {
                if (0 !== t.button || t.ctrlKey || t.metaKey)
                    return;
                const e = Bt(t.target, this.containers);
                if (!e)
                    return;
                if (this.options.handle && t.target && !Bt(t.target, this.options.handle))
                    return;
                const i = Bt(t.target, this.options.draggable);
                if (!i)
                    return;
                const {delay: s} = this
                  , {pageX: n, pageY: r} = t;
                Object.assign(this, {
                    pageX: n,
                    pageY: r
                }),
                this.onMouseDownAt = Date.now(),
                this.startEvent = t,
                this.currentContainer = e,
                this.originalSource = i,
                document.addEventListener("mouseup", this[Kt]),
                document.addEventListener("dragstart", ee),
                document.addEventListener("mousemove", this[te]),
                this.mouseDownTimeout = window.setTimeout(( () => {
                    this[te]({
                        pageX: this.pageX,
                        pageY: this.pageY
                    })
                }
                ), s.mouse)
            }
            [Qt]() {
                const t = this.startEvent
                  , e = this.currentContainer
                  , i = this.originalSource
                  , s = new qt({
                    clientX: t.clientX,
                    clientY: t.clientY,
                    target: t.target,
                    container: e,
                    originalSource: i,
                    originalEvent: t
                });
                this.trigger(this.currentContainer, s),
                this.dragging = !s.canceled(),
                this.dragging && (document.addEventListener("contextmenu", this[Xt], !0),
                document.addEventListener("mousemove", this[Jt]))
            }
            [te](t) {
                const {pageX: e, pageY: i} = t
                  , {distance: s} = this.options
                  , {startEvent: n, delay: r} = this;
                if (Object.assign(this, {
                    pageX: e,
                    pageY: i
                }),
                !this.currentContainer)
                    return;
                const o = Date.now() - this.onMouseDownAt
                  , a = Zt(n.pageX, n.pageY, e, i) || 0;
                clearTimeout(this.mouseDownTimeout),
                o < r.mouse ? document.removeEventListener("mousemove", this[te]) : a >= s && (document.removeEventListener("mousemove", this[te]),
                this[Qt]())
            }
            [Jt](t) {
                if (!this.dragging)
                    return;
                const e = document.elementFromPoint(t.clientX, t.clientY)
                  , i = new Ut({
                    clientX: t.clientX,
                    clientY: t.clientY,
                    target: e,
                    container: this.currentContainer,
                    originalEvent: t
                });
                this.trigger(this.currentContainer, i)
            }
            [Kt](t) {
                if (clearTimeout(this.mouseDownTimeout),
                0 !== t.button)
                    return;
                if (document.removeEventListener("mouseup", this[Kt]),
                document.removeEventListener("dragstart", ee),
                document.removeEventListener("mousemove", this[te]),
                !this.dragging)
                    return;
                const e = document.elementFromPoint(t.clientX, t.clientY)
                  , i = new Wt({
                    clientX: t.clientX,
                    clientY: t.clientY,
                    target: e,
                    container: this.currentContainer,
                    originalEvent: t
                });
                this.trigger(this.currentContainer, i),
                document.removeEventListener("contextmenu", this[Xt], !0),
                document.removeEventListener("mousemove", this[Jt]),
                this.currentContainer = null,
                this.dragging = !1,
                this.startEvent = null
            }
            [Xt](t) {
                t.preventDefault()
            }
        }
        ,
        TouchSensor: class extends $t {
            constructor(t=[], e={}) {
                super(t, e),
                this.currentScrollableParent = null,
                this.tapTimeout = null,
                this.touchMoved = !1,
                this.pageX = null,
                this.pageY = null,
                this[se] = this[se].bind(this),
                this[ne] = this[ne].bind(this),
                this[re] = this[re].bind(this),
                this[oe] = this[oe].bind(this),
                this[ae] = this[ae].bind(this)
            }
            attach() {
                document.addEventListener("touchstart", this[se])
            }
            detach() {
                document.removeEventListener("touchstart", this[se])
            }
            [se](t) {
                const e = Bt(t.target, this.containers);
                if (!e)
                    return;
                if (this.options.handle && t.target && !Bt(t.target, this.options.handle))
                    return;
                const i = Bt(t.target, this.options.draggable);
                if (!i)
                    return;
                const {distance: s=0} = this.options
                  , {delay: n} = this
                  , {pageX: r, pageY: o} = ie(t);
                Object.assign(this, {
                    pageX: r,
                    pageY: o
                }),
                this.onTouchStartAt = Date.now(),
                this.startEvent = t,
                this.currentContainer = e,
                this.originalSource = i,
                document.addEventListener("touchend", this[ne]),
                document.addEventListener("touchcancel", this[ne]),
                document.addEventListener("touchmove", this[ae]),
                e.addEventListener("contextmenu", ce),
                s && (le = !0),
                this.tapTimeout = window.setTimeout(( () => {
                    this[ae]({
                        touches: [{
                            pageX: this.pageX,
                            pageY: this.pageY
                        }]
                    })
                }
                ), n.touch)
            }
            [oe]() {
                const t = this.startEvent
                  , e = this.currentContainer
                  , i = ie(t)
                  , s = this.originalSource
                  , n = new qt({
                    clientX: i.pageX,
                    clientY: i.pageY,
                    target: t.target,
                    container: e,
                    originalSource: s,
                    originalEvent: t
                });
                this.trigger(this.currentContainer, n),
                this.dragging = !n.canceled(),
                this.dragging && document.addEventListener("touchmove", this[re]),
                le = this.dragging
            }
            [ae](t) {
                const {distance: e} = this.options
                  , {startEvent: i, delay: s} = this
                  , n = ie(i)
                  , r = ie(t)
                  , o = Date.now() - this.onTouchStartAt
                  , a = Zt(n.pageX, n.pageY, r.pageX, r.pageY);
                Object.assign(this, r),
                clearTimeout(this.tapTimeout),
                o < s.touch ? document.removeEventListener("touchmove", this[ae]) : a >= e && (document.removeEventListener("touchmove", this[ae]),
                this[oe]())
            }
            [re](t) {
                if (!this.dragging)
                    return;
                const {pageX: e, pageY: i} = ie(t)
                  , s = document.elementFromPoint(e - window.scrollX, i - window.scrollY)
                  , n = new Ut({
                    clientX: e,
                    clientY: i,
                    target: s,
                    container: this.currentContainer,
                    originalEvent: t
                });
                this.trigger(this.currentContainer, n)
            }
            [ne](t) {
                if (clearTimeout(this.tapTimeout),
                le = !1,
                document.removeEventListener("touchend", this[ne]),
                document.removeEventListener("touchcancel", this[ne]),
                document.removeEventListener("touchmove", this[ae]),
                this.currentContainer && this.currentContainer.removeEventListener("contextmenu", ce),
                !this.dragging)
                    return;
                document.removeEventListener("touchmove", this[re]);
                const {pageX: e, pageY: i} = ie(t)
                  , s = document.elementFromPoint(e - window.scrollX, i - window.scrollY);
                t.preventDefault();
                const n = new Wt({
                    clientX: e,
                    clientY: i,
                    target: s,
                    container: this.currentContainer,
                    originalEvent: t
                });
                this.trigger(this.currentContainer, n),
                this.currentContainer = null,
                this.dragging = !1,
                this.startEvent = null
            }
        }
    };
    class Bi extends Yt {
        constructor(t) {
            super(t),
            this.data = t
        }
        get dragEvent() {
            return this.data.dragEvent
        }
    }
    Bi.type = "droppable";
    class Zi extends Bi {
        get dropzone() {
            return this.data.dropzone
        }
    }
    Zi.type = "droppable:start",
    Zi.cancelable = !0;
    class Vi extends Bi {
        get dropzone() {
            return this.data.dropzone
        }
    }
    Vi.type = "droppable:dropped",
    Vi.cancelable = !0;
    class qi extends Bi {
        get dropzone() {
            return this.data.dropzone
        }
    }
    qi.type = "droppable:returned",
    qi.cancelable = !0;
    class Ui extends Bi {
        get dropzone() {
            return this.data.dropzone
        }
    }
    Ui.type = "droppable:stop",
    Ui.cancelable = !0;
    class Wi extends Yt {
        constructor(t) {
            super(t),
            this.data = t
        }
        get dragEvent() {
            return this.data.dragEvent
        }
    }
    Wi.type = "swappable";
    class Xi extends Wi {
    }
    Xi.type = "swappable:start",
    Xi.cancelable = !0;
    class Gi extends Wi {
        get over() {
            return this.data.over
        }
        get overContainer() {
            return this.data.overContainer
        }
    }
    Gi.type = "swappable:swap",
    Gi.cancelable = !0;
    class Ji extends Wi {
        get swappedElement() {
            return this.data.swappedElement
        }
    }
    Ji.type = "swappable:swapped";
    class Ki extends Wi {
    }
    Ki.type = "swappable:stop";
    const Qi = Symbol("onDragStart")
      , ts = Symbol("onDragOver")
      , es = Symbol("onDragStop");
    const is = {
        "swappabled:swapped": function({dragEvent: t, swappedElement: e}) {
            return `Swapped ${t.source.textContent.trim() || t.source.id || "swappable element"} with ${e.textContent.trim() || e.id || "swappable element"}`
        }
    };
    class ss extends ji {
        constructor(t=[], e={}) {
            super(t, {
                ...e,
                announcements: {
                    ...is,
                    ...e.announcements || {}
                }
            }),
            this.lastOver = null,
            this[Qi] = this[Qi].bind(this),
            this[ts] = this[ts].bind(this),
            this[es] = this[es].bind(this),
            this.on("drag:start", this[Qi]).on("drag:over", this[ts]).on("drag:stop", this[es])
        }
        destroy() {
            super.destroy(),
            this.off("drag:start", this._onDragStart).off("drag:over", this._onDragOver).off("drag:stop", this._onDragStop)
        }
        [Qi](t) {
            const e = new Xi({
                dragEvent: t
            });
            this.trigger(e),
            e.canceled() && t.cancel()
        }
        [ts](t) {
            if (t.over === t.originalSource || t.over === t.source || t.canceled())
                return;
            const e = new Gi({
                dragEvent: t,
                over: t.over,
                overContainer: t.overContainer
            });
            if (this.trigger(e),
            e.canceled())
                return;
            this.lastOver && this.lastOver !== t.over && ns(this.lastOver, t.source),
            this.lastOver === t.over ? this.lastOver = null : this.lastOver = t.over,
            ns(t.source, t.over);
            const i = new Ji({
                dragEvent: t,
                swappedElement: t.over
            });
            this.trigger(i)
        }
        [es](t) {
            const e = new Ki({
                dragEvent: t
            });
            this.trigger(e),
            this.lastOver = null
        }
    }
    function ns(t, e) {
        const i = e.parentNode
          , s = t.parentNode;
        !function(t) {
            const e = document.createElement("div");
            t(e),
            e.remove()
        }((n => {
            s.insertBefore(n, t),
            i.insertBefore(t, e),
            s.insertBefore(e, n)
        }
        ))
    }
    class rs extends Yt {
        constructor(t) {
            super(t),
            this.data = t
        }
        get dragEvent() {
            return this.data.dragEvent
        }
    }
    rs.type = "sortable";
    class os extends rs {
        get startIndex() {
            return this.data.startIndex
        }
        get startContainer() {
            return this.data.startContainer
        }
    }
    os.type = "sortable:start",
    os.cancelable = !0;
    class as extends rs {
        get currentIndex() {
            return this.data.currentIndex
        }
        get over() {
            return this.data.over
        }
        get overContainer() {
            return this.data.dragEvent.overContainer
        }
    }
    as.type = "sortable:sort",
    as.cancelable = !0;
    (class extends rs {
        get oldIndex() {
            return this.data.oldIndex
        }
        get newIndex() {
            return this.data.newIndex
        }
        get oldContainer() {
            return this.data.oldContainer
        }
        get newContainer() {
            return this.data.newContainer
        }
    }
    ).type = "sortable:sorted";
    (class extends rs {
        get oldIndex() {
            return this.data.oldIndex
        }
        get newIndex() {
            return this.data.newIndex
        }
        get oldContainer() {
            return this.data.oldContainer
        }
        get newContainer() {
            return this.data.newContainer
        }
    }
    ).type = "sortable:stop";
    let ls = !1;
    if ("undefined" != typeof window) {
        const t = {
            get passive() {
                ls = !0
            }
        };
        window.addEventListener("testPassive", null, t),
        window.removeEventListener("testPassive", null, t)
    }
    const cs = "undefined" != typeof window && window.navigator && window.navigator.platform && (/iP(ad|hone|od)/.test(window.navigator.platform) || "MacIntel" === window.navigator.platform && window.navigator.maxTouchPoints > 1);
    let hs, ds, us, ps, ms = [], fs = new Map, gs = !1, vs = -1;
    const ys = t => ms.some((e => !(!e.options.allowTouchMove || !e.options.allowTouchMove(t))))
      , _s = t => {
        const e = t || window.event;
        return !!ys(e.target) || (e.touches.length > 1 || (e.preventDefault && e.preventDefault(),
        !1))
    }
      , bs = (t, e) => {
        if (!t)
            return void console.error("disableBodyScroll unsuccessful - targetElement must be provided when calling disableBodyScroll on IOS devices.");
        if (fs.set(t, (null == fs ? void 0 : fs.get(t)) ? (null == fs ? void 0 : fs.get(t)) + 1 : 1),
        ms.some((e => e.targetElement === t)))
            return;
        const i = {
            targetElement: t,
            options: e || {}
        };
        ms = [...ms, i],
        cs ? window.requestAnimationFrame(( () => {
            const t = document.documentElement
              , e = document.body;
            if (void 0 === us) {
                ds = {
                    ...t.style
                },
                us = {
                    ...e.style
                };
                const {scrollY: i, scrollX: s, innerHeight: n} = window;
                t.style.height = "100%",
                t.style.overflow = "hidden",
                e.style.position = "fixed",
                e.style.top = -i + "px",
                e.style.left = -s + "px",
                e.style.width = "100%",
                e.style.height = "auto",
                e.style.overflow = "hidden",
                setTimeout(( () => window.requestAnimationFrame(( () => {
                    const t = n - window.innerHeight;
                    t && i >= n && (e.style.top = -(i + t) + "px")
                }
                ))), 300)
            }
        }
        )) : (t => {
            if (void 0 === ps) {
                const e = !!t && !0 === t.reserveScrollBarGap
                  , i = window.innerWidth - document.documentElement.getBoundingClientRect().width;
                if (e && i > 0) {
                    const t = parseInt(window.getComputedStyle(document.body).getPropertyValue("padding-right"), 10);
                    ps = document.body.style.paddingRight,
                    document.body.style.paddingRight = `${t + i}px`
                }
            }
            void 0 === hs && (hs = document.body.style.overflow,
            document.body.style.overflow = "hidden")
        }
        )(e),
        cs && (t.ontouchstart = t => {
            1 === t.targetTouches.length && (vs = t.targetTouches[0].clientY)
        }
        ,
        t.ontouchmove = e => {
            1 === e.targetTouches.length && ( (t, e) => {
                const i = t.targetTouches[0].clientY - vs;
                !ys(t.target) && (e && 0 === e.scrollTop && i > 0 || (t => !!t && t.scrollHeight - t.scrollTop <= t.clientHeight)(e) && i < 0 ? _s(t) : t.stopPropagation())
            }
            )(e, t)
        }
        ,
        gs || (document.addEventListener("touchmove", _s, ls ? {
            passive: !1
        } : void 0),
        gs = !0))
    }
      , ws = () => {
        cs && (ms.forEach((t => {
            t.targetElement.ontouchstart = null,
            t.targetElement.ontouchmove = null
        }
        )),
        gs && (document.removeEventListener("touchmove", _s, ls ? {
            passive: !1
        } : void 0),
        gs = !1),
        vs = -1),
        cs ? ( () => {
            if (void 0 !== us) {
                const t = -parseInt(document.body.style.top, 10)
                  , e = -parseInt(document.body.style.left, 10)
                  , i = document.documentElement
                  , s = document.body;
                i.style.height = (null == ds ? void 0 : ds.height) || "",
                i.style.overflow = (null == ds ? void 0 : ds.overflow) || "",
                s.style.position = us.position || "",
                s.style.top = us.top || "",
                s.style.left = us.left || "",
                s.style.width = us.width || "",
                s.style.height = us.height || "",
                s.style.overflow = us.overflow || "",
                window.scrollTo(e, t),
                us = void 0
            }
        }
        )() : (void 0 !== ps && (document.body.style.paddingRight = ps,
        ps = void 0),
        void 0 !== hs && (document.body.style.overflow = hs,
        hs = void 0)),
        ms = [],
        fs.clear()
    }
    ;
    let Ss = class {
        constructor(t, i, s, n, r) {
            this._app = t,
            this._elem = i,
            this._gallery = n,
            this._tinybind = s,
            this._config = r;
            let o = document.querySelector("[data-switch-apps-customer-gallery-custom-content-config]");
            o && (console.log(JSON.parse(o.innerHTML)),
            this._config = e.merge(this._config, JSON.parse(o.innerHTML)));
            let a = "image/png, image/jpeg, image/jpg, image/webp, image/gif"
              , l = "video/mp4, video/m4v, video/webm, video/ogg, video/avi, video/x-msvideo, video/quicktime";
            this._data = {
                loading: !1,
                submitPopupOpen: !1,
                gallery: this._gallery,
                error: !1,
                submitted: !1,
                mimeType: a,
                config: this._config
            },
            this._fileInput = this._elem.querySelector("[data-switch-apps-customer-gallery-file-input]"),
            this._triggers = document.querySelectorAll('[href="#customer-gallery-open"]'),
            this._form = this._elem.querySelector("form"),
            this._scrollElem = this._elem.querySelector("[data-switch-apps-gallery-scroll]"),
            "videos" === this._gallery?.settings?.media_mode && (this._data.mimeType = l),
            "photos_videos" === this._gallery?.settings?.media_mode && (this._data.mimeType = `${a}, ${l}`),
            this._imageMBLimit = this._gallery?.settings?.image_file_size_limit || 10,
            this._videoMBLimit = this._gallery?.settings?.video_file_size_limit || 100
        }
        async mount() {
            this.render(),
            this._doSwapElems(),
            document.addEventListener("click", (t => {
                this._data.productSearchResultsOpen = !1
            }
            )),
            "#customer-gallery-open" === window.location.hash && this.open();
            for (let t of this._triggers)
                t.addEventListener("click", (t => {
                    t.preventDefault(),
                    this.open()
                }
                ));
            this.preAddProduct()
        }
        showError({title: t, cta_url: e, cta_title: i}) {
            this._data.error = {
                title: t,
                cta_url: e,
                cta_title: i
            }
        }
        open() {
            this._gallery.settings.require_customer_login && !this._config.customerId ? this.showError({
                title: this._config.submission.error_titles.require_login_title,
                cta_title: this._config.submission.error_titles.require_login_cta_title,
                cta_url: this._config.submission.error_titles.require_login_cta_url
            }) : (this._data.submitPopupOpen = !0,
            bs(this._scrollElem)),
            this.whenPopupOpen()
        }
        _doSwapElems() {
            let t = this._elem.querySelectorAll("[data-switch-apps-gallery-swap]");
            for (let e of t)
                this._swap && this._swap.destroy(),
                this._swap = new ss(e,{
                    draggable: "li",
                    handle: ".switch-apps-gallery-file-preview-drag-handle",
                    mirror: {
                        constrainDimensions: !0
                    }
                }),
                this._swap.on("drag:stopped", ( () => {
                    let t = [];
                    for (let i of e.querySelectorAll("li"))
                        t.push(this._data.gallery.submission.media.find((t => t.uniqueId === i.getAttribute("position-id"))));
                    this._data.gallery.submission.media = t
                }
                ))
        }
        whenPopupOpen() {}
        whenPopupClose() {
            ws()
        }
        async preAddProduct() {
            if (this._config.preAddProduct) {
                let t = await r.getProduct(this._config.preAddProduct);
                console.log(t),
                t.selected_variant_id = t.variants?.[0]?.id,
                this._data.gallery.submission.products.push(t)
            }
        }
        async render() {
            let t = {
                data: this._data,
                controller: {
                    resizeTextarea: (t, e) => {
                        t.target.style.height = "auto";
                        let i = t.target.scrollHeight;
                        0 === t.target.value.length && (i = 75),
                        t.target.style.height = Math.ceil(i + 5) + "px"
                    }
                    ,
                    openSubmitPopup: async (t, e) => {
                        this.open()
                    }
                    ,
                    closeSubmitPopupOuter: async (t, e) => {
                        t.target.matches(".switch-apps-gallery--popup") && (this._data.submitPopupOpen = !1,
                        this.whenPopupClose())
                    }
                    ,
                    closeSubmitPopup: async (t, e) => {
                        this._data.submitPopupOpen = !1,
                        this.whenPopupClose()
                    }
                    ,
                    submitFieldChange: async (t, e) => {
                        this._data.gallery.fields = [...this._data.gallery.fields]
                    }
                    ,
                    nextStep: async (t, e) => {
                        let i = this._elem.querySelector(".switch-apps-gallery-form-step.switch-apps-show").querySelectorAll("input, select, textarea");
                        Array.from(i).every((t => t.reportValidity())) && (this._data.gallery.currentStep = this._data.gallery.submissionSteps[this._data.gallery.currentStep.index],
                        this._doSwapElems())
                    }
                    ,
                    previousStep: async (t, e) => {
                        this._data.gallery.currentStep = this._data.gallery.submissionSteps[this._data.gallery.currentStep.index - 2],
                        this._doSwapElems()
                    }
                    ,
                    goToStep: async (t, e) => {
                        let i = this._elem.querySelector(".switch-apps-gallery-form-step.switch-apps-show").querySelectorAll("input, select, textarea");
                        Array.from(i).every((t => t.reportValidity())) && (this._data.gallery.currentStep = e.step)
                    }
                    ,
                    dragOver: async (t, e) => {
                        t.preventDefault(),
                        t.stopPropagation(),
                        this._data.gallery.submissionDraggingOver = !0
                    }
                    ,
                    dragLeave: async (t, e) => {
                        t.preventDefault(),
                        t.stopPropagation(),
                        this._data.gallery.submissionDraggingOver = !1
                    }
                    ,
                    dragEnter: async (t, e) => {
                        t.preventDefault(),
                        t.stopPropagation()
                    }
                    ,
                    removeMedia: async (t, e) => {
                        t.preventDefault(),
                        t.stopPropagation(),
                        this._data.gallery.submission.media = [...this._data.gallery.submission.media.filter(( (t, i) => i !== e.$index))],
                        this._data.gallery.submission.mediaPreview = [...this._data.gallery.submission.mediaPreview.filter(( (t, i) => i !== e.$index))];
                        const i = new DataTransfer;
                        this._fileInput;
                        for (let t of this._data.gallery.submission.media)
                            i.items.add(t.file);
                        this._fileInput.files = i.files
                    }
                    ,
                    handleDrop: async (t, e) => {
                        t.preventDefault();
                        const i = t.dataTransfer.files;
                        if (i.length) {
                            const t = new DataTransfer;
                            for (let[e,s] of Array.from(i).entries())
                                this._data.mimeType.includes(s.type) && t.items.add(s);
                            this._fileInput.files = t.files,
                            this._fileInput.dispatchEvent(new Event("change"))
                        }
                        this._data.gallery.submissionDraggingOver = !1
                    }
                    ,
                    fileChange: async (t, e) => {
                        console.log(t.target.files);
                        let i = Array.from(t.target.files).filter((t => this._data.mimeType.includes(t.type)));
                        console.log(i),
                        this._data.filesLoading = !0;
                        let s = 0;
                        0 === i.length && (this._data.filesLoading = !1);
                        for (const [t,e] of i.entries()) {
                            const t = new FileReader;
                            t.onerror = () => {
                                console.error(t.error)
                            }
                            ,
                            t.onloadend = t => {
                                let n = Math.random().toString(36).substring(2, 7)
                                  , r = !1;
                                this._data.gallery.submission.media.length + 1 > Number(this._data.gallery.settings.photo_limit) && (this._data.error = {
                                    title: this._config.submission.error_titles.not_enough_media.replace("[x]", this._data.gallery.settings.photo_limit)
                                },
                                r = !0);
                                let o = this._imageMBLimit;
                                e.type.includes("video") && (o = this._videoMBLimit),
                                e.size >= 1024 * o * 1024 && (this._data.error = {
                                    title: this._config.submission.error_titles.media_too_big.replaceAll("[limit]", o)
                                },
                                r = !0),
                                console.log(e),
                                r || (this._data.gallery.submission.media.push({
                                    file: e,
                                    preview: t.target.result,
                                    uniqueId: n,
                                    type: e.type.split("/")[0]
                                }),
                                this._data.gallery.submission.mediaPreview.push({
                                    file: e,
                                    preview: t.target.result,
                                    uniqueId: n,
                                    type: e.type.split("/")[0]
                                }),
                                this._doSwapElems()),
                                s++,
                                s === i.length && (this._data.filesLoading = !1)
                            }
                            ,
                            t.readAsDataURL(e)
                        }
                        this._doSwapElems()
                    }
                    ,
                    submitForm: async (t, e) => {
                        try {
                            t.preventDefault();
                            let e = this._elem.querySelector(".switch-apps-gallery-form-step.switch-apps-show").querySelectorAll("input, select, textarea");
                            if (Array.from(e).every((t => t.reportValidity()))) {
                                this._data.submitting = !0;
                                let t = new FormData(this._form);
                                if (t.append("products", JSON.stringify(this._data.gallery.submission.products.map((t => ({
                                    handle: t.handle,
                                    id: t.id,
                                    selected_variant_id: t.selected_variant_id ? Number(t.selected_variant_id) : null
                                }))))),
                                0 === this._data.gallery.submission.media.length)
                                    throw new Error(this._config.submission.error_titles.no_media);
                                if (this._data.gallery.submission.media.length > Number(this._data.gallery.settings.photo_limit))
                                    throw new Error(this._config.submission.error_titles.not_enough_media.replace("[x]", this._data.gallery.settings.photo_limit));
                                for (let t of this._data.gallery.submission.media) {
                                    let e = this._imageMBLimit;
                                    if (t.file.type.includes("video") && (e = this._videoMBLimit),
                                    t.file.size >= 1024 * e * 1024)
                                        throw new Error(this._config.submission.error_titles.media_too_big.replaceAll("[limit]", e))
                                }
                                for (let t of this._data.gallery.fields) {
                                    t.originalLabel || t.label;
                                    if ((t.is_title || t.is_required) && !t.value)
                                        throw this._data.gallery.currentStep = this._data.gallery.submissionSteps[this._data.gallery.currentStep.index - 2],
                                        this._doSwapElems(),
                                        new Error(this._config.submission.error_titles.field_required.replace("[x]", t.label))
                                }
                                localStorage.setItem("CUSTOMER_GALLERY_DISPLAY_NAME", this._data.gallery.submission.display_name),
                                localStorage.setItem("CUSTOMER_GALLERY_EMAIL", this._data.gallery.submission.email),
                                t.append("frontend_page_url", `${window.location.href}#customerGallery`),
                                this._config.customerId && t.append("customer", `gid://shopify/Customer/${this._config.customerId}`);
                                const e = new DataTransfer
                                  , {files: i} = this._fileInput;
                                for (let i of this._data.gallery.submission.media)
                                    e.items.add(i.file),
                                    t.append("media[]", i.file, i.file.name);
                                this._fileInput.files = e.files;
                                let {data: s} = await Rt.post(`${this._app._appHost}/api/public/galleries/${this._data.gallery.id}/gallery-items?shop=${window.Shopify.shop}`, t);
                                this._data.submitted = !0
                            }
                        } catch (t) {
                            console.error(t),
                            this._data.error = {
                                title: t.message
                            }
                        } finally {
                            this._data.submitting = !1
                        }
                    }
                    ,
                    productSearch: async (t, e) => {
                        let i = await r.searchProducts(this._data.productSearch);
                        this._data.productSearchResults = i?.resources?.results?.products?.filter((t => !this._data.gallery.submission.products.find((e => e.id === t.id)))) ?? [],
                        this._data.productSearchResultsOpen = !0
                    }
                    ,
                    productSearchClick: async (t, e) => {
                        if (t.preventDefault(),
                        t.stopPropagation(),
                        !this._data.gallery.submission.products.find((t => t.id === e.product.id))) {
                            let t = {
                                ...e.product
                            };
                            t.selected_variant_id = null,
                            this._data.gallery.submission.products.push(t),
                            new Promise((async () => {
                                let e = await r.getProduct(t.handle);
                                console.log(e),
                                t.images = e.images,
                                t.variants = e.variants,
                                t.selected_variant_id = t.variants?.[0]?.id,
                                t.hasOnlyDefaultVariant = e.hasOnlyDefaultVariant
                            }
                            ))
                        }
                        this._data.productSearch = "",
                        this._data.productSearchResultsOpen = !1
                    }
                    ,
                    productSearchRemoveClick: async (t, e) => {
                        this._data.gallery.submission.products = [...this._data.gallery.submission.products.filter(( (t, i) => i !== e.$index))]
                    }
                    ,
                    searchClick: async (t, e) => {
                        t.preventDefault(),
                        t.stopPropagation(),
                        this._data.productSearchResultsOpen = !0
                    }
                    ,
                    clearError: async (t, e) => {
                        t.preventDefault(),
                        this._data.error = !1
                    }
                    ,
                    clearErrorOuter: async (t, e) => {
                        t.target.matches(".switch-apps-gallery--error-popup") && (this._data.error = !1)
                    }
                }
            };
            this._tinybind.bind(this._elem, t)
        }
    }
    ;
    function Es(t) {
        return "number" == typeof t
    }
    function xs(t) {
        return "string" == typeof t
    }
    function Ls(t) {
        return "boolean" == typeof t
    }
    function Os(t) {
        return "[object Object]" === Object.prototype.toString.call(t)
    }
    function Ps(t) {
        return Math.abs(t)
    }
    function Cs(t) {
        return Math.sign(t)
    }
    function As(t, e) {
        return Ps(t - e)
    }
    function Ms(t) {
        return zs(t).map(Number)
    }
    function Ts(t) {
        return t[Is(t)]
    }
    function Is(t) {
        return Math.max(0, t.length - 1)
    }
    function Ds(t, e) {
        return e === Is(t)
    }
    function ks(t, e=0) {
        return Array.from(Array(t), ( (t, i) => e + i))
    }
    function zs(t) {
        return Object.keys(t)
    }
    function Fs(t, e) {
        return [t, e].reduce(( (t, e) => (zs(e).forEach((i => {
            const s = t[i]
              , n = e[i]
              , r = Os(s) && Os(n);
            t[i] = r ? Fs(s, n) : n
        }
        )),
        t)), {})
    }
    function Ns(t, e) {
        return void 0 !== e.MouseEvent && t instanceof e.MouseEvent
    }
    function Rs() {
        let t = [];
        const e = {
            add: function(i, s, n, r={
                passive: !0
            }) {
                let o;
                if ("addEventListener"in i)
                    i.addEventListener(s, n, r),
                    o = () => i.removeEventListener(s, n, r);
                else {
                    const t = i;
                    t.addListener(n),
                    o = () => t.removeListener(n)
                }
                return t.push(o),
                e
            },
            clear: function() {
                t = t.filter((t => t()))
            }
        };
        return e
    }
    function Ys(t, e, i, s) {
        const n = Rs()
          , r = 1e3 / 60;
        let o = null
          , a = 0
          , l = 0;
        function c(t) {
            if (!l)
                return;
            o || (o = t,
            i(),
            i());
            const n = t - o;
            for (o = t,
            a += n; a >= r; )
                i(),
                a -= r;
            s(a / r),
            l && (l = e.requestAnimationFrame(c))
        }
        function h() {
            e.cancelAnimationFrame(l),
            o = null,
            a = 0,
            l = 0
        }
        return {
            init: function() {
                n.add(t, "visibilitychange", ( () => {
                    t.hidden && (o = null,
                    a = 0)
                }
                ))
            },
            destroy: function() {
                h(),
                n.clear()
            },
            start: function() {
                l || (l = e.requestAnimationFrame(c))
            },
            stop: h,
            update: i,
            render: s
        }
    }
    function js(t=0, e=0) {
        const i = Ps(t - e);
        function s(e) {
            return e < t
        }
        function n(t) {
            return t > e
        }
        function r(t) {
            return s(t) || n(t)
        }
        return {
            length: i,
            max: e,
            min: t,
            constrain: function(i) {
                return r(i) ? s(i) ? t : e : i
            },
            reachedAny: r,
            reachedMax: n,
            reachedMin: s,
            removeOffset: function(t) {
                return i ? t - i * Math.ceil((t - e) / i) : t
            }
        }
    }
    function Hs(t, e, i) {
        const {constrain: s} = js(0, t)
          , n = t + 1;
        let r = o(e);
        function o(t) {
            return i ? Ps((n + t) % n) : s(t)
        }
        function a() {
            return r
        }
        function l() {
            return Hs(t, a(), i)
        }
        const c = {
            get: a,
            set: function(t) {
                return r = o(t),
                c
            },
            add: function(t) {
                return l().set(a() + t)
            },
            clone: l
        };
        return c
    }
    function $s(t, e, i, s, n, r, o, a, l, c, h, d, u, p, m, f, g, v, y) {
        const {cross: _, direction: b} = t
          , w = ["INPUT", "SELECT", "TEXTAREA"]
          , S = {
            passive: !1
        }
          , E = Rs()
          , x = Rs()
          , L = js(50, 225).constrain(p.measure(20))
          , O = {
            mouse: 300,
            touch: 400
        }
          , P = {
            mouse: 500,
            touch: 600
        }
          , C = m ? 43 : 25;
        let A = !1
          , M = 0
          , T = 0
          , I = !1
          , D = !1
          , k = !1
          , z = !1;
        function F(t) {
            if (!Ns(t, s) && t.touches.length >= 2)
                return N(t);
            const e = r.readPoint(t)
              , i = r.readPoint(t, _)
              , o = As(e, M)
              , l = As(i, T);
            if (!D && !z) {
                if (!t.cancelable)
                    return N(t);
                if (D = o > l,
                !D)
                    return N(t)
            }
            const h = r.pointerMove(t);
            o > f && (k = !0),
            c.useFriction(.3).useDuration(.75),
            a.start(),
            n.add(b(h)),
            t.preventDefault()
        }
        function N(t) {
            const e = h.byDistance(0, !1).index !== d.get()
              , i = r.pointerUp(t) * (m ? P : O)[z ? "mouse" : "touch"]
              , s = function(t, e) {
                const i = d.add(-1 * Cs(t))
                  , s = h.byDistance(t, !m).distance;
                return m || Ps(t) < L ? s : g && e ? .5 * s : h.byIndex(i.get(), 0).distance
            }(b(i), e)
              , n = function(t, e) {
                if (0 === t || 0 === e)
                    return 0;
                if (Ps(t) <= Ps(e))
                    return 0;
                const i = As(Ps(t), Ps(e));
                return Ps(i / t)
            }(i, s)
              , o = C - 10 * n
              , a = v + n / 50;
            D = !1,
            I = !1,
            x.clear(),
            c.useDuration(o).useFriction(a),
            l.distance(s, !m),
            z = !1,
            u.emit("pointerUp")
        }
        function R(t) {
            k && (t.stopPropagation(),
            t.preventDefault(),
            k = !1)
        }
        return {
            init: function(t) {
                if (!y)
                    return;
                function a(a) {
                    (Ls(y) || y(t, a)) && function(t) {
                        const a = Ns(t, s);
                        if (z = a,
                        k = m && a && !t.buttons && A,
                        A = As(n.get(), o.get()) >= 2,
                        a && 0 !== t.button)
                            return;
                        if (function(t) {
                            const e = t.nodeName || "";
                            return w.includes(e)
                        }(t.target))
                            return;
                        I = !0,
                        r.pointerDown(t),
                        c.useFriction(0).useDuration(0),
                        n.set(o),
                        function() {
                            const t = z ? i : e;
                            x.add(t, "touchmove", F, S).add(t, "touchend", N).add(t, "mousemove", F, S).add(t, "mouseup", N)
                        }(),
                        M = r.readPoint(t),
                        T = r.readPoint(t, _),
                        u.emit("pointerDown")
                    }(a)
                }
                const l = e;
                E.add(l, "dragstart", (t => t.preventDefault()), S).add(l, "touchmove", ( () => {}
                ), S).add(l, "touchend", ( () => {}
                )).add(l, "touchstart", a).add(l, "mousedown", a).add(l, "touchcancel", N).add(l, "contextmenu", N).add(l, "click", R, !0)
            },
            destroy: function() {
                E.clear(),
                x.clear()
            },
            pointerDown: function() {
                return I
            }
        }
    }
    function Bs(t, e) {
        let i, s;
        function n(t) {
            return t.timeStamp
        }
        function r(i, s) {
            const n = "client" + ("x" === (s || t.scroll) ? "X" : "Y");
            return (Ns(i, e) ? i : i.touches[0])[n]
        }
        return {
            pointerDown: function(t) {
                return i = t,
                s = t,
                r(t)
            },
            pointerMove: function(t) {
                const e = r(t) - r(s)
                  , o = n(t) - n(i) > 170;
                return s = t,
                o && (i = t),
                e
            },
            pointerUp: function(t) {
                if (!i || !s)
                    return 0;
                const e = r(s) - r(i)
                  , o = n(t) - n(i)
                  , a = n(t) - n(s) > 170
                  , l = e / o;
                return o && !a && Ps(l) > .1 ? l : 0
            },
            readPoint: r
        }
    }
    function Zs(t, e, i, s, n, r, o) {
        const a = [t].concat(s);
        let l, c, h = [], d = !1;
        function u(t) {
            return n.measureSize(o.measure(t))
        }
        return {
            init: function(n) {
                r && (c = u(t),
                h = s.map(u),
                l = new ResizeObserver((i => {
                    (Ls(r) || r(n, i)) && function(i) {
                        for (const r of i) {
                            if (d)
                                return;
                            const i = r.target === t
                              , o = s.indexOf(r.target)
                              , a = i ? c : h[o];
                            if (Ps(u(i ? t : s[o]) - a) >= .5) {
                                n.reInit(),
                                e.emit("resize");
                                break
                            }
                        }
                    }(i)
                }
                )),
                i.requestAnimationFrame(( () => {
                    a.forEach((t => l.observe(t)))
                }
                )))
            },
            destroy: function() {
                d = !0,
                l && l.disconnect()
            }
        }
    }
    function Vs(t, e, i, s, n) {
        const r = n.measure(10)
          , o = n.measure(50)
          , a = js(.1, .99);
        let l = !1;
        function c() {
            return !l && (!!t.reachedAny(i.get()) && !!t.reachedAny(e.get()))
        }
        return {
            shouldConstrain: c,
            constrain: function(n) {
                if (!c())
                    return;
                const l = t.reachedMin(e.get()) ? "min" : "max"
                  , h = Ps(t[l] - e.get())
                  , d = i.get() - e.get()
                  , u = a.constrain(h / o);
                i.subtract(d * u),
                !n && Ps(d) < r && (i.set(t.constrain(i.get())),
                s.useDuration(25).useBaseFriction())
            },
            toggleActive: function(t) {
                l = !t
            }
        }
    }
    function qs(t, e, i, s) {
        const n = e.min + .1
          , r = e.max + .1
          , {reachedMin: o, reachedMax: a} = js(n, r);
        return {
            loop: function(e) {
                if (!function(t) {
                    return 1 === t ? a(i.get()) : -1 === t && o(i.get())
                }(e))
                    return;
                const n = t * (-1 * e);
                s.forEach((t => t.add(n)))
            }
        }
    }
    function Us(t, e, i, s, n) {
        const {reachedAny: r, removeOffset: o, constrain: a} = s;
        function l(t) {
            return t.concat().sort(( (t, e) => Ps(t) - Ps(e)))[0]
        }
        function c(e, s) {
            const n = [e, e + i, e - i];
            if (!t)
                return e;
            if (!s)
                return l(n);
            const r = n.filter((t => Cs(t) === s));
            return r.length ? l(r) : Ts(n) - i
        }
        const h = {
            byDistance: function(i, s) {
                const l = n.get() + i
                  , {index: h, distance: d} = function(i) {
                    const s = t ? o(i) : a(i)
                      , n = e.map(( (t, e) => ({
                        diff: c(t - s, 0),
                        index: e
                    }))).sort(( (t, e) => Ps(t.diff) - Ps(e.diff)))
                      , {index: r} = n[0];
                    return {
                        index: r,
                        distance: s
                    }
                }(l)
                  , u = !t && r(l);
                return !s || u ? {
                    index: h,
                    distance: i
                } : {
                    index: h,
                    distance: i + c(e[h] - d, 0)
                }
            },
            byIndex: function(t, i) {
                return {
                    index: t,
                    distance: c(e[t] - n.get(), i)
                }
            },
            shortcut: c
        };
        return h
    }
    function Ws(t, e, i, s, n, r, o, a) {
        const l = {
            passive: !0,
            capture: !0
        };
        let c = 0;
        function h(t) {
            "Tab" === t.code && (c = (new Date).getTime())
        }
        return {
            init: function(d) {
                a && (r.add(document, "keydown", h, !1),
                e.forEach(( (e, h) => {
                    r.add(e, "focus", (e => {
                        (Ls(a) || a(d, e)) && function(e) {
                            if ((new Date).getTime() - c > 10)
                                return;
                            o.emit("slideFocusStart"),
                            t.scrollLeft = 0;
                            const r = i.findIndex((t => t.includes(e)));
                            Es(r) && (n.useDuration(0),
                            s.index(r, 0),
                            o.emit("slideFocus"))
                        }(h)
                    }
                    ), l)
                }
                )))
            }
        }
    }
    function Xs(t) {
        let e = t;
        function i(t) {
            return Es(t) ? t : t.get()
        }
        return {
            get: function() {
                return e
            },
            set: function(t) {
                e = i(t)
            },
            add: function(t) {
                e += i(t)
            },
            subtract: function(t) {
                e -= i(t)
            }
        }
    }
    function Gs(t, e) {
        const i = "x" === t.scroll ? function(t) {
            return `translate3d(${t}px,0px,0px)`
        }
        : function(t) {
            return `translate3d(0px,${t}px,0px)`
        }
          , s = e.style;
        let n = null
          , r = !1;
        return {
            clear: function() {
                r || (s.transform = "",
                e.getAttribute("style") || e.removeAttribute("style"))
            },
            to: function(e) {
                if (r)
                    return;
                const o = (a = t.direction(e),
                Math.round(100 * a) / 100);
                var a;
                o !== n && (s.transform = i(o),
                n = o)
            },
            toggleActive: function(t) {
                r = !t
            }
        }
    }
    function Js(t, e, i, s, n, r, o, a, l) {
        const c = .5
          , h = Ms(n)
          , d = Ms(n).reverse()
          , u = function() {
            const t = o[0];
            return f(m(d, t), i, !1)
        }().concat(function() {
            const t = e - o[0] - 1;
            return f(m(h, t), -i, !0)
        }());
        function p(t, e) {
            return t.reduce(( (t, e) => t - n[e]), e)
        }
        function m(t, e) {
            return t.reduce(( (t, i) => p(t, e) > 0 ? t.concat([i]) : t), [])
        }
        function f(n, o, h) {
            const d = function(t) {
                return r.map(( (i, n) => ({
                    start: i - s[n] + c + t,
                    end: i + e - c + t
                })))
            }(o);
            return n.map((e => {
                const s = h ? 0 : -i
                  , n = h ? i : 0
                  , r = h ? "end" : "start"
                  , o = d[e][r];
                return {
                    index: e,
                    loopPoint: o,
                    slideLocation: Xs(-1),
                    translate: Gs(t, l[e]),
                    target: () => a.get() > o ? s : n
                }
            }
            ))
        }
        return {
            canLoop: function() {
                return u.every(( ({index: t}) => p(h.filter((e => e !== t)), e) <= .1))
            },
            clear: function() {
                u.forEach((t => t.translate.clear()))
            },
            loop: function() {
                u.forEach((t => {
                    const {target: e, translate: i, slideLocation: s} = t
                      , n = e();
                    n !== s.get() && (i.to(n),
                    s.set(n))
                }
                ))
            },
            loopPoints: u
        }
    }
    function Ks(t, e, i) {
        let s, n = !1;
        return {
            init: function(r) {
                i && (s = new MutationObserver((t => {
                    n || (Ls(i) || i(r, t)) && function(t) {
                        for (const i of t)
                            if ("childList" === i.type) {
                                r.reInit(),
                                e.emit("slidesChanged");
                                break
                            }
                    }(t)
                }
                )),
                s.observe(t, {
                    childList: !0
                }))
            },
            destroy: function() {
                s && s.disconnect(),
                n = !0
            }
        }
    }
    function Qs(t, e, i, s) {
        const n = {};
        let r, o = null, a = null, l = !1;
        return {
            init: function() {
                r = new IntersectionObserver((t => {
                    l || (t.forEach((t => {
                        const i = e.indexOf(t.target);
                        n[i] = t
                    }
                    )),
                    o = null,
                    a = null,
                    i.emit("slidesInView"))
                }
                ),{
                    root: t.parentElement,
                    threshold: s
                }),
                e.forEach((t => r.observe(t)))
            },
            destroy: function() {
                r && r.disconnect(),
                l = !0
            },
            get: function(t=!0) {
                if (t && o)
                    return o;
                if (!t && a)
                    return a;
                const e = function(t) {
                    return zs(n).reduce(( (e, i) => {
                        const s = parseInt(i)
                          , {isIntersecting: r} = n[s];
                        return (t && r || !t && !r) && e.push(s),
                        e
                    }
                    ), [])
                }(t);
                return t && (o = e),
                t || (a = e),
                e
            }
        }
    }
    function tn(t, e, i, s, n, r, o, a, l) {
        const {startEdge: c, endEdge: h, direction: d} = t
          , u = Es(i);
        return {
            groupSlides: function(t) {
                return u ? function(t, e) {
                    return Ms(t).filter((t => t % e == 0)).map((i => t.slice(i, i + e)))
                }(t, i) : function(t) {
                    return t.length ? Ms(t).reduce(( (i, u, p) => {
                        const m = Ts(i) || 0
                          , f = 0 === m
                          , g = u === Is(t)
                          , v = n[c] - r[m][c]
                          , y = n[c] - r[u][h]
                          , _ = !s && f ? d(o) : 0
                          , b = Ps(y - (!s && g ? d(a) : 0) - (v + _));
                        return p && b > e + l && i.push(u),
                        g && i.push(t.length),
                        i
                    }
                    ), []).map(( (e, i, s) => {
                        const n = Math.max(s[i - 1] || 0);
                        return t.slice(n, e)
                    }
                    )) : []
                }(t)
            }
        }
    }
    function en(t, e, i, s, n, r, o) {
        const {align: a, axis: l, direction: c, startIndex: h, loop: d, duration: u, dragFree: p, dragThreshold: m, inViewThreshold: f, slidesToScroll: g, skipSnaps: v, containScroll: y, watchResize: _, watchSlides: b, watchDrag: w, watchFocus: S} = r
          , E = {
            measure: function(t) {
                const {offsetTop: e, offsetLeft: i, offsetWidth: s, offsetHeight: n} = t;
                return {
                    top: e,
                    right: i + s,
                    bottom: e + n,
                    left: i,
                    width: s,
                    height: n
                }
            }
        }
          , x = E.measure(e)
          , L = i.map(E.measure)
          , O = function(t, e) {
            const i = "rtl" === e
              , s = "y" === t
              , n = !s && i ? -1 : 1;
            return {
                scroll: s ? "y" : "x",
                cross: s ? "x" : "y",
                startEdge: s ? "top" : i ? "right" : "left",
                endEdge: s ? "bottom" : i ? "left" : "right",
                measureSize: function(t) {
                    const {height: e, width: i} = t;
                    return s ? e : i
                },
                direction: function(t) {
                    return t * n
                }
            }
        }(l, c)
          , P = O.measureSize(x)
          , C = function(t) {
            return {
                measure: function(e) {
                    return t * (e / 100)
                }
            }
        }(P)
          , A = function(t, e) {
            const i = {
                start: function() {
                    return 0
                },
                center: function(t) {
                    return s(t) / 2
                },
                end: s
            };
            function s(t) {
                return e - t
            }
            return {
                measure: function(s, n) {
                    return xs(t) ? i[t](s) : t(e, s, n)
                }
            }
        }(a, P)
          , M = !d && !!y
          , T = d || !!y
          , {slideSizes: I, slideSizesWithGaps: D, startGap: k, endGap: z} = function(t, e, i, s, n, r) {
            const {measureSize: o, startEdge: a, endEdge: l} = t
              , c = i[0] && n
              , h = function() {
                if (!c)
                    return 0;
                const t = i[0];
                return Ps(e[a] - t[a])
            }()
              , d = function() {
                if (!c)
                    return 0;
                const t = r.getComputedStyle(Ts(s));
                return parseFloat(t.getPropertyValue(`margin-${l}`))
            }()
              , u = i.map(o)
              , p = i.map(( (t, e, i) => {
                const s = !e
                  , n = Ds(i, e);
                return s ? u[e] + h : n ? u[e] + d : i[e + 1][a] - t[a]
            }
            )).map(Ps);
            return {
                slideSizes: u,
                slideSizesWithGaps: p,
                startGap: h,
                endGap: d
            }
        }(O, x, L, i, T, n)
          , F = tn(O, P, g, d, x, L, k, z, 2)
          , {snaps: N, snapsAligned: R} = function(t, e, i, s, n) {
            const {startEdge: r, endEdge: o} = t
              , {groupSlides: a} = n
              , l = a(s).map((t => Ts(t)[o] - t[0][r])).map(Ps).map(e.measure)
              , c = s.map((t => i[r] - t[r])).map((t => -Ps(t)))
              , h = a(c).map((t => t[0])).map(( (t, e) => t + l[e]));
            return {
                snaps: c,
                snapsAligned: h
            }
        }(O, A, x, L, F)
          , Y = -Ts(N) + Ts(D)
          , {snapsContained: j, scrollContainLimit: H} = function(t, e, i, s, n) {
            const r = js(-e + t, 0)
              , o = i.map(( (t, e) => {
                const {min: s, max: n} = r
                  , o = r.constrain(t)
                  , a = !e
                  , c = Ds(i, e);
                return a ? n : c || l(s, o) ? s : l(n, o) ? n : o
            }
            )).map((t => parseFloat(t.toFixed(3))))
              , a = function() {
                const t = o[0]
                  , e = Ts(o);
                return js(o.lastIndexOf(t), o.indexOf(e) + 1)
            }();
            function l(t, e) {
                return As(t, e) <= 1
            }
            return {
                snapsContained: function() {
                    if (e <= t + n)
                        return [r.max];
                    if ("keepSnaps" === s)
                        return o;
                    const {min: i, max: l} = a;
                    return o.slice(i, l)
                }(),
                scrollContainLimit: a
            }
        }(P, Y, R, y, 2)
          , $ = M ? j : R
          , {limit: B} = function(t, e, i) {
            const s = e[0];
            return {
                limit: js(i ? s - t : Ts(e), s)
            }
        }(Y, $, d)
          , Z = Hs(Is($), h, d)
          , V = Z.clone()
          , q = Ms(i)
          , U = Ys(s, n, ( () => ( ({dragHandler: t, scrollBody: e, scrollBounds: i, options: {loop: s}}) => {
            s || i.constrain(t.pointerDown()),
            e.seek()
        }
        )(at)), (t => ( ({scrollBody: t, translate: e, location: i, offsetLocation: s, previousLocation: n, scrollLooper: r, slideLooper: o, dragHandler: a, animation: l, eventHandler: c, scrollBounds: h, options: {loop: d}}, u) => {
            const p = t.settled()
              , m = !h.shouldConstrain()
              , f = d ? p : p && m;
            f && !a.pointerDown() && (l.stop(),
            c.emit("settle")),
            f || c.emit("scroll");
            const g = i.get() * u + n.get() * (1 - u);
            s.set(g),
            d && (r.loop(t.direction()),
            o.loop()),
            e.to(s.get())
        }
        )(at, t)))
          , W = $[Z.get()]
          , X = Xs(W)
          , G = Xs(W)
          , J = Xs(W)
          , K = Xs(W)
          , Q = function(t, e, i, s, n, r) {
            let o = 0
              , a = 0
              , l = n
              , c = r
              , h = t.get()
              , d = 0;
            function u(t) {
                return l = t,
                m
            }
            function p(t) {
                return c = t,
                m
            }
            const m = {
                direction: function() {
                    return a
                },
                duration: function() {
                    return l
                },
                velocity: function() {
                    return o
                },
                seek: function() {
                    const e = s.get() - t.get();
                    let n = 0;
                    return l ? (i.set(t),
                    o += e / l,
                    o *= c,
                    h += o,
                    t.add(o),
                    n = h - d) : (o = 0,
                    i.set(s),
                    t.set(s),
                    n = e),
                    a = Cs(n),
                    d = h,
                    m
                },
                settled: function() {
                    return Ps(s.get() - e.get()) < .001
                },
                useBaseFriction: function() {
                    return p(r)
                },
                useBaseDuration: function() {
                    return u(n)
                },
                useFriction: p,
                useDuration: u
            };
            return m
        }(X, J, G, K, u, .68)
          , tt = Us(d, $, Y, B, K)
          , et = function(t, e, i, s, n, r, o) {
            function a(n) {
                const a = n.distance
                  , l = n.index !== e.get();
                r.add(a),
                a && (s.duration() ? t.start() : (t.update(),
                t.render(1),
                t.update())),
                l && (i.set(e.get()),
                e.set(n.index),
                o.emit("select"))
            }
            return {
                distance: function(t, e) {
                    a(n.byDistance(t, e))
                },
                index: function(t, i) {
                    const s = e.clone().set(t);
                    a(n.byIndex(s.get(), i))
                }
            }
        }(U, Z, V, Q, tt, K, o)
          , it = function(t) {
            const {max: e, length: i} = t;
            return {
                get: function(t) {
                    return i ? (t - e) / -i : 0
                }
            }
        }(B)
          , st = Rs()
          , nt = Qs(e, i, o, f)
          , {slideRegistry: rt} = function(t, e, i, s, n, r) {
            const {groupSlides: o} = n
              , {min: a, max: l} = s;
            return {
                slideRegistry: function() {
                    const s = o(r)
                      , n = !t || "keepSnaps" === e;
                    return 1 === i.length ? [r] : n ? s : s.slice(a, l).map(( (t, e, i) => {
                        const s = !e
                          , n = Ds(i, e);
                        return s ? ks(Ts(i[0]) + 1) : n ? ks(Is(r) - Ts(i)[0] + 1, Ts(i)[0]) : t
                    }
                    ))
                }()
            }
        }(M, y, $, H, F, q)
          , ot = Ws(t, i, rt, et, Q, st, o, S)
          , at = {
            ownerDocument: s,
            ownerWindow: n,
            eventHandler: o,
            containerRect: x,
            slideRects: L,
            animation: U,
            axis: O,
            dragHandler: $s(O, t, s, n, K, Bs(O, n), X, U, et, Q, tt, Z, o, C, p, m, v, .68, w),
            eventStore: st,
            percentOfView: C,
            index: Z,
            indexPrevious: V,
            limit: B,
            location: X,
            offsetLocation: J,
            previousLocation: G,
            options: r,
            resizeHandler: Zs(e, o, n, i, O, _, E),
            scrollBody: Q,
            scrollBounds: Vs(B, J, K, Q, C),
            scrollLooper: qs(Y, B, J, [X, J, G, K]),
            scrollProgress: it,
            scrollSnapList: $.map(it.get),
            scrollSnaps: $,
            scrollTarget: tt,
            scrollTo: et,
            slideLooper: Js(O, P, Y, I, D, N, $, J, i),
            slideFocus: ot,
            slidesHandler: Ks(e, o, b),
            slidesInView: nt,
            slideIndexes: q,
            slideRegistry: rt,
            slidesToScroll: F,
            target: K,
            translate: Gs(O, e)
        };
        return at
    }
    const sn = {
        align: "center",
        axis: "x",
        container: null,
        slides: null,
        containScroll: "trimSnaps",
        direction: "ltr",
        slidesToScroll: 1,
        inViewThreshold: 0,
        breakpoints: {},
        dragFree: !1,
        dragThreshold: 10,
        loop: !1,
        skipSnaps: !1,
        duration: 25,
        startIndex: 0,
        active: !0,
        watchDrag: !0,
        watchResize: !0,
        watchSlides: !0,
        watchFocus: !0
    };
    function nn(t) {
        function e(t, e) {
            return Fs(t, e || {})
        }
        const i = {
            mergeOptions: e,
            optionsAtMedia: function(i) {
                const s = i.breakpoints || {}
                  , n = zs(s).filter((e => t.matchMedia(e).matches)).map((t => s[t])).reduce(( (t, i) => e(t, i)), {});
                return e(i, n)
            },
            optionsMediaQueries: function(e) {
                return e.map((t => zs(t.breakpoints || {}))).reduce(( (t, e) => t.concat(e)), []).map(t.matchMedia)
            }
        };
        return i
    }
    function rn(t, e, i) {
        const s = t.ownerDocument
          , n = s.defaultView
          , r = nn(n)
          , o = function(t) {
            let e = [];
            return {
                init: function(i, s) {
                    return e = s.filter(( ({options: e}) => !1 !== t.optionsAtMedia(e).active)),
                    e.forEach((e => e.init(i, t))),
                    s.reduce(( (t, e) => Object.assign(t, {
                        [e.name]: e
                    })), {})
                },
                destroy: function() {
                    e = e.filter((t => t.destroy()))
                }
            }
        }(r)
          , a = Rs()
          , l = function() {
            let t, e = {};
            function i(t) {
                return e[t] || []
            }
            const s = {
                init: function(e) {
                    t = e
                },
                emit: function(e) {
                    return i(e).forEach((i => i(t, e))),
                    s
                },
                off: function(t, n) {
                    return e[t] = i(t).filter((t => t !== n)),
                    s
                },
                on: function(t, n) {
                    return e[t] = i(t).concat([n]),
                    s
                },
                clear: function() {
                    e = {}
                }
            };
            return s
        }()
          , {mergeOptions: c, optionsAtMedia: h, optionsMediaQueries: d} = r
          , {on: u, off: p, emit: m} = l
          , f = O;
        let g, v, y, _, b = !1, w = c(sn, rn.globalOptions), S = c(w), E = [];
        function x(e) {
            const i = en(t, y, _, s, n, e, l);
            if (e.loop && !i.slideLooper.canLoop()) {
                return x(Object.assign({}, e, {
                    loop: !1
                }))
            }
            return i
        }
        function L(e, i) {
            b || (w = c(w, e),
            S = h(w),
            E = i || E,
            function() {
                const {container: e, slides: i} = S
                  , s = xs(e) ? t.querySelector(e) : e;
                y = s || t.children[0];
                const n = xs(i) ? y.querySelectorAll(i) : i;
                _ = [].slice.call(n || y.children)
            }(),
            g = x(S),
            d([w, ...E.map(( ({options: t}) => t))]).forEach((t => a.add(t, "change", O))),
            S.active && (g.translate.to(g.location.get()),
            g.animation.init(),
            g.slidesInView.init(),
            g.slideFocus.init(M),
            g.eventHandler.init(M),
            g.resizeHandler.init(M),
            g.slidesHandler.init(M),
            g.options.loop && g.slideLooper.loop(),
            y.offsetParent && _.length && g.dragHandler.init(M),
            v = o.init(M, E)))
        }
        function O(t, e) {
            const i = A();
            P(),
            L(c({
                startIndex: i
            }, t), e),
            l.emit("reInit")
        }
        function P() {
            g.dragHandler.destroy(),
            g.eventStore.clear(),
            g.translate.clear(),
            g.slideLooper.clear(),
            g.resizeHandler.destroy(),
            g.slidesHandler.destroy(),
            g.slidesInView.destroy(),
            g.animation.destroy(),
            o.destroy(),
            a.clear()
        }
        function C(t, e, i) {
            S.active && !b && (g.scrollBody.useBaseFriction().useDuration(!0 === e ? 0 : S.duration),
            g.scrollTo.index(t, i || 0))
        }
        function A() {
            return g.index.get()
        }
        const M = {
            canScrollNext: function() {
                return g.index.add(1).get() !== A()
            },
            canScrollPrev: function() {
                return g.index.add(-1).get() !== A()
            },
            containerNode: function() {
                return y
            },
            internalEngine: function() {
                return g
            },
            destroy: function() {
                b || (b = !0,
                a.clear(),
                P(),
                l.emit("destroy"),
                l.clear())
            },
            off: p,
            on: u,
            emit: m,
            plugins: function() {
                return v
            },
            previousScrollSnap: function() {
                return g.indexPrevious.get()
            },
            reInit: f,
            rootNode: function() {
                return t
            },
            scrollNext: function(t) {
                C(g.index.add(1).get(), t, -1)
            },
            scrollPrev: function(t) {
                C(g.index.add(-1).get(), t, 1)
            },
            scrollProgress: function() {
                return g.scrollProgress.get(g.location.get())
            },
            scrollSnapList: function() {
                return g.scrollSnapList
            },
            scrollTo: C,
            selectedScrollSnap: A,
            slideNodes: function() {
                return _
            },
            slidesInView: function() {
                return g.slidesInView.get()
            },
            slidesNotInView: function() {
                return g.slidesInView.get(!1)
            }
        };
        return L(e, i),
        setTimeout(( () => l.emit("init")), 0),
        M
    }
    rn.globalOptions = void 0;
    "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self && self;
    function on(t) {
        return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t
    }
    var an, ln = {
        exports: {}
    };
    function cn() {
        return an || (an = 1,
        ln.exports = function() {
            var t = 1e3
              , e = 6e4
              , i = 36e5
              , s = "millisecond"
              , n = "second"
              , r = "minute"
              , o = "hour"
              , a = "day"
              , l = "week"
              , c = "month"
              , h = "quarter"
              , d = "year"
              , u = "date"
              , p = "Invalid Date"
              , m = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/
              , f = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g
              , g = {
                name: "en",
                weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
                months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
                ordinal: function(t) {
                    var e = ["th", "st", "nd", "rd"]
                      , i = t % 100;
                    return "[" + t + (e[(i - 20) % 10] || e[i] || e[0]) + "]"
                }
            }
              , v = function(t, e, i) {
                var s = String(t);
                return !s || s.length >= e ? t : "" + Array(e + 1 - s.length).join(i) + t
            }
              , y = {
                s: v,
                z: function(t) {
                    var e = -t.utcOffset()
                      , i = Math.abs(e)
                      , s = Math.floor(i / 60)
                      , n = i % 60;
                    return (e <= 0 ? "+" : "-") + v(s, 2, "0") + ":" + v(n, 2, "0")
                },
                m: function t(e, i) {
                    if (e.date() < i.date())
                        return -t(i, e);
                    var s = 12 * (i.year() - e.year()) + (i.month() - e.month())
                      , n = e.clone().add(s, c)
                      , r = i - n < 0
                      , o = e.clone().add(s + (r ? -1 : 1), c);
                    return +(-(s + (i - n) / (r ? n - o : o - n)) || 0)
                },
                a: function(t) {
                    return t < 0 ? Math.ceil(t) || 0 : Math.floor(t)
                },
                p: function(t) {
                    return {
                        M: c,
                        y: d,
                        w: l,
                        d: a,
                        D: u,
                        h: o,
                        m: r,
                        s: n,
                        ms: s,
                        Q: h
                    }[t] || String(t || "").toLowerCase().replace(/s$/, "")
                },
                u: function(t) {
                    return void 0 === t
                }
            }
              , _ = "en"
              , b = {};
            b[_] = g;
            var w = "$isDayjsObject"
              , S = function(t) {
                return t instanceof O || !(!t || !t[w])
            }
              , E = function t(e, i, s) {
                var n;
                if (!e)
                    return _;
                if ("string" == typeof e) {
                    var r = e.toLowerCase();
                    b[r] && (n = r),
                    i && (b[r] = i,
                    n = r);
                    var o = e.split("-");
                    if (!n && o.length > 1)
                        return t(o[0])
                } else {
                    var a = e.name;
                    b[a] = e,
                    n = a
                }
                return !s && n && (_ = n),
                n || !s && _
            }
              , x = function(t, e) {
                if (S(t))
                    return t.clone();
                var i = "object" == typeof e ? e : {};
                return i.date = t,
                i.args = arguments,
                new O(i)
            }
              , L = y;
            L.l = E,
            L.i = S,
            L.w = function(t, e) {
                return x(t, {
                    locale: e.$L,
                    utc: e.$u,
                    x: e.$x,
                    $offset: e.$offset
                })
            }
            ;
            var O = function() {
                function g(t) {
                    this.$L = E(t.locale, null, !0),
                    this.parse(t),
                    this.$x = this.$x || t.x || {},
                    this[w] = !0
                }
                var v = g.prototype;
                return v.parse = function(t) {
                    this.$d = function(t) {
                        var e = t.date
                          , i = t.utc;
                        if (null === e)
                            return new Date(NaN);
                        if (L.u(e))
                            return new Date;
                        if (e instanceof Date)
                            return new Date(e);
                        if ("string" == typeof e && !/Z$/i.test(e)) {
                            var s = e.match(m);
                            if (s) {
                                var n = s[2] - 1 || 0
                                  , r = (s[7] || "0").substring(0, 3);
                                return i ? new Date(Date.UTC(s[1], n, s[3] || 1, s[4] || 0, s[5] || 0, s[6] || 0, r)) : new Date(s[1],n,s[3] || 1,s[4] || 0,s[5] || 0,s[6] || 0,r)
                            }
                        }
                        return new Date(e)
                    }(t),
                    this.init()
                }
                ,
                v.init = function() {
                    var t = this.$d;
                    this.$y = t.getFullYear(),
                    this.$M = t.getMonth(),
                    this.$D = t.getDate(),
                    this.$W = t.getDay(),
                    this.$H = t.getHours(),
                    this.$m = t.getMinutes(),
                    this.$s = t.getSeconds(),
                    this.$ms = t.getMilliseconds()
                }
                ,
                v.$utils = function() {
                    return L
                }
                ,
                v.isValid = function() {
                    return !(this.$d.toString() === p)
                }
                ,
                v.isSame = function(t, e) {
                    var i = x(t);
                    return this.startOf(e) <= i && i <= this.endOf(e)
                }
                ,
                v.isAfter = function(t, e) {
                    return x(t) < this.startOf(e)
                }
                ,
                v.isBefore = function(t, e) {
                    return this.endOf(e) < x(t)
                }
                ,
                v.$g = function(t, e, i) {
                    return L.u(t) ? this[e] : this.set(i, t)
                }
                ,
                v.unix = function() {
                    return Math.floor(this.valueOf() / 1e3)
                }
                ,
                v.valueOf = function() {
                    return this.$d.getTime()
                }
                ,
                v.startOf = function(t, e) {
                    var i = this
                      , s = !!L.u(e) || e
                      , h = L.p(t)
                      , p = function(t, e) {
                        var n = L.w(i.$u ? Date.UTC(i.$y, e, t) : new Date(i.$y,e,t), i);
                        return s ? n : n.endOf(a)
                    }
                      , m = function(t, e) {
                        return L.w(i.toDate()[t].apply(i.toDate("s"), (s ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(e)), i)
                    }
                      , f = this.$W
                      , g = this.$M
                      , v = this.$D
                      , y = "set" + (this.$u ? "UTC" : "");
                    switch (h) {
                    case d:
                        return s ? p(1, 0) : p(31, 11);
                    case c:
                        return s ? p(1, g) : p(0, g + 1);
                    case l:
                        var _ = this.$locale().weekStart || 0
                          , b = (f < _ ? f + 7 : f) - _;
                        return p(s ? v - b : v + (6 - b), g);
                    case a:
                    case u:
                        return m(y + "Hours", 0);
                    case o:
                        return m(y + "Minutes", 1);
                    case r:
                        return m(y + "Seconds", 2);
                    case n:
                        return m(y + "Milliseconds", 3);
                    default:
                        return this.clone()
                    }
                }
                ,
                v.endOf = function(t) {
                    return this.startOf(t, !1)
                }
                ,
                v.$set = function(t, e) {
                    var i, l = L.p(t), h = "set" + (this.$u ? "UTC" : ""), p = (i = {},
                    i[a] = h + "Date",
                    i[u] = h + "Date",
                    i[c] = h + "Month",
                    i[d] = h + "FullYear",
                    i[o] = h + "Hours",
                    i[r] = h + "Minutes",
                    i[n] = h + "Seconds",
                    i[s] = h + "Milliseconds",
                    i)[l], m = l === a ? this.$D + (e - this.$W) : e;
                    if (l === c || l === d) {
                        var f = this.clone().set(u, 1);
                        f.$d[p](m),
                        f.init(),
                        this.$d = f.set(u, Math.min(this.$D, f.daysInMonth())).$d
                    } else
                        p && this.$d[p](m);
                    return this.init(),
                    this
                }
                ,
                v.set = function(t, e) {
                    return this.clone().$set(t, e)
                }
                ,
                v.get = function(t) {
                    return this[L.p(t)]()
                }
                ,
                v.add = function(s, h) {
                    var u, p = this;
                    s = Number(s);
                    var m = L.p(h)
                      , f = function(t) {
                        var e = x(p);
                        return L.w(e.date(e.date() + Math.round(t * s)), p)
                    };
                    if (m === c)
                        return this.set(c, this.$M + s);
                    if (m === d)
                        return this.set(d, this.$y + s);
                    if (m === a)
                        return f(1);
                    if (m === l)
                        return f(7);
                    var g = (u = {},
                    u[r] = e,
                    u[o] = i,
                    u[n] = t,
                    u)[m] || 1
                      , v = this.$d.getTime() + s * g;
                    return L.w(v, this)
                }
                ,
                v.subtract = function(t, e) {
                    return this.add(-1 * t, e)
                }
                ,
                v.format = function(t) {
                    var e = this
                      , i = this.$locale();
                    if (!this.isValid())
                        return i.invalidDate || p;
                    var s = t || "YYYY-MM-DDTHH:mm:ssZ"
                      , n = L.z(this)
                      , r = this.$H
                      , o = this.$m
                      , a = this.$M
                      , l = i.weekdays
                      , c = i.months
                      , h = i.meridiem
                      , d = function(t, i, n, r) {
                        return t && (t[i] || t(e, s)) || n[i].slice(0, r)
                    }
                      , u = function(t) {
                        return L.s(r % 12 || 12, t, "0")
                    }
                      , m = h || function(t, e, i) {
                        var s = t < 12 ? "AM" : "PM";
                        return i ? s.toLowerCase() : s
                    }
                    ;
                    return s.replace(f, (function(t, s) {
                        return s || function(t) {
                            switch (t) {
                            case "YY":
                                return String(e.$y).slice(-2);
                            case "YYYY":
                                return L.s(e.$y, 4, "0");
                            case "M":
                                return a + 1;
                            case "MM":
                                return L.s(a + 1, 2, "0");
                            case "MMM":
                                return d(i.monthsShort, a, c, 3);
                            case "MMMM":
                                return d(c, a);
                            case "D":
                                return e.$D;
                            case "DD":
                                return L.s(e.$D, 2, "0");
                            case "d":
                                return String(e.$W);
                            case "dd":
                                return d(i.weekdaysMin, e.$W, l, 2);
                            case "ddd":
                                return d(i.weekdaysShort, e.$W, l, 3);
                            case "dddd":
                                return l[e.$W];
                            case "H":
                                return String(r);
                            case "HH":
                                return L.s(r, 2, "0");
                            case "h":
                                return u(1);
                            case "hh":
                                return u(2);
                            case "a":
                                return m(r, o, !0);
                            case "A":
                                return m(r, o, !1);
                            case "m":
                                return String(o);
                            case "mm":
                                return L.s(o, 2, "0");
                            case "s":
                                return String(e.$s);
                            case "ss":
                                return L.s(e.$s, 2, "0");
                            case "SSS":
                                return L.s(e.$ms, 3, "0");
                            case "Z":
                                return n
                            }
                            return null
                        }(t) || n.replace(":", "")
                    }
                    ))
                }
                ,
                v.utcOffset = function() {
                    return 15 * -Math.round(this.$d.getTimezoneOffset() / 15)
                }
                ,
                v.diff = function(s, u, p) {
                    var m, f = this, g = L.p(u), v = x(s), y = (v.utcOffset() - this.utcOffset()) * e, _ = this - v, b = function() {
                        return L.m(f, v)
                    };
                    switch (g) {
                    case d:
                        m = b() / 12;
                        break;
                    case c:
                        m = b();
                        break;
                    case h:
                        m = b() / 3;
                        break;
                    case l:
                        m = (_ - y) / 6048e5;
                        break;
                    case a:
                        m = (_ - y) / 864e5;
                        break;
                    case o:
                        m = _ / i;
                        break;
                    case r:
                        m = _ / e;
                        break;
                    case n:
                        m = _ / t;
                        break;
                    default:
                        m = _
                    }
                    return p ? m : L.a(m)
                }
                ,
                v.daysInMonth = function() {
                    return this.endOf(c).$D
                }
                ,
                v.$locale = function() {
                    return b[this.$L]
                }
                ,
                v.locale = function(t, e) {
                    if (!t)
                        return this.$L;
                    var i = this.clone()
                      , s = E(t, e, !0);
                    return s && (i.$L = s),
                    i
                }
                ,
                v.clone = function() {
                    return L.w(this.$d, this)
                }
                ,
                v.toDate = function() {
                    return new Date(this.valueOf())
                }
                ,
                v.toJSON = function() {
                    return this.isValid() ? this.toISOString() : null
                }
                ,
                v.toISOString = function() {
                    return this.$d.toISOString()
                }
                ,
                v.toString = function() {
                    return this.$d.toUTCString()
                }
                ,
                g
            }()
              , P = O.prototype;
            return x.prototype = P,
            [["$ms", s], ["$s", n], ["$m", r], ["$H", o], ["$W", a], ["$M", c], ["$y", d], ["$D", u]].forEach((function(t) {
                P[t[1]] = function(e) {
                    return this.$g(e, t[0], t[1])
                }
            }
            )),
            x.extend = function(t, e) {
                return t.$i || (t(e, O, x),
                t.$i = !0),
                x
            }
            ,
            x.locale = E,
            x.isDayjs = S,
            x.unix = function(t) {
                return x(1e3 * t)
            }
            ,
            x.en = b[_],
            x.Ls = b,
            x.p = {},
            x
        }()),
        ln.exports
    }
    var hn = on(cn())
      , dn = {
        exports: {}
    };
    dn.exports = function(t, e, i) {
        t = t || {};
        var s = e.prototype
          , n = {
            future: "in %s",
            past: "%s ago",
            s: "a few seconds",
            m: "a minute",
            mm: "%d minutes",
            h: "an hour",
            hh: "%d hours",
            d: "a day",
            dd: "%d days",
            M: "a month",
            MM: "%d months",
            y: "a year",
            yy: "%d years"
        };
        function r(t, e, i, n) {
            return s.fromToBase(t, e, i, n)
        }
        i.en.relativeTime = n,
        s.fromToBase = function(e, s, r, o, a) {
            for (var l, c, h, d = r.$locale().relativeTime || n, u = t.thresholds || [{
                l: "s",
                r: 44,
                d: "second"
            }, {
                l: "m",
                r: 89
            }, {
                l: "mm",
                r: 44,
                d: "minute"
            }, {
                l: "h",
                r: 89
            }, {
                l: "hh",
                r: 21,
                d: "hour"
            }, {
                l: "d",
                r: 35
            }, {
                l: "dd",
                r: 25,
                d: "day"
            }, {
                l: "M",
                r: 45
            }, {
                l: "MM",
                r: 10,
                d: "month"
            }, {
                l: "y",
                r: 17
            }, {
                l: "yy",
                d: "year"
            }], p = u.length, m = 0; m < p; m += 1) {
                var f = u[m];
                f.d && (l = o ? i(e).diff(r, f.d, !0) : r.diff(e, f.d, !0));
                var g = (t.rounding || Math.round)(Math.abs(l));
                if (h = l > 0,
                g <= f.r || !f.r) {
                    g <= 1 && m > 0 && (f = u[m - 1]);
                    var v = d[f.l];
                    a && (g = a("" + g)),
                    c = "string" == typeof v ? v.replace("%d", g) : v(g, s, f.l, h);
                    break
                }
            }
            if (s)
                return c;
            var y = h ? d.future : d.past;
            return "function" == typeof y ? y(c) : y.replace("%s", c)
        }
        ,
        s.to = function(t, e) {
            return r(t, e, this, !0)
        }
        ,
        s.from = function(t, e) {
            return r(t, e, this)
        }
        ;
        var o = function(t) {
            return t.$u ? i.utc() : i()
        };
        s.toNow = function(t) {
            return this.to(o(this), t)
        }
        ,
        s.fromNow = function(t) {
            return this.from(o(this), t)
        }
    }
    ;
    var un = on(dn.exports)
      , pn = {
        exports: {}
    };
    !function(t, e) {
        t.exports = function() {
            function t(t, e) {
                var i = void 0;
                return function() {
                    i && clearTimeout(i),
                    i = setTimeout(t, e)
                }
            }
            function e(t, e) {
                for (var i = t.length, s = i, n = []; i--; )
                    n.push(e(t[s - i - 1]));
                return n
            }
            function i(t, e) {
                var i = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
                if (window.Promise)
                    return w(t, e, i);
                t.recalculate(!0, !0)
            }
            function s(t) {
                for (var e = t.options, i = t.responsiveOptions, s = t.keys, n = t.docWidth, r = void 0, o = 0; o < s.length; o++) {
                    var a = parseInt(s[o], 10);
                    n >= a && (r = e.breakAt[a],
                    C(r, i))
                }
                return i
            }
            function n(t) {
                for (var e = t.options, i = t.responsiveOptions, s = t.keys, n = t.docWidth, r = void 0, o = s.length - 1; o >= 0; o--) {
                    var a = parseInt(s[o], 10);
                    n <= a && (r = e.breakAt[a],
                    C(r, i))
                }
                return i
            }
            function r(t) {
                var e = t.useContainerForBreakpoints ? t.container.clientWidth : window.innerWidth
                  , i = {
                    columns: t.columns
                };
                P(t.margin) ? i.margin = {
                    x: t.margin.x,
                    y: t.margin.y
                } : i.margin = {
                    x: t.margin,
                    y: t.margin
                };
                var r = Object.keys(t.breakAt);
                return t.mobileFirst ? s({
                    options: t,
                    responsiveOptions: i,
                    keys: r,
                    docWidth: e
                }) : n({
                    options: t,
                    responsiveOptions: i,
                    keys: r,
                    docWidth: e
                })
            }
            function o(t) {
                return r(t).columns
            }
            function a(t) {
                return r(t).margin
            }
            function l(t) {
                var e = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1]
                  , i = o(t)
                  , s = a(t).x
                  , n = 100 / i;
                if (!e)
                    return n;
                if (1 === i)
                    return "100%";
                var r = "px";
                if ("string" == typeof s) {
                    var l = parseFloat(s);
                    r = s.replace(l, ""),
                    s = l
                }
                return s = (i - 1) * s / i,
                "%" === r ? n - s + "%" : "calc(" + n + "% - " + s + r + ")"
            }
            function c(t, e) {
                var i = o(t.options)
                  , s = 0
                  , n = void 0
                  , r = void 0;
                if (1 == ++e)
                    return 0;
                var c = "px";
                if ("string" == typeof (r = a(t.options).x)) {
                    var h = parseFloat(r, 10);
                    c = r.replace(h, ""),
                    r = h
                }
                return n = (r - (i - 1) * r / i) * (e - 1),
                s += l(t.options, !1) * (e - 1),
                "%" === c ? s + n + "%" : "calc(" + s + "% + " + n + c + ")"
            }
            function h(t) {
                var e = 0
                  , i = t.container
                  , s = t.rows;
                m(s, (function(t) {
                    e = t > e ? t : e
                }
                )),
                i.style.height = e + "px"
            }
            function d(t, e) {
                var i = arguments.length > 2 && void 0 !== arguments[2] && arguments[2]
                  , s = !(arguments.length > 3 && void 0 !== arguments[3]) || arguments[3]
                  , n = o(t.options)
                  , r = a(t.options).y;
                M(t, n, i),
                m(e, (function(e) {
                    var i = 0
                      , n = parseInt(e.offsetHeight, 10);
                    isNaN(n) || (t.rows.forEach((function(e, s) {
                        e < t.rows[i] && (i = s)
                    }
                    )),
                    e.style.position = "absolute",
                    e.style.top = t.rows[i] + "px",
                    e.style[t.options.rtl ? "right" : "left"] = "" + t.cols[i],
                    t.rows[i] += isNaN(n) ? 0 : n + r,
                    s && (e.dataset.macyComplete = 1))
                }
                )),
                s && (t.tmpRows = null),
                h(t)
            }
            function u(t, e) {
                var i = arguments.length > 2 && void 0 !== arguments[2] && arguments[2]
                  , s = !(arguments.length > 3 && void 0 !== arguments[3]) || arguments[3]
                  , n = o(t.options)
                  , r = a(t.options).y;
                M(t, n, i),
                m(e, (function(e) {
                    t.lastcol === n && (t.lastcol = 0);
                    var i = A(e, "height");
                    i = parseInt(e.offsetHeight, 10),
                    isNaN(i) || (e.style.position = "absolute",
                    e.style.top = t.rows[t.lastcol] + "px",
                    e.style[t.options.rtl ? "right" : "left"] = "" + t.cols[t.lastcol],
                    t.rows[t.lastcol] += isNaN(i) ? 0 : i + r,
                    t.lastcol += 1,
                    s && (e.dataset.macyComplete = 1))
                }
                )),
                s && (t.tmpRows = null),
                h(t)
            }
            var p = function t(e, i) {
                if (!(this instanceof t))
                    return new t(e,i);
                if (e && e.nodeName)
                    return e;
                if (e = e.replace(/^\s*/, "").replace(/\s*$/, ""),
                i)
                    return this.byCss(e, i);
                for (var s in this.selectors)
                    if (i = s.split("/"),
                    new RegExp(i[1],i[2]).test(e))
                        return this.selectors[s](e);
                return this.byCss(e)
            };
            p.prototype.byCss = function(t, e) {
                return (e || document).querySelectorAll(t)
            }
            ,
            p.prototype.selectors = {},
            p.prototype.selectors[/^\.[\w\-]+$/] = function(t) {
                return document.getElementsByClassName(t.substring(1))
            }
            ,
            p.prototype.selectors[/^\w+$/] = function(t) {
                return document.getElementsByTagName(t)
            }
            ,
            p.prototype.selectors[/^\#[\w\-]+$/] = function(t) {
                return document.getElementById(t.substring(1))
            }
            ;
            var m = function(t, e) {
                for (var i = t.length, s = i; i--; )
                    e(t[s - i - 1])
            }
              , f = function() {
                var t = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
                this.running = !1,
                this.events = [],
                this.add(t)
            };
            f.prototype.run = function() {
                if (!this.running && this.events.length > 0) {
                    var t = this.events.shift();
                    this.running = !0,
                    t(),
                    this.running = !1,
                    this.run()
                }
            }
            ,
            f.prototype.add = function() {
                var t = this
                  , e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
                return !!e && (Array.isArray(e) ? m(e, (function(e) {
                    return t.add(e)
                }
                )) : (this.events.push(e),
                void this.run()))
            }
            ,
            f.prototype.clear = function() {
                this.events = []
            }
            ;
            var g = function(t) {
                var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                return this.instance = t,
                this.data = e,
                this
            }
              , v = function() {
                var t = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
                this.events = {},
                this.instance = t
            };
            v.prototype.on = function() {
                var t = arguments.length > 0 && void 0 !== arguments[0] && arguments[0]
                  , e = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
                return !(!t || !e) && (Array.isArray(this.events[t]) || (this.events[t] = []),
                this.events[t].push(e))
            }
            ,
            v.prototype.emit = function() {
                var t = arguments.length > 0 && void 0 !== arguments[0] && arguments[0]
                  , e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                if (!t || !Array.isArray(this.events[t]))
                    return !1;
                var i = new g(this.instance,e);
                m(this.events[t], (function(t) {
                    return t(i)
                }
                ))
            }
            ;
            var y = function(t) {
                return !("naturalHeight"in t && t.naturalHeight + t.naturalWidth === 0) || t.width + t.height !== 0
            }
              , _ = function(t, e) {
                var i = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
                return new Promise((function(t, i) {
                    if (e.complete)
                        return y(e) ? t(e) : i(e);
                    e.addEventListener("load", (function() {
                        return y(e) ? t(e) : i(e)
                    }
                    )),
                    e.addEventListener("error", (function() {
                        return i(e)
                    }
                    ))
                }
                )).then((function(e) {
                    i && t.emit(t.constants.EVENT_IMAGE_LOAD, {
                        img: e
                    })
                }
                )).catch((function(e) {
                    return t.emit(t.constants.EVENT_IMAGE_ERROR, {
                        img: e
                    })
                }
                ))
            }
              , b = function(t, i) {
                var s = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
                return e(i, (function(e) {
                    return _(t, e, s)
                }
                ))
            }
              , w = function(t, e) {
                var i = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
                return Promise.all(b(t, e, i)).then((function() {
                    t.emit(t.constants.EVENT_IMAGE_COMPLETE)
                }
                ))
            }
              , S = function(e) {
                return t((function() {
                    e.emit(e.constants.EVENT_RESIZE),
                    e.queue.add((function() {
                        return e.recalculate(!0, !0)
                    }
                    ))
                }
                ), 100)
            }
              , E = function(t) {
                if (t.container = p(t.options.container),
                t.container instanceof p || !t.container)
                    return !!t.options.debug && console.error("Error: Container not found");
                t.container.length && (t.container = t.container[0]),
                t.options.container = t.container,
                t.container.style.position = "relative"
            }
              , x = function(t) {
                t.queue = new f,
                t.events = new v(t),
                t.rows = [],
                t.resizer = S(t)
            }
              , L = function(t) {
                var e = p("img", t.container);
                window.addEventListener("resize", t.resizer),
                t.on(t.constants.EVENT_IMAGE_LOAD, (function() {
                    return t.recalculate(!1, !1)
                }
                )),
                t.on(t.constants.EVENT_IMAGE_COMPLETE, (function() {
                    return t.recalculate(!0, !0)
                }
                )),
                t.options.useOwnImageLoader || i(t, e, !t.options.waitForImages),
                t.emit(t.constants.EVENT_INITIALIZED)
            }
              , O = function(t) {
                E(t),
                x(t),
                L(t)
            }
              , P = function(t) {
                return t === Object(t) && "[object Array]" !== Object.prototype.toString.call(t)
            }
              , C = function(t, e) {
                P(t) || (e.columns = t),
                P(t) && t.columns && (e.columns = t.columns),
                P(t) && t.margin && !P(t.margin) && (e.margin = {
                    x: t.margin,
                    y: t.margin
                }),
                P(t) && t.margin && P(t.margin) && t.margin.x && (e.margin.x = t.margin.x),
                P(t) && t.margin && P(t.margin) && t.margin.y && (e.margin.y = t.margin.y)
            }
              , A = function(t, e) {
                return window.getComputedStyle(t, null).getPropertyValue(e)
            }
              , M = function(t, e) {
                var i = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
                if (t.lastcol || (t.lastcol = 0),
                t.rows.length < 1 && (i = !0),
                i) {
                    t.rows = [],
                    t.cols = [],
                    t.lastcol = 0;
                    for (var s = e - 1; s >= 0; s--)
                        t.rows[s] = 0,
                        t.cols[s] = c(t, s)
                } else if (t.tmpRows)
                    for (t.rows = [],
                    s = e - 1; s >= 0; s--)
                        t.rows[s] = t.tmpRows[s];
                else
                    for (t.tmpRows = [],
                    s = e - 1; s >= 0; s--)
                        t.tmpRows[s] = t.rows[s]
            }
              , T = function(t) {
                var e = arguments.length > 1 && void 0 !== arguments[1] && arguments[1]
                  , i = !(arguments.length > 2 && void 0 !== arguments[2]) || arguments[2]
                  , s = e ? t.container.children : p(':scope > *:not([data-macy-complete="1"])', t.container);
                s = Array.from(s).filter((function(t) {
                    return null !== t.offsetParent
                }
                ));
                var n = l(t.options);
                return m(s, (function(t) {
                    e && (t.dataset.macyComplete = 0),
                    t.style.width = n
                }
                )),
                t.options.trueOrder ? (u(t, s, e, i),
                t.emit(t.constants.EVENT_RECALCULATED)) : (d(t, s, e, i),
                t.emit(t.constants.EVENT_RECALCULATED))
            }
              , I = function() {
                return !!window.Promise
            }
              , D = Object.assign || function(t) {
                for (var e = 1; e < arguments.length; e++) {
                    var i = arguments[e];
                    for (var s in i)
                        Object.prototype.hasOwnProperty.call(i, s) && (t[s] = i[s])
                }
                return t
            }
            ;
            Array.from || (Array.from = function(t) {
                for (var e = 0, i = []; e < t.length; )
                    i.push(t[e++]);
                return i
            }
            );
            var k = {
                columns: 4,
                margin: 2,
                trueOrder: !1,
                waitForImages: !1,
                useImageLoader: !0,
                breakAt: {},
                useOwnImageLoader: !1,
                onInit: !1,
                cancelLegacy: !1,
                useContainerForBreakpoints: !1
            };
            !function() {
                try {
                    document.createElement("a").querySelector(":scope *")
                } catch (t) {
                    !function() {
                        function t(t) {
                            return function(i) {
                                if (i && e.test(i)) {
                                    var s = this.getAttribute("id");
                                    s || (this.id = "q" + Math.floor(9e6 * Math.random()) + 1e6),
                                    arguments[0] = i.replace(e, "#" + this.id);
                                    var n = t.apply(this, arguments);
                                    return null === s ? this.removeAttribute("id") : s || (this.id = s),
                                    n
                                }
                                return t.apply(this, arguments)
                            }
                        }
                        var e = /:scope\b/gi
                          , i = t(Element.prototype.querySelector);
                        Element.prototype.querySelector = function(t) {
                            return i.apply(this, arguments)
                        }
                        ;
                        var s = t(Element.prototype.querySelectorAll);
                        Element.prototype.querySelectorAll = function(t) {
                            return s.apply(this, arguments)
                        }
                    }()
                }
            }();
            var z = function t() {
                var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : k;
                if (!(this instanceof t))
                    return new t(e);
                this.options = {},
                D(this.options, k, e),
                this.options.cancelLegacy && !I() || O(this)
            };
            return z.init = function(t) {
                return console.warn("Depreciated: Macy.init will be removed in v3.0.0 opt to use Macy directly like so Macy({ /*options here*/ }) "),
                new z(t)
            }
            ,
            z.prototype.recalculateOnImageLoad = function() {
                var t = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
                return i(this, p("img", this.container), !t)
            }
            ,
            z.prototype.runOnImageLoad = function(t) {
                var e = arguments.length > 1 && void 0 !== arguments[1] && arguments[1]
                  , s = p("img", this.container);
                return this.on(this.constants.EVENT_IMAGE_COMPLETE, t),
                e && this.on(this.constants.EVENT_IMAGE_LOAD, t),
                i(this, s, e)
            }
            ,
            z.prototype.recalculate = function() {
                var t = this
                  , e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0]
                  , i = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];
                return i && this.queue.clear(),
                this.queue.add((function() {
                    return T(t, e, i)
                }
                ))
            }
            ,
            z.prototype.remove = function() {
                window.removeEventListener("resize", this.resizer),
                m(this.container.children, (function(t) {
                    t.removeAttribute("data-macy-complete"),
                    t.removeAttribute("style")
                }
                )),
                this.container.removeAttribute("style")
            }
            ,
            z.prototype.reInit = function() {
                this.recalculate(!0, !0),
                this.emit(this.constants.EVENT_INITIALIZED),
                window.addEventListener("resize", this.resizer),
                this.container.style.position = "relative"
            }
            ,
            z.prototype.on = function(t, e) {
                this.events.on(t, e)
            }
            ,
            z.prototype.emit = function(t, e) {
                this.events.emit(t, e)
            }
            ,
            z.constants = {
                EVENT_INITIALIZED: "macy.initialized",
                EVENT_RECALCULATED: "macy.recalculated",
                EVENT_IMAGE_LOAD: "macy.image.load",
                EVENT_IMAGE_ERROR: "macy.image.error",
                EVENT_IMAGE_COMPLETE: "macy.images.complete",
                EVENT_RESIZE: "macy.resize"
            },
            z.prototype.constants = z.constants,
            z
        }()
    }(pn);
    var mn = on(pn.exports);
    /*!
    * PhotoSwipe Lightbox 5.4.4 - https://photoswipe.com
    * (c) 2024 Dmytro Semenov
    */
    function fn(t, e, i) {
        const s = document.createElement(e);
        return t && (s.className = t),
        i && i.appendChild(s),
        s
    }
    function gn(t, e, i) {
        t.style.width = "number" == typeof e ? `${e}px` : e,
        t.style.height = "number" == typeof i ? `${i}px` : i
    }
    const vn = "idle"
      , yn = "loading"
      , _n = "loaded"
      , bn = "error";
    function wn(t, e, i=document) {
        let s = [];
        if (t instanceof Element)
            s = [t];
        else if (t instanceof NodeList || Array.isArray(t))
            s = Array.from(t);
        else {
            const n = "string" == typeof t ? t : e;
            n && (s = Array.from(i.querySelectorAll(n)))
        }
        return s
    }
    function Sn() {
        return !(!navigator.vendor || !navigator.vendor.match(/apple/i))
    }
    let En = class {
        constructor(t, e) {
            this.type = t,
            this.defaultPrevented = !1,
            e && Object.assign(this, e)
        }
        preventDefault() {
            this.defaultPrevented = !0
        }
    }
      , xn = class {
        constructor() {
            this._listeners = {},
            this._filters = {},
            this.pswp = void 0,
            this.options = void 0
        }
        addFilter(t, e, i=100) {
            var s, n, r;
            this._filters[t] || (this._filters[t] = []),
            null === (s = this._filters[t]) || void 0 === s || s.push({
                fn: e,
                priority: i
            }),
            null === (n = this._filters[t]) || void 0 === n || n.sort(( (t, e) => t.priority - e.priority)),
            null === (r = this.pswp) || void 0 === r || r.addFilter(t, e, i)
        }
        removeFilter(t, e) {
            this._filters[t] && (this._filters[t] = this._filters[t].filter((t => t.fn !== e))),
            this.pswp && this.pswp.removeFilter(t, e)
        }
        applyFilters(t, ...e) {
            var i;
            return null === (i = this._filters[t]) || void 0 === i || i.forEach((t => {
                e[0] = t.fn.apply(this, e)
            }
            )),
            e[0]
        }
        on(t, e) {
            var i, s;
            this._listeners[t] || (this._listeners[t] = []),
            null === (i = this._listeners[t]) || void 0 === i || i.push(e),
            null === (s = this.pswp) || void 0 === s || s.on(t, e)
        }
        off(t, e) {
            var i;
            this._listeners[t] && (this._listeners[t] = this._listeners[t].filter((t => e !== t))),
            null === (i = this.pswp) || void 0 === i || i.off(t, e)
        }
        dispatch(t, e) {
            var i;
            if (this.pswp)
                return this.pswp.dispatch(t, e);
            const s = new En(t,e);
            return null === (i = this._listeners[t]) || void 0 === i || i.forEach((t => {
                t.call(this, s)
            }
            )),
            s
        }
    }
      , Ln = class {
        constructor(t, e) {
            if (this.element = fn("pswp__img pswp__img--placeholder", t ? "img" : "div", e),
            t) {
                const e = this.element;
                e.decoding = "async",
                e.alt = "",
                e.src = t,
                e.setAttribute("role", "presentation")
            }
            this.element.setAttribute("aria-hidden", "true")
        }
        setDisplayedSize(t, e) {
            this.element && ("IMG" === this.element.tagName ? (gn(this.element, 250, "auto"),
            this.element.style.transformOrigin = "0 0",
            this.element.style.transform = function(t, e, i) {
                let s = `translate3d(${t}px,0px,0)`;
                return void 0 !== i && (s += ` scale3d(${i},${i},1)`),
                s
            }(0, 0, t / 250)) : gn(this.element, t, e))
        }
        destroy() {
            var t;
            null !== (t = this.element) && void 0 !== t && t.parentNode && this.element.remove(),
            this.element = null
        }
    }
      , On = class {
        constructor(t, e, i) {
            this.instance = e,
            this.data = t,
            this.index = i,
            this.element = void 0,
            this.placeholder = void 0,
            this.slide = void 0,
            this.displayedImageWidth = 0,
            this.displayedImageHeight = 0,
            this.width = Number(this.data.w) || Number(this.data.width) || 0,
            this.height = Number(this.data.h) || Number(this.data.height) || 0,
            this.isAttached = !1,
            this.hasSlide = !1,
            this.isDecoding = !1,
            this.state = vn,
            this.data.type ? this.type = this.data.type : this.data.src ? this.type = "image" : this.type = "html",
            this.instance.dispatch("contentInit", {
                content: this
            })
        }
        removePlaceholder() {
            this.placeholder && !this.keepPlaceholder() && setTimeout(( () => {
                this.placeholder && (this.placeholder.destroy(),
                this.placeholder = void 0)
            }
            ), 1e3)
        }
        load(t, e) {
            if (this.slide && this.usePlaceholder())
                if (this.placeholder) {
                    const t = this.placeholder.element;
                    t && !t.parentElement && this.slide.container.prepend(t)
                } else {
                    const t = this.instance.applyFilters("placeholderSrc", !(!this.data.msrc || !this.slide.isFirstSlide) && this.data.msrc, this);
                    this.placeholder = new Ln(t,this.slide.container)
                }
            this.element && !e || this.instance.dispatch("contentLoad", {
                content: this,
                isLazy: t
            }).defaultPrevented || (this.isImageContent() ? (this.element = fn("pswp__img", "img"),
            this.displayedImageWidth && this.loadImage(t)) : (this.element = fn("pswp__content", "div"),
            this.element.innerHTML = this.data.html || ""),
            e && this.slide && this.slide.updateContentSize(!0))
        }
        loadImage(t) {
            var e, i;
            if (!this.isImageContent() || !this.element || this.instance.dispatch("contentLoadImage", {
                content: this,
                isLazy: t
            }).defaultPrevented)
                return;
            const s = this.element;
            this.updateSrcsetSizes(),
            this.data.srcset && (s.srcset = this.data.srcset),
            s.src = null !== (e = this.data.src) && void 0 !== e ? e : "",
            s.alt = null !== (i = this.data.alt) && void 0 !== i ? i : "",
            this.state = yn,
            s.complete ? this.onLoaded() : (s.onload = () => {
                this.onLoaded()
            }
            ,
            s.onerror = () => {
                this.onError()
            }
            )
        }
        setSlide(t) {
            this.slide = t,
            this.hasSlide = !0,
            this.instance = t.pswp
        }
        onLoaded() {
            this.state = _n,
            this.slide && this.element && (this.instance.dispatch("loadComplete", {
                slide: this.slide,
                content: this
            }),
            this.slide.isActive && this.slide.heavyAppended && !this.element.parentNode && (this.append(),
            this.slide.updateContentSize(!0)),
            this.state !== _n && this.state !== bn || this.removePlaceholder())
        }
        onError() {
            this.state = bn,
            this.slide && (this.displayError(),
            this.instance.dispatch("loadComplete", {
                slide: this.slide,
                isError: !0,
                content: this
            }),
            this.instance.dispatch("loadError", {
                slide: this.slide,
                content: this
            }))
        }
        isLoading() {
            return this.instance.applyFilters("isContentLoading", this.state === yn, this)
        }
        isError() {
            return this.state === bn
        }
        isImageContent() {
            return "image" === this.type
        }
        setDisplayedSize(t, e) {
            if (this.element && (this.placeholder && this.placeholder.setDisplayedSize(t, e),
            !this.instance.dispatch("contentResize", {
                content: this,
                width: t,
                height: e
            }).defaultPrevented && (gn(this.element, t, e),
            this.isImageContent() && !this.isError()))) {
                const i = !this.displayedImageWidth && t;
                this.displayedImageWidth = t,
                this.displayedImageHeight = e,
                i ? this.loadImage(!1) : this.updateSrcsetSizes(),
                this.slide && this.instance.dispatch("imageSizeChange", {
                    slide: this.slide,
                    width: t,
                    height: e,
                    content: this
                })
            }
        }
        isZoomable() {
            return this.instance.applyFilters("isContentZoomable", this.isImageContent() && this.state !== bn, this)
        }
        updateSrcsetSizes() {
            if (!this.isImageContent() || !this.element || !this.data.srcset)
                return;
            const t = this.element
              , e = this.instance.applyFilters("srcsetSizesWidth", this.displayedImageWidth, this);
            (!t.dataset.largestUsedSize || e > parseInt(t.dataset.largestUsedSize, 10)) && (t.sizes = e + "px",
            t.dataset.largestUsedSize = String(e))
        }
        usePlaceholder() {
            return this.instance.applyFilters("useContentPlaceholder", this.isImageContent(), this)
        }
        lazyLoad() {
            this.instance.dispatch("contentLazyLoad", {
                content: this
            }).defaultPrevented || this.load(!0)
        }
        keepPlaceholder() {
            return this.instance.applyFilters("isKeepingPlaceholder", this.isLoading(), this)
        }
        destroy() {
            this.hasSlide = !1,
            this.slide = void 0,
            this.instance.dispatch("contentDestroy", {
                content: this
            }).defaultPrevented || (this.remove(),
            this.placeholder && (this.placeholder.destroy(),
            this.placeholder = void 0),
            this.isImageContent() && this.element && (this.element.onload = null,
            this.element.onerror = null,
            this.element = void 0))
        }
        displayError() {
            if (this.slide) {
                var t, e;
                let i = fn("pswp__error-msg", "div");
                i.innerText = null !== (t = null === (e = this.instance.options) || void 0 === e ? void 0 : e.errorMsg) && void 0 !== t ? t : "",
                i = this.instance.applyFilters("contentErrorElement", i, this),
                this.element = fn("pswp__content pswp__error-msg-container", "div"),
                this.element.appendChild(i),
                this.slide.container.innerText = "",
                this.slide.container.appendChild(this.element),
                this.slide.updateContentSize(!0),
                this.removePlaceholder()
            }
        }
        append() {
            if (this.isAttached || !this.element)
                return;
            if (this.isAttached = !0,
            this.state === bn)
                return void this.displayError();
            if (this.instance.dispatch("contentAppend", {
                content: this
            }).defaultPrevented)
                return;
            const t = "decode"in this.element;
            this.isImageContent() ? t && this.slide && (!this.slide.isActive || Sn()) ? (this.isDecoding = !0,
            this.element.decode().catch(( () => {}
            )).finally(( () => {
                this.isDecoding = !1,
                this.appendImage()
            }
            ))) : this.appendImage() : this.slide && !this.element.parentNode && this.slide.container.appendChild(this.element)
        }
        activate() {
            !this.instance.dispatch("contentActivate", {
                content: this
            }).defaultPrevented && this.slide && (this.isImageContent() && this.isDecoding && !Sn() ? this.appendImage() : this.isError() && this.load(!1, !0),
            this.slide.holderElement && this.slide.holderElement.setAttribute("aria-hidden", "false"))
        }
        deactivate() {
            this.instance.dispatch("contentDeactivate", {
                content: this
            }),
            this.slide && this.slide.holderElement && this.slide.holderElement.setAttribute("aria-hidden", "true")
        }
        remove() {
            this.isAttached = !1,
            this.instance.dispatch("contentRemove", {
                content: this
            }).defaultPrevented || (this.element && this.element.parentNode && this.element.remove(),
            this.placeholder && this.placeholder.element && this.placeholder.element.remove())
        }
        appendImage() {
            this.isAttached && (this.instance.dispatch("contentAppendImage", {
                content: this
            }).defaultPrevented || (this.slide && this.element && !this.element.parentNode && this.slide.container.appendChild(this.element),
            this.state !== _n && this.state !== bn || this.removePlaceholder()))
        }
    }
    ;
    function Pn(t, e, i, s, n) {
        let r = 0;
        if (e.paddingFn)
            r = e.paddingFn(i, s, n)[t];
        else if (e.padding)
            r = e.padding[t];
        else {
            const i = "padding" + t[0].toUpperCase() + t.slice(1);
            e[i] && (r = e[i])
        }
        return Number(r) || 0
    }
    let Cn = class {
        constructor(t, e, i, s) {
            this.pswp = s,
            this.options = t,
            this.itemData = e,
            this.index = i,
            this.panAreaSize = null,
            this.elementSize = null,
            this.fit = 1,
            this.fill = 1,
            this.vFill = 1,
            this.initial = 1,
            this.secondary = 1,
            this.max = 1,
            this.min = 1
        }
        update(t, e, i) {
            const s = {
                x: t,
                y: e
            };
            this.elementSize = s,
            this.panAreaSize = i;
            const n = i.x / s.x
              , r = i.y / s.y;
            this.fit = Math.min(1, n < r ? n : r),
            this.fill = Math.min(1, n > r ? n : r),
            this.vFill = Math.min(1, r),
            this.initial = this._getInitial(),
            this.secondary = this._getSecondary(),
            this.max = Math.max(this.initial, this.secondary, this._getMax()),
            this.min = Math.min(this.fit, this.initial, this.secondary),
            this.pswp && this.pswp.dispatch("zoomLevelsUpdate", {
                zoomLevels: this,
                slideData: this.itemData
            })
        }
        _parseZoomLevelOption(t) {
            const e = t + "ZoomLevel"
              , i = this.options[e];
            if (i)
                return "function" == typeof i ? i(this) : "fill" === i ? this.fill : "fit" === i ? this.fit : Number(i)
        }
        _getSecondary() {
            let t = this._parseZoomLevelOption("secondary");
            return t || (t = Math.min(1, 3 * this.fit),
            this.elementSize && t * this.elementSize.x > 4e3 && (t = 4e3 / this.elementSize.x),
            t)
        }
        _getInitial() {
            return this._parseZoomLevelOption("initial") || this.fit
        }
        _getMax() {
            return this._parseZoomLevelOption("max") || Math.max(1, 4 * this.fit)
        }
    }
    ;
    function An(t, e, i) {
        const s = e.createContentFromData(t, i);
        let n;
        const {options: r} = e;
        if (r) {
            let o;
            n = new Cn(r,t,-1),
            o = e.pswp ? e.pswp.viewportSize : function(t, e) {
                if (t.getViewportSizeFn) {
                    const i = t.getViewportSizeFn(t, e);
                    if (i)
                        return i
                }
                return {
                    x: document.documentElement.clientWidth,
                    y: window.innerHeight
                }
            }(r, e);
            const a = function(t, e, i, s) {
                return {
                    x: e.x - Pn("left", t, e, i, s) - Pn("right", t, e, i, s),
                    y: e.y - Pn("top", t, e, i, s) - Pn("bottom", t, e, i, s)
                }
            }(r, o, t, i);
            n.update(s.width, s.height, a)
        }
        return s.lazyLoad(),
        n && s.setDisplayedSize(Math.ceil(s.width * n.initial), Math.ceil(s.height * n.initial)),
        s
    }
    let Mn = class extends xn {
        getNumItems() {
            var t;
            let e = 0;
            const i = null === (t = this.options) || void 0 === t ? void 0 : t.dataSource;
            i && "length"in i ? e = i.length : i && "gallery"in i && (i.items || (i.items = this._getGalleryDOMElements(i.gallery)),
            i.items && (e = i.items.length));
            const s = this.dispatch("numItems", {
                dataSource: i,
                numItems: e
            });
            return this.applyFilters("numItems", s.numItems, i)
        }
        createContentFromData(t, e) {
            return new On(t,this,e)
        }
        getItemData(t) {
            var e;
            const i = null === (e = this.options) || void 0 === e ? void 0 : e.dataSource;
            let s = {};
            Array.isArray(i) ? s = i[t] : i && "gallery"in i && (i.items || (i.items = this._getGalleryDOMElements(i.gallery)),
            s = i.items[t]);
            let n = s;
            n instanceof Element && (n = this._domElementToItemData(n));
            const r = this.dispatch("itemData", {
                itemData: n || {},
                index: t
            });
            return this.applyFilters("itemData", r.itemData, t)
        }
        _getGalleryDOMElements(t) {
            var e, i;
            return null !== (e = this.options) && void 0 !== e && e.children || null !== (i = this.options) && void 0 !== i && i.childSelector ? wn(this.options.children, this.options.childSelector, t) || [] : [t]
        }
        _domElementToItemData(t) {
            const e = {
                element: t
            }
              , i = "A" === t.tagName ? t : t.querySelector("a");
            if (i) {
                e.src = i.dataset.pswpSrc || i.href,
                i.dataset.pswpSrcset && (e.srcset = i.dataset.pswpSrcset),
                e.width = i.dataset.pswpWidth ? parseInt(i.dataset.pswpWidth, 10) : 0,
                e.height = i.dataset.pswpHeight ? parseInt(i.dataset.pswpHeight, 10) : 0,
                e.w = e.width,
                e.h = e.height,
                i.dataset.pswpType && (e.type = i.dataset.pswpType);
                const n = t.querySelector("img");
                var s;
                if (n)
                    e.msrc = n.currentSrc || n.src,
                    e.alt = null !== (s = n.getAttribute("alt")) && void 0 !== s ? s : "";
                (i.dataset.pswpCropped || i.dataset.cropped) && (e.thumbCropped = !0)
            }
            return this.applyFilters("domItemData", e, t, i)
        }
        lazyLoadData(t, e) {
            return An(t, this, e)
        }
    }
    ;
    class Tn extends Mn {
        constructor(t) {
            super(),
            this.options = t || {},
            this._uid = 0,
            this.shouldOpen = !1,
            this._preloadedContent = void 0,
            this.onThumbnailsClick = this.onThumbnailsClick.bind(this)
        }
        init() {
            wn(this.options.gallery, this.options.gallerySelector).forEach((t => {
                t.addEventListener("click", this.onThumbnailsClick, !1)
            }
            ))
        }
        onThumbnailsClick(t) {
            if (function(t) {
                return "button"in t && 1 === t.button || t.ctrlKey || t.metaKey || t.altKey || t.shiftKey
            }(t) || window.pswp)
                return;
            let e = {
                x: t.clientX,
                y: t.clientY
            };
            e.x || e.y || (e = null);
            let i = this.getClickedIndex(t);
            i = this.applyFilters("clickedIndex", i, t, this);
            const s = {
                gallery: t.currentTarget
            };
            i >= 0 && (t.preventDefault(),
            this.loadAndOpen(i, s, e))
        }
        getClickedIndex(t) {
            if (this.options.getClickedIndexFn)
                return this.options.getClickedIndexFn.call(this, t);
            const e = t.target
              , i = wn(this.options.children, this.options.childSelector, t.currentTarget).findIndex((t => t === e || t.contains(e)));
            return -1 !== i ? i : this.options.children || this.options.childSelector ? -1 : 0
        }
        loadAndOpen(t, e, i) {
            if (window.pswp || !this.options)
                return !1;
            if (!e && this.options.gallery && this.options.children) {
                const t = wn(this.options.gallery);
                t[0] && (e = {
                    gallery: t[0]
                })
            }
            return this.options.index = t,
            this.options.initialPointerPos = i,
            this.shouldOpen = !0,
            this.preload(t, e),
            !0
        }
        preload(t, e) {
            const {options: i} = this;
            e && (i.dataSource = e);
            const s = []
              , n = typeof i.pswpModule;
            if ("function" == typeof (r = i.pswpModule) && r.prototype && r.prototype.goTo)
                s.push(Promise.resolve(i.pswpModule));
            else {
                if ("string" === n)
                    throw new Error("pswpModule as string is no longer supported");
                if ("function" !== n)
                    throw new Error("pswpModule is not valid");
                s.push(i.pswpModule())
            }
            var r;
            "function" == typeof i.openPromise && s.push(i.openPromise()),
            !1 !== i.preloadFirstSlide && t >= 0 && (this._preloadedContent = function(t, e) {
                const i = e.getItemData(t);
                if (!e.dispatch("lazyLoadSlide", {
                    index: t,
                    itemData: i
                }).defaultPrevented)
                    return An(i, e, t)
            }(t, this));
            const o = ++this._uid;
            Promise.all(s).then((t => {
                if (this.shouldOpen) {
                    const e = t[0];
                    this._openPhotoswipe(e, o)
                }
            }
            ))
        }
        _openPhotoswipe(t, e) {
            if (e !== this._uid && this.shouldOpen)
                return;
            if (this.shouldOpen = !1,
            window.pswp)
                return;
            const i = "object" == typeof t ? new t.default(this.options) : new t(this.options);
            this.pswp = i,
            window.pswp = i,
            Object.keys(this._listeners).forEach((t => {
                var e;
                null === (e = this._listeners[t]) || void 0 === e || e.forEach((e => {
                    i.on(t, e)
                }
                ))
            }
            )),
            Object.keys(this._filters).forEach((t => {
                var e;
                null === (e = this._filters[t]) || void 0 === e || e.forEach((e => {
                    i.addFilter(t, e.fn, e.priority)
                }
                ))
            }
            )),
            this._preloadedContent && (i.contentLoader.addToCache(this._preloadedContent),
            this._preloadedContent = void 0),
            i.on("destroy", ( () => {
                this.pswp = void 0,
                delete window.pswp
            }
            )),
            i.init()
        }
        destroy() {
            var t;
            null === (t = this.pswp) || void 0 === t || t.destroy(),
            this.shouldOpen = !1,
            this._listeners = {},
            wn(this.options.gallery, this.options.gallerySelector).forEach((t => {
                t.removeEventListener("click", this.onThumbnailsClick, !1)
            }
            ))
        }
    }
    /*!
    * PhotoSwipe 5.4.4 - https://photoswipe.com
    * (c) 2024 Dmytro Semenov
    */
    function In(t, e, i) {
        const s = document.createElement(e);
        return t && (s.className = t),
        i && i.appendChild(s),
        s
    }
    function Dn(t, e) {
        return t.x = e.x,
        t.y = e.y,
        void 0 !== e.id && (t.id = e.id),
        t
    }
    function kn(t) {
        t.x = Math.round(t.x),
        t.y = Math.round(t.y)
    }
    function zn(t, e) {
        const i = Math.abs(t.x - e.x)
          , s = Math.abs(t.y - e.y);
        return Math.sqrt(i * i + s * s)
    }
    function Fn(t, e) {
        return t.x === e.x && t.y === e.y
    }
    function Nn(t, e, i) {
        return Math.min(Math.max(t, e), i)
    }
    function Rn(t, e, i) {
        let s = `translate3d(${t}px,${e || 0}px,0)`;
        return void 0 !== i && (s += ` scale3d(${i},${i},1)`),
        s
    }
    function Yn(t, e, i, s) {
        t.style.transform = Rn(e, i, s)
    }
    const jn = "cubic-bezier(.4,0,.22,1)";
    function Hn(t, e, i, s) {
        t.style.transition = e ? `${e} ${i}ms ${s || jn}` : "none"
    }
    function $n(t, e, i) {
        t.style.width = "number" == typeof e ? `${e}px` : e,
        t.style.height = "number" == typeof i ? `${i}px` : i
    }
    const Bn = "idle"
      , Zn = "loading"
      , Vn = "loaded"
      , qn = "error";
    function Un() {
        return !(!navigator.vendor || !navigator.vendor.match(/apple/i))
    }
    let Wn = !1;
    try {
        window.addEventListener("test", null, Object.defineProperty({}, "passive", {
            get: () => {
                Wn = !0
            }
        }))
    } catch (t) {}
    class Xn {
        constructor() {
            this._pool = []
        }
        add(t, e, i, s) {
            this._toggleListener(t, e, i, s)
        }
        remove(t, e, i, s) {
            this._toggleListener(t, e, i, s, !0)
        }
        removeAll() {
            this._pool.forEach((t => {
                this._toggleListener(t.target, t.type, t.listener, t.passive, !0, !0)
            }
            )),
            this._pool = []
        }
        _toggleListener(t, e, i, s, n, r) {
            if (!t)
                return;
            const o = n ? "removeEventListener" : "addEventListener";
            e.split(" ").forEach((e => {
                if (e) {
                    r || (n ? this._pool = this._pool.filter((s => s.type !== e || s.listener !== i || s.target !== t)) : this._pool.push({
                        target: t,
                        type: e,
                        listener: i,
                        passive: s
                    }));
                    const a = !!Wn && {
                        passive: s || !1
                    };
                    t[o](e, i, a)
                }
            }
            ))
        }
    }
    function Gn(t, e) {
        if (t.getViewportSizeFn) {
            const i = t.getViewportSizeFn(t, e);
            if (i)
                return i
        }
        return {
            x: document.documentElement.clientWidth,
            y: window.innerHeight
        }
    }
    function Jn(t, e, i, s, n) {
        let r = 0;
        if (e.paddingFn)
            r = e.paddingFn(i, s, n)[t];
        else if (e.padding)
            r = e.padding[t];
        else {
            const i = "padding" + t[0].toUpperCase() + t.slice(1);
            e[i] && (r = e[i])
        }
        return Number(r) || 0
    }
    function Kn(t, e, i, s) {
        return {
            x: e.x - Jn("left", t, e, i, s) - Jn("right", t, e, i, s),
            y: e.y - Jn("top", t, e, i, s) - Jn("bottom", t, e, i, s)
        }
    }
    class Qn {
        constructor(t) {
            this.slide = t,
            this.currZoomLevel = 1,
            this.center = {
                x: 0,
                y: 0
            },
            this.max = {
                x: 0,
                y: 0
            },
            this.min = {
                x: 0,
                y: 0
            }
        }
        update(t) {
            this.currZoomLevel = t,
            this.slide.width ? (this._updateAxis("x"),
            this._updateAxis("y"),
            this.slide.pswp.dispatch("calcBounds", {
                slide: this.slide
            })) : this.reset()
        }
        _updateAxis(t) {
            const {pswp: e} = this.slide
              , i = this.slide["x" === t ? "width" : "height"] * this.currZoomLevel
              , s = Jn("x" === t ? "left" : "top", e.options, e.viewportSize, this.slide.data, this.slide.index)
              , n = this.slide.panAreaSize[t];
            this.center[t] = Math.round((n - i) / 2) + s,
            this.max[t] = i > n ? Math.round(n - i) + s : this.center[t],
            this.min[t] = i > n ? s : this.center[t]
        }
        reset() {
            this.center.x = 0,
            this.center.y = 0,
            this.max.x = 0,
            this.max.y = 0,
            this.min.x = 0,
            this.min.y = 0
        }
        correctPan(t, e) {
            return Nn(e, this.max[t], this.min[t])
        }
    }
    class tr {
        constructor(t, e, i, s) {
            this.pswp = s,
            this.options = t,
            this.itemData = e,
            this.index = i,
            this.panAreaSize = null,
            this.elementSize = null,
            this.fit = 1,
            this.fill = 1,
            this.vFill = 1,
            this.initial = 1,
            this.secondary = 1,
            this.max = 1,
            this.min = 1
        }
        update(t, e, i) {
            const s = {
                x: t,
                y: e
            };
            this.elementSize = s,
            this.panAreaSize = i;
            const n = i.x / s.x
              , r = i.y / s.y;
            this.fit = Math.min(1, n < r ? n : r),
            this.fill = Math.min(1, n > r ? n : r),
            this.vFill = Math.min(1, r),
            this.initial = this._getInitial(),
            this.secondary = this._getSecondary(),
            this.max = Math.max(this.initial, this.secondary, this._getMax()),
            this.min = Math.min(this.fit, this.initial, this.secondary),
            this.pswp && this.pswp.dispatch("zoomLevelsUpdate", {
                zoomLevels: this,
                slideData: this.itemData
            })
        }
        _parseZoomLevelOption(t) {
            const e = t + "ZoomLevel"
              , i = this.options[e];
            if (i)
                return "function" == typeof i ? i(this) : "fill" === i ? this.fill : "fit" === i ? this.fit : Number(i)
        }
        _getSecondary() {
            let t = this._parseZoomLevelOption("secondary");
            return t || (t = Math.min(1, 3 * this.fit),
            this.elementSize && t * this.elementSize.x > 4e3 && (t = 4e3 / this.elementSize.x),
            t)
        }
        _getInitial() {
            return this._parseZoomLevelOption("initial") || this.fit
        }
        _getMax() {
            return this._parseZoomLevelOption("max") || Math.max(1, 4 * this.fit)
        }
    }
    class er {
        constructor(t, e, i) {
            this.data = t,
            this.index = e,
            this.pswp = i,
            this.isActive = e === i.currIndex,
            this.currentResolution = 0,
            this.panAreaSize = {
                x: 0,
                y: 0
            },
            this.pan = {
                x: 0,
                y: 0
            },
            this.isFirstSlide = this.isActive && !i.opener.isOpen,
            this.zoomLevels = new tr(i.options,t,e,i),
            this.pswp.dispatch("gettingData", {
                slide: this,
                data: this.data,
                index: e
            }),
            this.content = this.pswp.contentLoader.getContentBySlide(this),
            this.container = In("pswp__zoom-wrap", "div"),
            this.holderElement = null,
            this.currZoomLevel = 1,
            this.width = this.content.width,
            this.height = this.content.height,
            this.heavyAppended = !1,
            this.bounds = new Qn(this),
            this.prevDisplayedWidth = -1,
            this.prevDisplayedHeight = -1,
            this.pswp.dispatch("slideInit", {
                slide: this
            })
        }
        setIsActive(t) {
            t && !this.isActive ? this.activate() : !t && this.isActive && this.deactivate()
        }
        append(t) {
            this.holderElement = t,
            this.container.style.transformOrigin = "0 0",
            this.data && (this.calculateSize(),
            this.load(),
            this.updateContentSize(),
            this.appendHeavy(),
            this.holderElement.appendChild(this.container),
            this.zoomAndPanToInitial(),
            this.pswp.dispatch("firstZoomPan", {
                slide: this
            }),
            this.applyCurrentZoomPan(),
            this.pswp.dispatch("afterSetContent", {
                slide: this
            }),
            this.isActive && this.activate())
        }
        load() {
            this.content.load(!1),
            this.pswp.dispatch("slideLoad", {
                slide: this
            })
        }
        appendHeavy() {
            const {pswp: t} = this;
            !this.heavyAppended && t.opener.isOpen && !t.mainScroll.isShifted() && (this.isActive,
            1) && (this.pswp.dispatch("appendHeavy", {
                slide: this
            }).defaultPrevented || (this.heavyAppended = !0,
            this.content.append(),
            this.pswp.dispatch("appendHeavyContent", {
                slide: this
            })))
        }
        activate() {
            this.isActive = !0,
            this.appendHeavy(),
            this.content.activate(),
            this.pswp.dispatch("slideActivate", {
                slide: this
            })
        }
        deactivate() {
            this.isActive = !1,
            this.content.deactivate(),
            this.currZoomLevel !== this.zoomLevels.initial && this.calculateSize(),
            this.currentResolution = 0,
            this.zoomAndPanToInitial(),
            this.applyCurrentZoomPan(),
            this.updateContentSize(),
            this.pswp.dispatch("slideDeactivate", {
                slide: this
            })
        }
        destroy() {
            this.content.hasSlide = !1,
            this.content.remove(),
            this.container.remove(),
            this.pswp.dispatch("slideDestroy", {
                slide: this
            })
        }
        resize() {
            this.currZoomLevel !== this.zoomLevels.initial && this.isActive ? (this.calculateSize(),
            this.bounds.update(this.currZoomLevel),
            this.panTo(this.pan.x, this.pan.y)) : (this.calculateSize(),
            this.currentResolution = 0,
            this.zoomAndPanToInitial(),
            this.applyCurrentZoomPan(),
            this.updateContentSize())
        }
        updateContentSize(t) {
            const e = this.currentResolution || this.zoomLevels.initial;
            if (!e)
                return;
            const i = Math.round(this.width * e) || this.pswp.viewportSize.x
              , s = Math.round(this.height * e) || this.pswp.viewportSize.y;
            (this.sizeChanged(i, s) || t) && this.content.setDisplayedSize(i, s)
        }
        sizeChanged(t, e) {
            return (t !== this.prevDisplayedWidth || e !== this.prevDisplayedHeight) && (this.prevDisplayedWidth = t,
            this.prevDisplayedHeight = e,
            !0)
        }
        getPlaceholderElement() {
            var t;
            return null === (t = this.content.placeholder) || void 0 === t ? void 0 : t.element
        }
        zoomTo(t, e, i, s) {
            const {pswp: n} = this;
            if (!this.isZoomable() || n.mainScroll.isShifted())
                return;
            n.dispatch("beforeZoomTo", {
                destZoomLevel: t,
                centerPoint: e,
                transitionDuration: i
            }),
            n.animations.stopAllPan();
            const r = this.currZoomLevel;
            s || (t = Nn(t, this.zoomLevels.min, this.zoomLevels.max)),
            this.setZoomLevel(t),
            this.pan.x = this.calculateZoomToPanOffset("x", e, r),
            this.pan.y = this.calculateZoomToPanOffset("y", e, r),
            kn(this.pan);
            const o = () => {
                this._setResolution(t),
                this.applyCurrentZoomPan()
            }
            ;
            i ? n.animations.startTransition({
                isPan: !0,
                name: "zoomTo",
                target: this.container,
                transform: this.getCurrentTransform(),
                onComplete: o,
                duration: i,
                easing: n.options.easing
            }) : o()
        }
        toggleZoom(t) {
            this.zoomTo(this.currZoomLevel === this.zoomLevels.initial ? this.zoomLevels.secondary : this.zoomLevels.initial, t, this.pswp.options.zoomAnimationDuration)
        }
        setZoomLevel(t) {
            this.currZoomLevel = t,
            this.bounds.update(this.currZoomLevel)
        }
        calculateZoomToPanOffset(t, e, i) {
            if (0 === this.bounds.max[t] - this.bounds.min[t])
                return this.bounds.center[t];
            e || (e = this.pswp.getViewportCenterPoint()),
            i || (i = this.zoomLevels.initial);
            const s = this.currZoomLevel / i;
            return this.bounds.correctPan(t, (this.pan[t] - e[t]) * s + e[t])
        }
        panTo(t, e) {
            this.pan.x = this.bounds.correctPan("x", t),
            this.pan.y = this.bounds.correctPan("y", e),
            this.applyCurrentZoomPan()
        }
        isPannable() {
            return Boolean(this.width) && this.currZoomLevel > this.zoomLevels.fit
        }
        isZoomable() {
            return Boolean(this.width) && this.content.isZoomable()
        }
        applyCurrentZoomPan() {
            this._applyZoomTransform(this.pan.x, this.pan.y, this.currZoomLevel),
            this === this.pswp.currSlide && this.pswp.dispatch("zoomPanUpdate", {
                slide: this
            })
        }
        zoomAndPanToInitial() {
            this.currZoomLevel = this.zoomLevels.initial,
            this.bounds.update(this.currZoomLevel),
            Dn(this.pan, this.bounds.center),
            this.pswp.dispatch("initialZoomPan", {
                slide: this
            })
        }
        _applyZoomTransform(t, e, i) {
            i /= this.currentResolution || this.zoomLevels.initial,
            Yn(this.container, t, e, i)
        }
        calculateSize() {
            const {pswp: t} = this;
            Dn(this.panAreaSize, Kn(t.options, t.viewportSize, this.data, this.index)),
            this.zoomLevels.update(this.width, this.height, this.panAreaSize),
            t.dispatch("calcSlideSize", {
                slide: this
            })
        }
        getCurrentTransform() {
            const t = this.currZoomLevel / (this.currentResolution || this.zoomLevels.initial);
            return Rn(this.pan.x, this.pan.y, t)
        }
        _setResolution(t) {
            t !== this.currentResolution && (this.currentResolution = t,
            this.updateContentSize(),
            this.pswp.dispatch("resolutionChanged"))
        }
    }
    class ir {
        constructor(t) {
            this.gestures = t,
            this.pswp = t.pswp,
            this.startPan = {
                x: 0,
                y: 0
            }
        }
        start() {
            this.pswp.currSlide && Dn(this.startPan, this.pswp.currSlide.pan),
            this.pswp.animations.stopAll()
        }
        change() {
            const {p1: t, prevP1: e, dragAxis: i} = this.gestures
              , {currSlide: s} = this.pswp;
            if ("y" === i && this.pswp.options.closeOnVerticalDrag && s && s.currZoomLevel <= s.zoomLevels.fit && !this.gestures.isMultitouch) {
                const i = s.pan.y + (t.y - e.y);
                if (!this.pswp.dispatch("verticalDrag", {
                    panY: i
                }).defaultPrevented) {
                    this._setPanWithFriction("y", i, .6);
                    const t = 1 - Math.abs(this._getVerticalDragRatio(s.pan.y));
                    this.pswp.applyBgOpacity(t),
                    s.applyCurrentZoomPan()
                }
            } else {
                this._panOrMoveMainScroll("x") || (this._panOrMoveMainScroll("y"),
                s && (kn(s.pan),
                s.applyCurrentZoomPan()))
            }
        }
        end() {
            const {velocity: t} = this.gestures
              , {mainScroll: e, currSlide: i} = this.pswp;
            let s = 0;
            if (this.pswp.animations.stopAll(),
            e.isShifted()) {
                const i = (e.x - e.getCurrSlideX()) / this.pswp.viewportSize.x;
                t.x < -.5 && i < 0 || t.x < .1 && i < -.5 ? (s = 1,
                t.x = Math.min(t.x, 0)) : (t.x > .5 && i > 0 || t.x > -.1 && i > .5) && (s = -1,
                t.x = Math.max(t.x, 0)),
                e.moveIndexBy(s, !0, t.x)
            }
            i && i.currZoomLevel > i.zoomLevels.max || this.gestures.isMultitouch ? this.gestures.zoomLevels.correctZoomPan(!0) : (this._finishPanGestureForAxis("x"),
            this._finishPanGestureForAxis("y"))
        }
        _finishPanGestureForAxis(t) {
            const {velocity: e} = this.gestures
              , {currSlide: i} = this.pswp;
            if (!i)
                return;
            const {pan: s, bounds: n} = i
              , r = s[t]
              , o = this.pswp.bgOpacity < 1 && "y" === t
              , a = r + function(t, e) {
                return t * e / (1 - e)
            }(e[t], .995);
            if (o) {
                const t = this._getVerticalDragRatio(r)
                  , e = this._getVerticalDragRatio(a);
                if (t < 0 && e < -.4 || t > 0 && e > .4)
                    return void this.pswp.close()
            }
            const l = n.correctPan(t, a);
            if (r === l)
                return;
            const c = l === a ? 1 : .82
              , h = this.pswp.bgOpacity
              , d = l - r;
            this.pswp.animations.startSpring({
                name: "panGesture" + t,
                isPan: !0,
                start: r,
                end: l,
                velocity: e[t],
                dampingRatio: c,
                onUpdate: e => {
                    if (o && this.pswp.bgOpacity < 1) {
                        const t = 1 - (l - e) / d;
                        this.pswp.applyBgOpacity(Nn(h + (1 - h) * t, 0, 1))
                    }
                    s[t] = Math.floor(e),
                    i.applyCurrentZoomPan()
                }
            })
        }
        _panOrMoveMainScroll(t) {
            const {p1: e, dragAxis: i, prevP1: s, isMultitouch: n} = this.gestures
              , {currSlide: r, mainScroll: o} = this.pswp
              , a = e[t] - s[t]
              , l = o.x + a;
            if (!a || !r)
                return !1;
            if ("x" === t && !r.isPannable() && !n)
                return o.moveTo(l, !0),
                !0;
            const {bounds: c} = r
              , h = r.pan[t] + a;
            if (this.pswp.options.allowPanToNext && "x" === i && "x" === t && !n) {
                const e = o.getCurrSlideX()
                  , i = o.x - e
                  , s = a > 0
                  , n = !s;
                if (h > c.min[t] && s) {
                    if (c.min[t] <= this.startPan[t])
                        return o.moveTo(l, !0),
                        !0;
                    this._setPanWithFriction(t, h)
                } else if (h < c.max[t] && n) {
                    if (this.startPan[t] <= c.max[t])
                        return o.moveTo(l, !0),
                        !0;
                    this._setPanWithFriction(t, h)
                } else if (0 !== i) {
                    if (i > 0)
                        return o.moveTo(Math.max(l, e), !0),
                        !0;
                    if (i < 0)
                        return o.moveTo(Math.min(l, e), !0),
                        !0
                } else
                    this._setPanWithFriction(t, h)
            } else
                "y" === t && (o.isShifted() || c.min.y === c.max.y) || this._setPanWithFriction(t, h);
            return !1
        }
        _getVerticalDragRatio(t) {
            var e, i;
            return (t - (null !== (e = null === (i = this.pswp.currSlide) || void 0 === i ? void 0 : i.bounds.center.y) && void 0 !== e ? e : 0)) / (this.pswp.viewportSize.y / 3)
        }
        _setPanWithFriction(t, e, i) {
            const {currSlide: s} = this.pswp;
            if (!s)
                return;
            const {pan: n, bounds: r} = s;
            if (r.correctPan(t, e) !== e || i) {
                const s = Math.round(e - n[t]);
                n[t] += s * (i || .35)
            } else
                n[t] = e
        }
    }
    function sr(t, e, i) {
        return t.x = (e.x + i.x) / 2,
        t.y = (e.y + i.y) / 2,
        t
    }
    class nr {
        constructor(t) {
            this.gestures = t,
            this._startPan = {
                x: 0,
                y: 0
            },
            this._startZoomPoint = {
                x: 0,
                y: 0
            },
            this._zoomPoint = {
                x: 0,
                y: 0
            },
            this._wasOverFitZoomLevel = !1,
            this._startZoomLevel = 1
        }
        start() {
            const {currSlide: t} = this.gestures.pswp;
            t && (this._startZoomLevel = t.currZoomLevel,
            Dn(this._startPan, t.pan)),
            this.gestures.pswp.animations.stopAllPan(),
            this._wasOverFitZoomLevel = !1
        }
        change() {
            const {p1: t, startP1: e, p2: i, startP2: s, pswp: n} = this.gestures
              , {currSlide: r} = n;
            if (!r)
                return;
            const o = r.zoomLevels.min
              , a = r.zoomLevels.max;
            if (!r.isZoomable() || n.mainScroll.isShifted())
                return;
            sr(this._startZoomPoint, e, s),
            sr(this._zoomPoint, t, i);
            let l = 1 / zn(e, s) * zn(t, i) * this._startZoomLevel;
            if (l > r.zoomLevels.initial + r.zoomLevels.initial / 15 && (this._wasOverFitZoomLevel = !0),
            l < o)
                if (n.options.pinchToClose && !this._wasOverFitZoomLevel && this._startZoomLevel <= r.zoomLevels.initial) {
                    const t = 1 - (o - l) / (o / 1.2);
                    n.dispatch("pinchClose", {
                        bgOpacity: t
                    }).defaultPrevented || n.applyBgOpacity(t)
                } else
                    l = o - .15 * (o - l);
            else
                l > a && (l = a + .05 * (l - a));
            r.pan.x = this._calculatePanForZoomLevel("x", l),
            r.pan.y = this._calculatePanForZoomLevel("y", l),
            r.setZoomLevel(l),
            r.applyCurrentZoomPan()
        }
        end() {
            const {pswp: t} = this.gestures
              , {currSlide: e} = t;
            (!e || e.currZoomLevel < e.zoomLevels.initial) && !this._wasOverFitZoomLevel && t.options.pinchToClose ? t.close() : this.correctZoomPan()
        }
        _calculatePanForZoomLevel(t, e) {
            const i = e / this._startZoomLevel;
            return this._zoomPoint[t] - (this._startZoomPoint[t] - this._startPan[t]) * i
        }
        correctZoomPan(t) {
            const {pswp: e} = this.gestures
              , {currSlide: i} = e;
            if (null == i || !i.isZoomable())
                return;
            0 === this._zoomPoint.x && (t = !0);
            const s = i.currZoomLevel;
            let n, r = !0;
            s < i.zoomLevels.initial ? n = i.zoomLevels.initial : s > i.zoomLevels.max ? n = i.zoomLevels.max : (r = !1,
            n = s);
            const o = e.bgOpacity
              , a = e.bgOpacity < 1
              , l = Dn({
                x: 0,
                y: 0
            }, i.pan);
            let c = Dn({
                x: 0,
                y: 0
            }, l);
            t && (this._zoomPoint.x = 0,
            this._zoomPoint.y = 0,
            this._startZoomPoint.x = 0,
            this._startZoomPoint.y = 0,
            this._startZoomLevel = s,
            Dn(this._startPan, l)),
            r && (c = {
                x: this._calculatePanForZoomLevel("x", n),
                y: this._calculatePanForZoomLevel("y", n)
            }),
            i.setZoomLevel(n),
            c = {
                x: i.bounds.correctPan("x", c.x),
                y: i.bounds.correctPan("y", c.y)
            },
            i.setZoomLevel(s);
            const h = !Fn(c, l);
            if (!h && !r && !a)
                return i._setResolution(n),
                void i.applyCurrentZoomPan();
            e.animations.stopAllPan(),
            e.animations.startSpring({
                isPan: !0,
                start: 0,
                end: 1e3,
                velocity: 0,
                dampingRatio: 1,
                naturalFrequency: 40,
                onUpdate: t => {
                    if (t /= 1e3,
                    h || r) {
                        if (h && (i.pan.x = l.x + (c.x - l.x) * t,
                        i.pan.y = l.y + (c.y - l.y) * t),
                        r) {
                            const e = s + (n - s) * t;
                            i.setZoomLevel(e)
                        }
                        i.applyCurrentZoomPan()
                    }
                    a && e.bgOpacity < 1 && e.applyBgOpacity(Nn(o + (1 - o) * t, 0, 1))
                }
                ,
                onComplete: () => {
                    i._setResolution(n),
                    i.applyCurrentZoomPan()
                }
            })
        }
    }
    function rr(t) {
        return !!t.target.closest(".pswp__container")
    }
    class or {
        constructor(t) {
            this.gestures = t
        }
        click(t, e) {
            const i = e.target.classList
              , s = i.contains("pswp__img")
              , n = i.contains("pswp__item") || i.contains("pswp__zoom-wrap");
            s ? this._doClickOrTapAction("imageClick", t, e) : n && this._doClickOrTapAction("bgClick", t, e)
        }
        tap(t, e) {
            rr(e) && this._doClickOrTapAction("tap", t, e)
        }
        doubleTap(t, e) {
            rr(e) && this._doClickOrTapAction("doubleTap", t, e)
        }
        _doClickOrTapAction(t, e, i) {
            var s;
            const {pswp: n} = this.gestures
              , {currSlide: r} = n
              , o = t + "Action"
              , a = n.options[o];
            if (!n.dispatch(o, {
                point: e,
                originalEvent: i
            }).defaultPrevented)
                if ("function" != typeof a)
                    switch (a) {
                    case "close":
                    case "next":
                        n[a]();
                        break;
                    case "zoom":
                        null == r || r.toggleZoom(e);
                        break;
                    case "zoom-or-close":
                        null != r && r.isZoomable() && r.zoomLevels.secondary !== r.zoomLevels.initial ? r.toggleZoom(e) : n.options.clickToCloseNonZoomable && n.close();
                        break;
                    case "toggle-controls":
                        null === (s = this.gestures.pswp.element) || void 0 === s || s.classList.toggle("pswp--ui-visible")
                    }
                else
                    a.call(n, e, i)
        }
    }
    class ar {
        constructor(t) {
            this.pswp = t,
            this.dragAxis = null,
            this.p1 = {
                x: 0,
                y: 0
            },
            this.p2 = {
                x: 0,
                y: 0
            },
            this.prevP1 = {
                x: 0,
                y: 0
            },
            this.prevP2 = {
                x: 0,
                y: 0
            },
            this.startP1 = {
                x: 0,
                y: 0
            },
            this.startP2 = {
                x: 0,
                y: 0
            },
            this.velocity = {
                x: 0,
                y: 0
            },
            this._lastStartP1 = {
                x: 0,
                y: 0
            },
            this._intervalP1 = {
                x: 0,
                y: 0
            },
            this._numActivePoints = 0,
            this._ongoingPointers = [],
            this._touchEventEnabled = "ontouchstart"in window,
            this._pointerEventEnabled = !!window.PointerEvent,
            this.supportsTouch = this._touchEventEnabled || this._pointerEventEnabled && navigator.maxTouchPoints > 1,
            this._numActivePoints = 0,
            this._intervalTime = 0,
            this._velocityCalculated = !1,
            this.isMultitouch = !1,
            this.isDragging = !1,
            this.isZooming = !1,
            this.raf = null,
            this._tapTimer = null,
            this.supportsTouch || (t.options.allowPanToNext = !1),
            this.drag = new ir(this),
            this.zoomLevels = new nr(this),
            this.tapHandler = new or(this),
            t.on("bindEvents", ( () => {
                t.events.add(t.scrollWrap, "click", this._onClick.bind(this)),
                this._pointerEventEnabled ? this._bindEvents("pointer", "down", "up", "cancel") : this._touchEventEnabled ? (this._bindEvents("touch", "start", "end", "cancel"),
                t.scrollWrap && (t.scrollWrap.ontouchmove = () => {}
                ,
                t.scrollWrap.ontouchend = () => {}
                )) : this._bindEvents("mouse", "down", "up")
            }
            ))
        }
        _bindEvents(t, e, i, s) {
            const {pswp: n} = this
              , {events: r} = n
              , o = s ? t + s : "";
            r.add(n.scrollWrap, t + e, this.onPointerDown.bind(this)),
            r.add(window, t + "move", this.onPointerMove.bind(this)),
            r.add(window, t + i, this.onPointerUp.bind(this)),
            o && r.add(n.scrollWrap, o, this.onPointerUp.bind(this))
        }
        onPointerDown(t) {
            const e = "mousedown" === t.type || "mouse" === t.pointerType;
            if (e && t.button > 0)
                return;
            const {pswp: i} = this;
            i.opener.isOpen ? i.dispatch("pointerDown", {
                originalEvent: t
            }).defaultPrevented || (e && (i.mouseDetected(),
            this._preventPointerEventBehaviour(t, "down")),
            i.animations.stopAll(),
            this._updatePoints(t, "down"),
            1 === this._numActivePoints && (this.dragAxis = null,
            Dn(this.startP1, this.p1)),
            this._numActivePoints > 1 ? (this._clearTapTimer(),
            this.isMultitouch = !0) : this.isMultitouch = !1) : t.preventDefault()
        }
        onPointerMove(t) {
            this._preventPointerEventBehaviour(t, "move"),
            this._numActivePoints && (this._updatePoints(t, "move"),
            this.pswp.dispatch("pointerMove", {
                originalEvent: t
            }).defaultPrevented || (1 !== this._numActivePoints || this.isDragging ? this._numActivePoints > 1 && !this.isZooming && (this._finishDrag(),
            this.isZooming = !0,
            this._updateStartPoints(),
            this.zoomLevels.start(),
            this._rafStopLoop(),
            this._rafRenderLoop()) : (this.dragAxis || this._calculateDragDirection(),
            this.dragAxis && !this.isDragging && (this.isZooming && (this.isZooming = !1,
            this.zoomLevels.end()),
            this.isDragging = !0,
            this._clearTapTimer(),
            this._updateStartPoints(),
            this._intervalTime = Date.now(),
            this._velocityCalculated = !1,
            Dn(this._intervalP1, this.p1),
            this.velocity.x = 0,
            this.velocity.y = 0,
            this.drag.start(),
            this._rafStopLoop(),
            this._rafRenderLoop()))))
        }
        _finishDrag() {
            this.isDragging && (this.isDragging = !1,
            this._velocityCalculated || this._updateVelocity(!0),
            this.drag.end(),
            this.dragAxis = null)
        }
        onPointerUp(t) {
            this._numActivePoints && (this._updatePoints(t, "up"),
            this.pswp.dispatch("pointerUp", {
                originalEvent: t
            }).defaultPrevented || (0 === this._numActivePoints && (this._rafStopLoop(),
            this.isDragging ? this._finishDrag() : this.isZooming || this.isMultitouch || this._finishTap(t)),
            this._numActivePoints < 2 && this.isZooming && (this.isZooming = !1,
            this.zoomLevels.end(),
            1 === this._numActivePoints && (this.dragAxis = null,
            this._updateStartPoints()))))
        }
        _rafRenderLoop() {
            (this.isDragging || this.isZooming) && (this._updateVelocity(),
            this.isDragging ? Fn(this.p1, this.prevP1) || this.drag.change() : Fn(this.p1, this.prevP1) && Fn(this.p2, this.prevP2) || this.zoomLevels.change(),
            this._updatePrevPoints(),
            this.raf = requestAnimationFrame(this._rafRenderLoop.bind(this)))
        }
        _updateVelocity(t) {
            const e = Date.now()
              , i = e - this._intervalTime;
            i < 50 && !t || (this.velocity.x = this._getVelocity("x", i),
            this.velocity.y = this._getVelocity("y", i),
            this._intervalTime = e,
            Dn(this._intervalP1, this.p1),
            this._velocityCalculated = !0)
        }
        _finishTap(t) {
            const {mainScroll: e} = this.pswp;
            if (e.isShifted())
                return void e.moveIndexBy(0, !0);
            if (t.type.indexOf("cancel") > 0)
                return;
            if ("mouseup" === t.type || "mouse" === t.pointerType)
                return void this.tapHandler.click(this.startP1, t);
            const i = this.pswp.options.doubleTapAction ? 300 : 0;
            this._tapTimer ? (this._clearTapTimer(),
            zn(this._lastStartP1, this.startP1) < 25 && this.tapHandler.doubleTap(this.startP1, t)) : (Dn(this._lastStartP1, this.startP1),
            this._tapTimer = setTimeout(( () => {
                this.tapHandler.tap(this.startP1, t),
                this._clearTapTimer()
            }
            ), i))
        }
        _clearTapTimer() {
            this._tapTimer && (clearTimeout(this._tapTimer),
            this._tapTimer = null)
        }
        _getVelocity(t, e) {
            const i = this.p1[t] - this._intervalP1[t];
            return Math.abs(i) > 1 && e > 5 ? i / e : 0
        }
        _rafStopLoop() {
            this.raf && (cancelAnimationFrame(this.raf),
            this.raf = null)
        }
        _preventPointerEventBehaviour(t, e) {
            this.pswp.applyFilters("preventPointerEvent", !0, t, e) && t.preventDefault()
        }
        _updatePoints(t, e) {
            if (this._pointerEventEnabled) {
                const i = t
                  , s = this._ongoingPointers.findIndex((t => t.id === i.pointerId));
                "up" === e && s > -1 ? this._ongoingPointers.splice(s, 1) : "down" === e && -1 === s ? this._ongoingPointers.push(this._convertEventPosToPoint(i, {
                    x: 0,
                    y: 0
                })) : s > -1 && this._convertEventPosToPoint(i, this._ongoingPointers[s]),
                this._numActivePoints = this._ongoingPointers.length,
                this._numActivePoints > 0 && Dn(this.p1, this._ongoingPointers[0]),
                this._numActivePoints > 1 && Dn(this.p2, this._ongoingPointers[1])
            } else {
                const i = t;
                this._numActivePoints = 0,
                i.type.indexOf("touch") > -1 ? i.touches && i.touches.length > 0 && (this._convertEventPosToPoint(i.touches[0], this.p1),
                this._numActivePoints++,
                i.touches.length > 1 && (this._convertEventPosToPoint(i.touches[1], this.p2),
                this._numActivePoints++)) : (this._convertEventPosToPoint(t, this.p1),
                "up" === e ? this._numActivePoints = 0 : this._numActivePoints++)
            }
        }
        _updatePrevPoints() {
            Dn(this.prevP1, this.p1),
            Dn(this.prevP2, this.p2)
        }
        _updateStartPoints() {
            Dn(this.startP1, this.p1),
            Dn(this.startP2, this.p2),
            this._updatePrevPoints()
        }
        _calculateDragDirection() {
            if (this.pswp.mainScroll.isShifted())
                this.dragAxis = "x";
            else {
                const t = Math.abs(this.p1.x - this.startP1.x) - Math.abs(this.p1.y - this.startP1.y);
                if (0 !== t) {
                    const e = t > 0 ? "x" : "y";
                    Math.abs(this.p1[e] - this.startP1[e]) >= 10 && (this.dragAxis = e)
                }
            }
        }
        _convertEventPosToPoint(t, e) {
            return e.x = t.pageX - this.pswp.offset.x,
            e.y = t.pageY - this.pswp.offset.y,
            "pointerId"in t ? e.id = t.pointerId : void 0 !== t.identifier && (e.id = t.identifier),
            e
        }
        _onClick(t) {
            this.pswp.mainScroll.isShifted() && (t.preventDefault(),
            t.stopPropagation())
        }
    }
    class lr {
        constructor(t) {
            this.pswp = t,
            this.x = 0,
            this.slideWidth = 0,
            this._currPositionIndex = 0,
            this._prevPositionIndex = 0,
            this._containerShiftIndex = -1,
            this.itemHolders = []
        }
        resize(t) {
            const {pswp: e} = this
              , i = Math.round(e.viewportSize.x + e.viewportSize.x * e.options.spacing)
              , s = i !== this.slideWidth;
            s && (this.slideWidth = i,
            this.moveTo(this.getCurrSlideX())),
            this.itemHolders.forEach(( (e, i) => {
                s && Yn(e.el, (i + this._containerShiftIndex) * this.slideWidth),
                t && e.slide && e.slide.resize()
            }
            ))
        }
        resetPosition() {
            this._currPositionIndex = 0,
            this._prevPositionIndex = 0,
            this.slideWidth = 0,
            this._containerShiftIndex = -1
        }
        appendHolders() {
            this.itemHolders = [];
            for (let t = 0; t < 3; t++) {
                const e = In("pswp__item", "div", this.pswp.container);
                e.setAttribute("role", "group"),
                e.setAttribute("aria-roledescription", "slide"),
                e.setAttribute("aria-hidden", "true"),
                e.style.display = 1 === t ? "block" : "none",
                this.itemHolders.push({
                    el: e
                })
            }
        }
        canBeSwiped() {
            return this.pswp.getNumItems() > 1
        }
        moveIndexBy(t, e, i) {
            const {pswp: s} = this;
            let n = s.potentialIndex + t;
            const r = s.getNumItems();
            if (s.canLoop()) {
                n = s.getLoopedIndex(n);
                const e = (t + r) % r;
                t = e <= r / 2 ? e : e - r
            } else
                n < 0 ? n = 0 : n >= r && (n = r - 1),
                t = n - s.potentialIndex;
            s.potentialIndex = n,
            this._currPositionIndex -= t,
            s.animations.stopMainScroll();
            const o = this.getCurrSlideX();
            if (e) {
                s.animations.startSpring({
                    isMainScroll: !0,
                    start: this.x,
                    end: o,
                    velocity: i || 0,
                    naturalFrequency: 30,
                    dampingRatio: 1,
                    onUpdate: t => {
                        this.moveTo(t)
                    }
                    ,
                    onComplete: () => {
                        this.updateCurrItem(),
                        s.appendHeavy()
                    }
                });
                let t = s.potentialIndex - s.currIndex;
                if (s.canLoop()) {
                    const e = (t + r) % r;
                    t = e <= r / 2 ? e : e - r
                }
                Math.abs(t) > 1 && this.updateCurrItem()
            } else
                this.moveTo(o),
                this.updateCurrItem();
            return Boolean(t)
        }
        getCurrSlideX() {
            return this.slideWidth * this._currPositionIndex
        }
        isShifted() {
            return this.x !== this.getCurrSlideX()
        }
        updateCurrItem() {
            var t;
            const {pswp: e} = this
              , i = this._prevPositionIndex - this._currPositionIndex;
            if (!i)
                return;
            this._prevPositionIndex = this._currPositionIndex,
            e.currIndex = e.potentialIndex;
            let s, n = Math.abs(i);
            n >= 3 && (this._containerShiftIndex += i + (i > 0 ? -3 : 3),
            n = 3,
            this.itemHolders.forEach((t => {
                var e;
                null === (e = t.slide) || void 0 === e || e.destroy(),
                t.slide = void 0
            }
            )));
            for (let t = 0; t < n; t++)
                i > 0 ? (s = this.itemHolders.shift(),
                s && (this.itemHolders[2] = s,
                this._containerShiftIndex++,
                Yn(s.el, (this._containerShiftIndex + 2) * this.slideWidth),
                e.setContent(s, e.currIndex - n + t + 2))) : (s = this.itemHolders.pop(),
                s && (this.itemHolders.unshift(s),
                this._containerShiftIndex--,
                Yn(s.el, this._containerShiftIndex * this.slideWidth),
                e.setContent(s, e.currIndex + n - t - 2)));
            Math.abs(this._containerShiftIndex) > 50 && !this.isShifted() && (this.resetPosition(),
            this.resize()),
            e.animations.stopAllPan(),
            this.itemHolders.forEach(( (t, e) => {
                t.slide && t.slide.setIsActive(1 === e)
            }
            )),
            e.currSlide = null === (t = this.itemHolders[1]) || void 0 === t ? void 0 : t.slide,
            e.contentLoader.updateLazy(i),
            e.currSlide && e.currSlide.applyCurrentZoomPan(),
            e.dispatch("change")
        }
        moveTo(t, e) {
            if (!this.pswp.canLoop() && e) {
                let e = (this.slideWidth * this._currPositionIndex - t) / this.slideWidth;
                e += this.pswp.currIndex;
                const i = Math.round(t - this.x);
                (e < 0 && i > 0 || e >= this.pswp.getNumItems() - 1 && i < 0) && (t = this.x + .35 * i)
            }
            this.x = t,
            this.pswp.container && Yn(this.pswp.container, t),
            this.pswp.dispatch("moveMainScroll", {
                x: t,
                dragging: null != e && e
            })
        }
    }
    const cr = {
        Escape: 27,
        z: 90,
        ArrowLeft: 37,
        ArrowUp: 38,
        ArrowRight: 39,
        ArrowDown: 40,
        Tab: 9
    }
      , hr = (t, e) => e ? t : cr[t];
    class dr {
        constructor(t) {
            this.pswp = t,
            this._wasFocused = !1,
            t.on("bindEvents", ( () => {
                t.options.trapFocus && (t.options.initialPointerPos || this._focusRoot(),
                t.events.add(document, "focusin", this._onFocusIn.bind(this))),
                t.events.add(document, "keydown", this._onKeyDown.bind(this))
            }
            ));
            const e = document.activeElement;
            t.on("destroy", ( () => {
                t.options.returnFocus && e && this._wasFocused && e.focus()
            }
            ))
        }
        _focusRoot() {
            !this._wasFocused && this.pswp.element && (this.pswp.element.focus(),
            this._wasFocused = !0)
        }
        _onKeyDown(t) {
            const {pswp: e} = this;
            if (e.dispatch("keydown", {
                originalEvent: t
            }).defaultPrevented)
                return;
            if (function(t) {
                return "button"in t && 1 === t.button || t.ctrlKey || t.metaKey || t.altKey || t.shiftKey
            }(t))
                return;
            let i, s, n = !1;
            const r = "key"in t;
            switch (r ? t.key : t.keyCode) {
            case hr("Escape", r):
                e.options.escKey && (i = "close");
                break;
            case hr("z", r):
                i = "toggleZoom";
                break;
            case hr("ArrowLeft", r):
                s = "x";
                break;
            case hr("ArrowUp", r):
                s = "y";
                break;
            case hr("ArrowRight", r):
                s = "x",
                n = !0;
                break;
            case hr("ArrowDown", r):
                n = !0,
                s = "y";
                break;
            case hr("Tab", r):
                this._focusRoot()
            }
            if (s) {
                t.preventDefault();
                const {currSlide: r} = e;
                e.options.arrowKeys && "x" === s && e.getNumItems() > 1 ? i = n ? "next" : "prev" : r && r.currZoomLevel > r.zoomLevels.fit && (r.pan[s] += n ? -80 : 80,
                r.panTo(r.pan.x, r.pan.y))
            }
            i && (t.preventDefault(),
            e[i]())
        }
        _onFocusIn(t) {
            const {template: e} = this.pswp;
            e && document !== t.target && e !== t.target && !e.contains(t.target) && e.focus()
        }
    }
    const ur = "cubic-bezier(.4,0,.22,1)";
    class pr {
        constructor(t) {
            var e;
            this.props = t;
            const {target: i, onComplete: s, transform: n, onFinish: r=( () => {}
            ), duration: o=333, easing: a=ur} = t;
            this.onFinish = r;
            const l = n ? "transform" : "opacity"
              , c = null !== (e = t[l]) && void 0 !== e ? e : "";
            this._target = i,
            this._onComplete = s,
            this._finished = !1,
            this._onTransitionEnd = this._onTransitionEnd.bind(this),
            this._helperTimeout = setTimeout(( () => {
                Hn(i, l, o, a),
                this._helperTimeout = setTimeout(( () => {
                    i.addEventListener("transitionend", this._onTransitionEnd, !1),
                    i.addEventListener("transitioncancel", this._onTransitionEnd, !1),
                    this._helperTimeout = setTimeout(( () => {
                        this._finalizeAnimation()
                    }
                    ), o + 500),
                    i.style[l] = c
                }
                ), 30)
            }
            ), 0)
        }
        _onTransitionEnd(t) {
            t.target === this._target && this._finalizeAnimation()
        }
        _finalizeAnimation() {
            this._finished || (this._finished = !0,
            this.onFinish(),
            this._onComplete && this._onComplete())
        }
        destroy() {
            this._helperTimeout && clearTimeout(this._helperTimeout),
            Hn(this._target),
            this._target.removeEventListener("transitionend", this._onTransitionEnd, !1),
            this._target.removeEventListener("transitioncancel", this._onTransitionEnd, !1),
            this._finished || this._finalizeAnimation()
        }
    }
    class mr {
        constructor(t, e, i) {
            this.velocity = 1e3 * t,
            this._dampingRatio = e || .75,
            this._naturalFrequency = i || 12,
            this._dampedFrequency = this._naturalFrequency,
            this._dampingRatio < 1 && (this._dampedFrequency *= Math.sqrt(1 - this._dampingRatio * this._dampingRatio))
        }
        easeFrame(t, e) {
            let i, s = 0;
            e /= 1e3;
            const n = Math.E ** (-this._dampingRatio * this._naturalFrequency * e);
            if (1 === this._dampingRatio)
                i = this.velocity + this._naturalFrequency * t,
                s = (t + i * e) * n,
                this.velocity = s * -this._naturalFrequency + i * n;
            else if (this._dampingRatio < 1) {
                i = 1 / this._dampedFrequency * (this._dampingRatio * this._naturalFrequency * t + this.velocity);
                const r = Math.cos(this._dampedFrequency * e)
                  , o = Math.sin(this._dampedFrequency * e);
                s = n * (t * r + i * o),
                this.velocity = s * -this._naturalFrequency * this._dampingRatio + n * (-this._dampedFrequency * t * o + this._dampedFrequency * i * r)
            }
            return s
        }
    }
    class fr {
        constructor(t) {
            this.props = t,
            this._raf = 0;
            const {start: e, end: i, velocity: s, onUpdate: n, onComplete: r, onFinish: o=( () => {}
            ), dampingRatio: a, naturalFrequency: l} = t;
            this.onFinish = o;
            const c = new mr(s,a,l);
            let h = Date.now()
              , d = e - i;
            const u = () => {
                this._raf && (d = c.easeFrame(d, Date.now() - h),
                Math.abs(d) < 1 && Math.abs(c.velocity) < 50 ? (n(i),
                r && r(),
                this.onFinish()) : (h = Date.now(),
                n(d + i),
                this._raf = requestAnimationFrame(u)))
            }
            ;
            this._raf = requestAnimationFrame(u)
        }
        destroy() {
            this._raf >= 0 && cancelAnimationFrame(this._raf),
            this._raf = 0
        }
    }
    class gr {
        constructor() {
            this.activeAnimations = []
        }
        startSpring(t) {
            this._start(t, !0)
        }
        startTransition(t) {
            this._start(t)
        }
        _start(t, e) {
            const i = e ? new fr(t) : new pr(t);
            return this.activeAnimations.push(i),
            i.onFinish = () => this.stop(i),
            i
        }
        stop(t) {
            t.destroy();
            const e = this.activeAnimations.indexOf(t);
            e > -1 && this.activeAnimations.splice(e, 1)
        }
        stopAll() {
            this.activeAnimations.forEach((t => {
                t.destroy()
            }
            )),
            this.activeAnimations = []
        }
        stopAllPan() {
            this.activeAnimations = this.activeAnimations.filter((t => !t.props.isPan || (t.destroy(),
            !1)))
        }
        stopMainScroll() {
            this.activeAnimations = this.activeAnimations.filter((t => !t.props.isMainScroll || (t.destroy(),
            !1)))
        }
        isPanRunning() {
            return this.activeAnimations.some((t => t.props.isPan))
        }
    }
    class vr {
        constructor(t) {
            this.pswp = t,
            t.events.add(t.element, "wheel", this._onWheel.bind(this))
        }
        _onWheel(t) {
            t.preventDefault();
            const {currSlide: e} = this.pswp;
            let {deltaX: i, deltaY: s} = t;
            if (e && !this.pswp.dispatch("wheel", {
                originalEvent: t
            }).defaultPrevented)
                if (t.ctrlKey || this.pswp.options.wheelToZoom) {
                    if (e.isZoomable()) {
                        let i = -s;
                        1 === t.deltaMode ? i *= .05 : i *= t.deltaMode ? 1 : .002,
                        i = 2 ** i;
                        const n = e.currZoomLevel * i;
                        e.zoomTo(n, {
                            x: t.clientX,
                            y: t.clientY
                        })
                    }
                } else
                    e.isPannable() && (1 === t.deltaMode && (i *= 18,
                    s *= 18),
                    e.panTo(e.pan.x - i, e.pan.y - s))
        }
    }
    class yr {
        constructor(t, e) {
            var i;
            const s = e.name || e.className;
            let n = e.html;
            if (!1 === t.options[s])
                return;
            "string" == typeof t.options[s + "SVG"] && (n = t.options[s + "SVG"]),
            t.dispatch("uiElementCreate", {
                data: e
            });
            let r = "";
            e.isButton ? (r += "pswp__button ",
            r += e.className || `pswp__button--${e.name}`) : r += e.className || `pswp__${e.name}`;
            let o = e.isButton ? e.tagName || "button" : e.tagName || "div";
            o = o.toLowerCase();
            const a = In(r, o);
            if (e.isButton) {
                "button" === o && (a.type = "button");
                let {title: i} = e;
                const {ariaLabel: n} = e;
                "string" == typeof t.options[s + "Title"] && (i = t.options[s + "Title"]),
                i && (a.title = i);
                const r = n || i;
                r && a.setAttribute("aria-label", r)
            }
            a.innerHTML = function(t) {
                if ("string" == typeof t)
                    return t;
                if (!t || !t.isCustomSVG)
                    return "";
                const e = t;
                let i = '<svg aria-hidden="true" class="pswp__icn" viewBox="0 0 %d %d" width="%d" height="%d">';
                return i = i.split("%d").join(e.size || 32),
                e.outlineID && (i += '<use class="pswp__icn-shadow" xlink:href="#' + e.outlineID + '"/>'),
                i += e.inner,
                i += "</svg>",
                i
            }(n),
            e.onInit && e.onInit(a, t),
            e.onClick && (a.onclick = i => {
                "string" == typeof e.onClick ? t[e.onClick]() : "function" == typeof e.onClick && e.onClick(i, a, t)
            }
            );
            const l = e.appendTo || "bar";
            let c = t.element;
            "bar" === l ? (t.topBar || (t.topBar = In("pswp__top-bar pswp__hide-on-close", "div", t.scrollWrap)),
            c = t.topBar) : (a.classList.add("pswp__hide-on-close"),
            "wrapper" === l && (c = t.scrollWrap)),
            null === (i = c) || void 0 === i || i.appendChild(t.applyFilters("uiElement", a, e))
        }
    }
    function _r(t, e, i) {
        t.classList.add("pswp__button--arrow"),
        t.setAttribute("aria-controls", "pswp__items"),
        e.on("change", ( () => {
            e.options.loop || (t.disabled = i ? !(e.currIndex < e.getNumItems() - 1) : !(e.currIndex > 0))
        }
        ))
    }
    const br = {
        name: "arrowPrev",
        className: "pswp__button--arrow--prev",
        title: "Previous",
        order: 10,
        isButton: !0,
        appendTo: "wrapper",
        html: {
            isCustomSVG: !0,
            size: 60,
            inner: '<path d="M29 43l-3 3-16-16 16-16 3 3-13 13 13 13z" id="pswp__icn-arrow"/>',
            outlineID: "pswp__icn-arrow"
        },
        onClick: "prev",
        onInit: _r
    }
      , wr = {
        name: "arrowNext",
        className: "pswp__button--arrow--next",
        title: "Next",
        order: 11,
        isButton: !0,
        appendTo: "wrapper",
        html: {
            isCustomSVG: !0,
            size: 60,
            inner: '<use xlink:href="#pswp__icn-arrow"/>',
            outlineID: "pswp__icn-arrow"
        },
        onClick: "next",
        onInit: (t, e) => {
            _r(t, e, !0)
        }
    }
      , Sr = {
        name: "close",
        title: "Close",
        order: 20,
        isButton: !0,
        html: {
            isCustomSVG: !0,
            inner: '<path d="M24 10l-2-2-6 6-6-6-2 2 6 6-6 6 2 2 6-6 6 6 2-2-6-6z" id="pswp__icn-close"/>',
            outlineID: "pswp__icn-close"
        },
        onClick: "close"
    }
      , Er = {
        name: "zoom",
        title: "Zoom",
        order: 10,
        isButton: !0,
        html: {
            isCustomSVG: !0,
            inner: '<path d="M17.426 19.926a6 6 0 1 1 1.5-1.5L23 22.5 21.5 24l-4.074-4.074z" id="pswp__icn-zoom"/><path fill="currentColor" class="pswp__zoom-icn-bar-h" d="M11 16v-2h6v2z"/><path fill="currentColor" class="pswp__zoom-icn-bar-v" d="M13 12h2v6h-2z"/>',
            outlineID: "pswp__icn-zoom"
        },
        onClick: "toggleZoom"
    }
      , xr = {
        name: "preloader",
        appendTo: "bar",
        order: 7,
        html: {
            isCustomSVG: !0,
            inner: '<path fill-rule="evenodd" clip-rule="evenodd" d="M21.2 16a5.2 5.2 0 1 1-5.2-5.2V8a8 8 0 1 0 8 8h-2.8Z" id="pswp__icn-loading"/>',
            outlineID: "pswp__icn-loading"
        },
        onInit: (t, e) => {
            let i, s = null;
            const n = e => {
                var s, n;
                i !== e && (i = e,
                s = "active",
                n = e,
                t.classList.toggle("pswp__preloader--" + s, n))
            }
              , r = () => {
                var t;
                if (null === (t = e.currSlide) || void 0 === t || !t.content.isLoading())
                    return n(!1),
                    void (s && (clearTimeout(s),
                    s = null));
                s || (s = setTimeout(( () => {
                    var t;
                    n(Boolean(null === (t = e.currSlide) || void 0 === t ? void 0 : t.content.isLoading())),
                    s = null
                }
                ), e.options.preloaderDelay))
            }
            ;
            e.on("change", r),
            e.on("loadComplete", (t => {
                e.currSlide === t.slide && r()
            }
            )),
            e.ui && (e.ui.updatePreloaderVisibility = r)
        }
    }
      , Lr = {
        name: "counter",
        order: 5,
        onInit: (t, e) => {
            e.on("change", ( () => {
                t.innerText = e.currIndex + 1 + e.options.indexIndicatorSep + e.getNumItems()
            }
            ))
        }
    };
    function Or(t, e) {
        t.classList.toggle("pswp--zoomed-in", e)
    }
    class Pr {
        constructor(t) {
            this.pswp = t,
            this.isRegistered = !1,
            this.uiElementsData = [],
            this.items = [],
            this.updatePreloaderVisibility = () => {}
            ,
            this._lastUpdatedZoomLevel = void 0
        }
        init() {
            const {pswp: t} = this;
            this.isRegistered = !1,
            this.uiElementsData = [Sr, br, wr, Er, xr, Lr],
            t.dispatch("uiRegister"),
            this.uiElementsData.sort(( (t, e) => (t.order || 0) - (e.order || 0))),
            this.items = [],
            this.isRegistered = !0,
            this.uiElementsData.forEach((t => {
                this.registerElement(t)
            }
            )),
            t.on("change", ( () => {
                var e;
                null === (e = t.element) || void 0 === e || e.classList.toggle("pswp--one-slide", 1 === t.getNumItems())
            }
            )),
            t.on("zoomPanUpdate", ( () => this._onZoomPanUpdate()))
        }
        registerElement(t) {
            this.isRegistered ? this.items.push(new yr(this.pswp,t)) : this.uiElementsData.push(t)
        }
        _onZoomPanUpdate() {
            const {template: t, currSlide: e, options: i} = this.pswp;
            if (this.pswp.opener.isClosing || !t || !e)
                return;
            let {currZoomLevel: s} = e;
            if (this.pswp.opener.isOpen || (s = e.zoomLevels.initial),
            s === this._lastUpdatedZoomLevel)
                return;
            this._lastUpdatedZoomLevel = s;
            const n = e.zoomLevels.initial - e.zoomLevels.secondary;
            if (Math.abs(n) < .01 || !e.isZoomable())
                return Or(t, !1),
                void t.classList.remove("pswp--zoom-allowed");
            t.classList.add("pswp--zoom-allowed");
            Or(t, (s === e.zoomLevels.initial ? e.zoomLevels.secondary : e.zoomLevels.initial) <= s),
            "zoom" !== i.imageClickAction && "zoom-or-close" !== i.imageClickAction || t.classList.add("pswp--click-to-zoom")
        }
    }
    class Cr {
        constructor(t, e) {
            this.type = t,
            this.defaultPrevented = !1,
            e && Object.assign(this, e)
        }
        preventDefault() {
            this.defaultPrevented = !0
        }
    }
    class Ar {
        constructor() {
            this._listeners = {},
            this._filters = {},
            this.pswp = void 0,
            this.options = void 0
        }
        addFilter(t, e, i=100) {
            var s, n, r;
            this._filters[t] || (this._filters[t] = []),
            null === (s = this._filters[t]) || void 0 === s || s.push({
                fn: e,
                priority: i
            }),
            null === (n = this._filters[t]) || void 0 === n || n.sort(( (t, e) => t.priority - e.priority)),
            null === (r = this.pswp) || void 0 === r || r.addFilter(t, e, i)
        }
        removeFilter(t, e) {
            this._filters[t] && (this._filters[t] = this._filters[t].filter((t => t.fn !== e))),
            this.pswp && this.pswp.removeFilter(t, e)
        }
        applyFilters(t, ...e) {
            var i;
            return null === (i = this._filters[t]) || void 0 === i || i.forEach((t => {
                e[0] = t.fn.apply(this, e)
            }
            )),
            e[0]
        }
        on(t, e) {
            var i, s;
            this._listeners[t] || (this._listeners[t] = []),
            null === (i = this._listeners[t]) || void 0 === i || i.push(e),
            null === (s = this.pswp) || void 0 === s || s.on(t, e)
        }
        off(t, e) {
            var i;
            this._listeners[t] && (this._listeners[t] = this._listeners[t].filter((t => e !== t))),
            null === (i = this.pswp) || void 0 === i || i.off(t, e)
        }
        dispatch(t, e) {
            var i;
            if (this.pswp)
                return this.pswp.dispatch(t, e);
            const s = new Cr(t,e);
            return null === (i = this._listeners[t]) || void 0 === i || i.forEach((t => {
                t.call(this, s)
            }
            )),
            s
        }
    }
    class Mr {
        constructor(t, e) {
            if (this.element = In("pswp__img pswp__img--placeholder", t ? "img" : "div", e),
            t) {
                const e = this.element;
                e.decoding = "async",
                e.alt = "",
                e.src = t,
                e.setAttribute("role", "presentation")
            }
            this.element.setAttribute("aria-hidden", "true")
        }
        setDisplayedSize(t, e) {
            this.element && ("IMG" === this.element.tagName ? ($n(this.element, 250, "auto"),
            this.element.style.transformOrigin = "0 0",
            this.element.style.transform = Rn(0, 0, t / 250)) : $n(this.element, t, e))
        }
        destroy() {
            var t;
            null !== (t = this.element) && void 0 !== t && t.parentNode && this.element.remove(),
            this.element = null
        }
    }
    class Tr {
        constructor(t, e, i) {
            this.instance = e,
            this.data = t,
            this.index = i,
            this.element = void 0,
            this.placeholder = void 0,
            this.slide = void 0,
            this.displayedImageWidth = 0,
            this.displayedImageHeight = 0,
            this.width = Number(this.data.w) || Number(this.data.width) || 0,
            this.height = Number(this.data.h) || Number(this.data.height) || 0,
            this.isAttached = !1,
            this.hasSlide = !1,
            this.isDecoding = !1,
            this.state = Bn,
            this.data.type ? this.type = this.data.type : this.data.src ? this.type = "image" : this.type = "html",
            this.instance.dispatch("contentInit", {
                content: this
            })
        }
        removePlaceholder() {
            this.placeholder && !this.keepPlaceholder() && setTimeout(( () => {
                this.placeholder && (this.placeholder.destroy(),
                this.placeholder = void 0)
            }
            ), 1e3)
        }
        load(t, e) {
            if (this.slide && this.usePlaceholder())
                if (this.placeholder) {
                    const t = this.placeholder.element;
                    t && !t.parentElement && this.slide.container.prepend(t)
                } else {
                    const t = this.instance.applyFilters("placeholderSrc", !(!this.data.msrc || !this.slide.isFirstSlide) && this.data.msrc, this);
                    this.placeholder = new Mr(t,this.slide.container)
                }
            this.element && !e || this.instance.dispatch("contentLoad", {
                content: this,
                isLazy: t
            }).defaultPrevented || (this.isImageContent() ? (this.element = In("pswp__img", "img"),
            this.displayedImageWidth && this.loadImage(t)) : (this.element = In("pswp__content", "div"),
            this.element.innerHTML = this.data.html || ""),
            e && this.slide && this.slide.updateContentSize(!0))
        }
        loadImage(t) {
            var e, i;
            if (!this.isImageContent() || !this.element || this.instance.dispatch("contentLoadImage", {
                content: this,
                isLazy: t
            }).defaultPrevented)
                return;
            const s = this.element;
            this.updateSrcsetSizes(),
            this.data.srcset && (s.srcset = this.data.srcset),
            s.src = null !== (e = this.data.src) && void 0 !== e ? e : "",
            s.alt = null !== (i = this.data.alt) && void 0 !== i ? i : "",
            this.state = Zn,
            s.complete ? this.onLoaded() : (s.onload = () => {
                this.onLoaded()
            }
            ,
            s.onerror = () => {
                this.onError()
            }
            )
        }
        setSlide(t) {
            this.slide = t,
            this.hasSlide = !0,
            this.instance = t.pswp
        }
        onLoaded() {
            this.state = Vn,
            this.slide && this.element && (this.instance.dispatch("loadComplete", {
                slide: this.slide,
                content: this
            }),
            this.slide.isActive && this.slide.heavyAppended && !this.element.parentNode && (this.append(),
            this.slide.updateContentSize(!0)),
            this.state !== Vn && this.state !== qn || this.removePlaceholder())
        }
        onError() {
            this.state = qn,
            this.slide && (this.displayError(),
            this.instance.dispatch("loadComplete", {
                slide: this.slide,
                isError: !0,
                content: this
            }),
            this.instance.dispatch("loadError", {
                slide: this.slide,
                content: this
            }))
        }
        isLoading() {
            return this.instance.applyFilters("isContentLoading", this.state === Zn, this)
        }
        isError() {
            return this.state === qn
        }
        isImageContent() {
            return "image" === this.type
        }
        setDisplayedSize(t, e) {
            if (this.element && (this.placeholder && this.placeholder.setDisplayedSize(t, e),
            !this.instance.dispatch("contentResize", {
                content: this,
                width: t,
                height: e
            }).defaultPrevented && ($n(this.element, t, e),
            this.isImageContent() && !this.isError()))) {
                const i = !this.displayedImageWidth && t;
                this.displayedImageWidth = t,
                this.displayedImageHeight = e,
                i ? this.loadImage(!1) : this.updateSrcsetSizes(),
                this.slide && this.instance.dispatch("imageSizeChange", {
                    slide: this.slide,
                    width: t,
                    height: e,
                    content: this
                })
            }
        }
        isZoomable() {
            return this.instance.applyFilters("isContentZoomable", this.isImageContent() && this.state !== qn, this)
        }
        updateSrcsetSizes() {
            if (!this.isImageContent() || !this.element || !this.data.srcset)
                return;
            const t = this.element
              , e = this.instance.applyFilters("srcsetSizesWidth", this.displayedImageWidth, this);
            (!t.dataset.largestUsedSize || e > parseInt(t.dataset.largestUsedSize, 10)) && (t.sizes = e + "px",
            t.dataset.largestUsedSize = String(e))
        }
        usePlaceholder() {
            return this.instance.applyFilters("useContentPlaceholder", this.isImageContent(), this)
        }
        lazyLoad() {
            this.instance.dispatch("contentLazyLoad", {
                content: this
            }).defaultPrevented || this.load(!0)
        }
        keepPlaceholder() {
            return this.instance.applyFilters("isKeepingPlaceholder", this.isLoading(), this)
        }
        destroy() {
            this.hasSlide = !1,
            this.slide = void 0,
            this.instance.dispatch("contentDestroy", {
                content: this
            }).defaultPrevented || (this.remove(),
            this.placeholder && (this.placeholder.destroy(),
            this.placeholder = void 0),
            this.isImageContent() && this.element && (this.element.onload = null,
            this.element.onerror = null,
            this.element = void 0))
        }
        displayError() {
            if (this.slide) {
                var t, e;
                let i = In("pswp__error-msg", "div");
                i.innerText = null !== (t = null === (e = this.instance.options) || void 0 === e ? void 0 : e.errorMsg) && void 0 !== t ? t : "",
                i = this.instance.applyFilters("contentErrorElement", i, this),
                this.element = In("pswp__content pswp__error-msg-container", "div"),
                this.element.appendChild(i),
                this.slide.container.innerText = "",
                this.slide.container.appendChild(this.element),
                this.slide.updateContentSize(!0),
                this.removePlaceholder()
            }
        }
        append() {
            if (this.isAttached || !this.element)
                return;
            if (this.isAttached = !0,
            this.state === qn)
                return void this.displayError();
            if (this.instance.dispatch("contentAppend", {
                content: this
            }).defaultPrevented)
                return;
            const t = "decode"in this.element;
            this.isImageContent() ? t && this.slide && (!this.slide.isActive || Un()) ? (this.isDecoding = !0,
            this.element.decode().catch(( () => {}
            )).finally(( () => {
                this.isDecoding = !1,
                this.appendImage()
            }
            ))) : this.appendImage() : this.slide && !this.element.parentNode && this.slide.container.appendChild(this.element)
        }
        activate() {
            !this.instance.dispatch("contentActivate", {
                content: this
            }).defaultPrevented && this.slide && (this.isImageContent() && this.isDecoding && !Un() ? this.appendImage() : this.isError() && this.load(!1, !0),
            this.slide.holderElement && this.slide.holderElement.setAttribute("aria-hidden", "false"))
        }
        deactivate() {
            this.instance.dispatch("contentDeactivate", {
                content: this
            }),
            this.slide && this.slide.holderElement && this.slide.holderElement.setAttribute("aria-hidden", "true")
        }
        remove() {
            this.isAttached = !1,
            this.instance.dispatch("contentRemove", {
                content: this
            }).defaultPrevented || (this.element && this.element.parentNode && this.element.remove(),
            this.placeholder && this.placeholder.element && this.placeholder.element.remove())
        }
        appendImage() {
            this.isAttached && (this.instance.dispatch("contentAppendImage", {
                content: this
            }).defaultPrevented || (this.slide && this.element && !this.element.parentNode && this.slide.container.appendChild(this.element),
            this.state !== Vn && this.state !== qn || this.removePlaceholder()))
        }
    }
    function Ir(t, e, i) {
        const s = e.createContentFromData(t, i);
        let n;
        const {options: r} = e;
        if (r) {
            let o;
            n = new tr(r,t,-1),
            o = e.pswp ? e.pswp.viewportSize : Gn(r, e);
            const a = Kn(r, o, t, i);
            n.update(s.width, s.height, a)
        }
        return s.lazyLoad(),
        n && s.setDisplayedSize(Math.ceil(s.width * n.initial), Math.ceil(s.height * n.initial)),
        s
    }
    class Dr {
        constructor(t) {
            this.pswp = t,
            this.limit = Math.max(t.options.preload[0] + t.options.preload[1] + 1, 5),
            this._cachedItems = []
        }
        updateLazy(t) {
            const {pswp: e} = this;
            if (e.dispatch("lazyLoad").defaultPrevented)
                return;
            const {preload: i} = e.options
              , s = void 0 === t || t >= 0;
            let n;
            for (n = 0; n <= i[1]; n++)
                this.loadSlideByIndex(e.currIndex + (s ? n : -n));
            for (n = 1; n <= i[0]; n++)
                this.loadSlideByIndex(e.currIndex + (s ? -n : n))
        }
        loadSlideByIndex(t) {
            const e = this.pswp.getLoopedIndex(t);
            let i = this.getContentByIndex(e);
            i || (i = function(t, e) {
                const i = e.getItemData(t);
                if (!e.dispatch("lazyLoadSlide", {
                    index: t,
                    itemData: i
                }).defaultPrevented)
                    return Ir(i, e, t)
            }(e, this.pswp),
            i && this.addToCache(i))
        }
        getContentBySlide(t) {
            let e = this.getContentByIndex(t.index);
            return e || (e = this.pswp.createContentFromData(t.data, t.index),
            this.addToCache(e)),
            e.setSlide(t),
            e
        }
        addToCache(t) {
            if (this.removeByIndex(t.index),
            this._cachedItems.push(t),
            this._cachedItems.length > this.limit) {
                const t = this._cachedItems.findIndex((t => !t.isAttached && !t.hasSlide));
                if (-1 !== t) {
                    this._cachedItems.splice(t, 1)[0].destroy()
                }
            }
        }
        removeByIndex(t) {
            const e = this._cachedItems.findIndex((e => e.index === t));
            -1 !== e && this._cachedItems.splice(e, 1)
        }
        getContentByIndex(t) {
            return this._cachedItems.find((e => e.index === t))
        }
        destroy() {
            this._cachedItems.forEach((t => t.destroy())),
            this._cachedItems = []
        }
    }
    class kr extends Ar {
        getNumItems() {
            var t;
            let e = 0;
            const i = null === (t = this.options) || void 0 === t ? void 0 : t.dataSource;
            i && "length"in i ? e = i.length : i && "gallery"in i && (i.items || (i.items = this._getGalleryDOMElements(i.gallery)),
            i.items && (e = i.items.length));
            const s = this.dispatch("numItems", {
                dataSource: i,
                numItems: e
            });
            return this.applyFilters("numItems", s.numItems, i)
        }
        createContentFromData(t, e) {
            return new Tr(t,this,e)
        }
        getItemData(t) {
            var e;
            const i = null === (e = this.options) || void 0 === e ? void 0 : e.dataSource;
            let s = {};
            Array.isArray(i) ? s = i[t] : i && "gallery"in i && (i.items || (i.items = this._getGalleryDOMElements(i.gallery)),
            s = i.items[t]);
            let n = s;
            n instanceof Element && (n = this._domElementToItemData(n));
            const r = this.dispatch("itemData", {
                itemData: n || {},
                index: t
            });
            return this.applyFilters("itemData", r.itemData, t)
        }
        _getGalleryDOMElements(t) {
            var e, i;
            return null !== (e = this.options) && void 0 !== e && e.children || null !== (i = this.options) && void 0 !== i && i.childSelector ? function(t, e, i=document) {
                let s = [];
                if (t instanceof Element)
                    s = [t];
                else if (t instanceof NodeList || Array.isArray(t))
                    s = Array.from(t);
                else {
                    const n = "string" == typeof t ? t : e;
                    n && (s = Array.from(i.querySelectorAll(n)))
                }
                return s
            }(this.options.children, this.options.childSelector, t) || [] : [t]
        }
        _domElementToItemData(t) {
            const e = {
                element: t
            }
              , i = "A" === t.tagName ? t : t.querySelector("a");
            if (i) {
                e.src = i.dataset.pswpSrc || i.href,
                i.dataset.pswpSrcset && (e.srcset = i.dataset.pswpSrcset),
                e.width = i.dataset.pswpWidth ? parseInt(i.dataset.pswpWidth, 10) : 0,
                e.height = i.dataset.pswpHeight ? parseInt(i.dataset.pswpHeight, 10) : 0,
                e.w = e.width,
                e.h = e.height,
                i.dataset.pswpType && (e.type = i.dataset.pswpType);
                const n = t.querySelector("img");
                var s;
                if (n)
                    e.msrc = n.currentSrc || n.src,
                    e.alt = null !== (s = n.getAttribute("alt")) && void 0 !== s ? s : "";
                (i.dataset.pswpCropped || i.dataset.cropped) && (e.thumbCropped = !0)
            }
            return this.applyFilters("domItemData", e, t, i)
        }
        lazyLoadData(t, e) {
            return Ir(t, this, e)
        }
    }
    const zr = .003;
    class Fr {
        constructor(t) {
            this.pswp = t,
            this.isClosed = !0,
            this.isOpen = !1,
            this.isClosing = !1,
            this.isOpening = !1,
            this._duration = void 0,
            this._useAnimation = !1,
            this._croppedZoom = !1,
            this._animateRootOpacity = !1,
            this._animateBgOpacity = !1,
            this._placeholder = void 0,
            this._opacityElement = void 0,
            this._cropContainer1 = void 0,
            this._cropContainer2 = void 0,
            this._thumbBounds = void 0,
            this._prepareOpen = this._prepareOpen.bind(this),
            t.on("firstZoomPan", this._prepareOpen)
        }
        open() {
            this._prepareOpen(),
            this._start()
        }
        close() {
            if (this.isClosed || this.isClosing || this.isOpening)
                return;
            const t = this.pswp.currSlide;
            this.isOpen = !1,
            this.isOpening = !1,
            this.isClosing = !0,
            this._duration = this.pswp.options.hideAnimationDuration,
            t && t.currZoomLevel * t.width >= this.pswp.options.maxWidthToAnimate && (this._duration = 0),
            this._applyStartProps(),
            setTimeout(( () => {
                this._start()
            }
            ), this._croppedZoom ? 30 : 0)
        }
        _prepareOpen() {
            if (this.pswp.off("firstZoomPan", this._prepareOpen),
            !this.isOpening) {
                const t = this.pswp.currSlide;
                this.isOpening = !0,
                this.isClosing = !1,
                this._duration = this.pswp.options.showAnimationDuration,
                t && t.zoomLevels.initial * t.width >= this.pswp.options.maxWidthToAnimate && (this._duration = 0),
                this._applyStartProps()
            }
        }
        _applyStartProps() {
            const {pswp: t} = this
              , e = this.pswp.currSlide
              , {options: i} = t;
            var s, n;
            ("fade" === i.showHideAnimationType ? (i.showHideOpacity = !0,
            this._thumbBounds = void 0) : "none" === i.showHideAnimationType ? (i.showHideOpacity = !1,
            this._duration = 0,
            this._thumbBounds = void 0) : this.isOpening && t._initialThumbBounds ? this._thumbBounds = t._initialThumbBounds : this._thumbBounds = this.pswp.getThumbBounds(),
            this._placeholder = null == e ? void 0 : e.getPlaceholderElement(),
            t.animations.stopAll(),
            this._useAnimation = Boolean(this._duration && this._duration > 50),
            this._animateZoom = Boolean(this._thumbBounds) && (null == e ? void 0 : e.content.usePlaceholder()) && (!this.isClosing || !t.mainScroll.isShifted()),
            this._animateZoom) ? this._animateRootOpacity = null !== (s = i.showHideOpacity) && void 0 !== s && s : (this._animateRootOpacity = !0,
            this.isOpening && e && (e.zoomAndPanToInitial(),
            e.applyCurrentZoomPan()));
            if (this._animateBgOpacity = !this._animateRootOpacity && this.pswp.options.bgOpacity > zr,
            this._opacityElement = this._animateRootOpacity ? t.element : t.bg,
            !this._useAnimation)
                return this._duration = 0,
                this._animateZoom = !1,
                this._animateBgOpacity = !1,
                this._animateRootOpacity = !0,
                void (this.isOpening && (t.element && (t.element.style.opacity = String(zr)),
                t.applyBgOpacity(1)));
            this._animateZoom && this._thumbBounds && this._thumbBounds.innerRect ? (this._croppedZoom = !0,
            this._cropContainer1 = this.pswp.container,
            this._cropContainer2 = null === (n = this.pswp.currSlide) || void 0 === n ? void 0 : n.holderElement,
            t.container && (t.container.style.overflow = "hidden",
            t.container.style.width = t.viewportSize.x + "px")) : this._croppedZoom = !1;
            this.isOpening ? (this._animateRootOpacity ? (t.element && (t.element.style.opacity = String(zr)),
            t.applyBgOpacity(1)) : (this._animateBgOpacity && t.bg && (t.bg.style.opacity = String(zr)),
            t.element && (t.element.style.opacity = "1")),
            this._animateZoom && (this._setClosedStateZoomPan(),
            this._placeholder && (this._placeholder.style.willChange = "transform",
            this._placeholder.style.opacity = String(zr)))) : this.isClosing && (t.mainScroll.itemHolders[0] && (t.mainScroll.itemHolders[0].el.style.display = "none"),
            t.mainScroll.itemHolders[2] && (t.mainScroll.itemHolders[2].el.style.display = "none"),
            this._croppedZoom && 0 !== t.mainScroll.x && (t.mainScroll.resetPosition(),
            t.mainScroll.resize()))
        }
        _start() {
            this.isOpening && this._useAnimation && this._placeholder && "IMG" === this._placeholder.tagName ? new Promise((t => {
                let e = !1
                  , i = !0;
                var s;
                (s = this._placeholder,
                "decode"in s ? s.decode().catch(( () => {}
                )) : s.complete ? Promise.resolve(s) : new Promise(( (t, e) => {
                    s.onload = () => t(s),
                    s.onerror = e
                }
                ))).finally(( () => {
                    e = !0,
                    i || t(!0)
                }
                )),
                setTimeout(( () => {
                    i = !1,
                    e && t(!0)
                }
                ), 50),
                setTimeout(t, 250)
            }
            )).finally(( () => this._initiate())) : this._initiate()
        }
        _initiate() {
            var t, e;
            null === (t = this.pswp.element) || void 0 === t || t.style.setProperty("--pswp-transition-duration", this._duration + "ms"),
            this.pswp.dispatch(this.isOpening ? "openingAnimationStart" : "closingAnimationStart"),
            this.pswp.dispatch("initialZoom" + (this.isOpening ? "In" : "Out")),
            null === (e = this.pswp.element) || void 0 === e || e.classList.toggle("pswp--ui-visible", this.isOpening),
            this.isOpening ? (this._placeholder && (this._placeholder.style.opacity = "1"),
            this._animateToOpenState()) : this.isClosing && this._animateToClosedState(),
            this._useAnimation || this._onAnimationComplete()
        }
        _onAnimationComplete() {
            const {pswp: t} = this;
            if (this.isOpen = this.isOpening,
            this.isClosed = this.isClosing,
            this.isOpening = !1,
            this.isClosing = !1,
            t.dispatch(this.isOpen ? "openingAnimationEnd" : "closingAnimationEnd"),
            t.dispatch("initialZoom" + (this.isOpen ? "InEnd" : "OutEnd")),
            this.isClosed)
                t.destroy();
            else if (this.isOpen) {
                var e;
                this._animateZoom && t.container && (t.container.style.overflow = "visible",
                t.container.style.width = "100%"),
                null === (e = t.currSlide) || void 0 === e || e.applyCurrentZoomPan()
            }
        }
        _animateToOpenState() {
            const {pswp: t} = this;
            this._animateZoom && (this._croppedZoom && this._cropContainer1 && this._cropContainer2 && (this._animateTo(this._cropContainer1, "transform", "translate3d(0,0,0)"),
            this._animateTo(this._cropContainer2, "transform", "none")),
            t.currSlide && (t.currSlide.zoomAndPanToInitial(),
            this._animateTo(t.currSlide.container, "transform", t.currSlide.getCurrentTransform()))),
            this._animateBgOpacity && t.bg && this._animateTo(t.bg, "opacity", String(t.options.bgOpacity)),
            this._animateRootOpacity && t.element && this._animateTo(t.element, "opacity", "1")
        }
        _animateToClosedState() {
            const {pswp: t} = this;
            this._animateZoom && this._setClosedStateZoomPan(!0),
            this._animateBgOpacity && t.bgOpacity > .01 && t.bg && this._animateTo(t.bg, "opacity", "0"),
            this._animateRootOpacity && t.element && this._animateTo(t.element, "opacity", "0")
        }
        _setClosedStateZoomPan(t) {
            if (!this._thumbBounds)
                return;
            const {pswp: e} = this
              , {innerRect: i} = this._thumbBounds
              , {currSlide: s, viewportSize: n} = e;
            if (this._croppedZoom && i && this._cropContainer1 && this._cropContainer2) {
                const e = -n.x + (this._thumbBounds.x - i.x) + i.w
                  , s = -n.y + (this._thumbBounds.y - i.y) + i.h
                  , r = n.x - i.w
                  , o = n.y - i.h;
                t ? (this._animateTo(this._cropContainer1, "transform", Rn(e, s)),
                this._animateTo(this._cropContainer2, "transform", Rn(r, o))) : (Yn(this._cropContainer1, e, s),
                Yn(this._cropContainer2, r, o))
            }
            s && (Dn(s.pan, i || this._thumbBounds),
            s.currZoomLevel = this._thumbBounds.w / s.width,
            t ? this._animateTo(s.container, "transform", s.getCurrentTransform()) : s.applyCurrentZoomPan())
        }
        _animateTo(t, e, i) {
            if (!this._duration)
                return void (t.style[e] = i);
            const {animations: s} = this.pswp
              , n = {
                duration: this._duration,
                easing: this.pswp.options.easing,
                onComplete: () => {
                    s.activeAnimations.length || this._onAnimationComplete()
                }
                ,
                target: t
            };
            n[e] = i,
            s.startTransition(n)
        }
    }
    const Nr = {
        allowPanToNext: !0,
        spacing: .1,
        loop: !0,
        pinchToClose: !0,
        closeOnVerticalDrag: !0,
        hideAnimationDuration: 333,
        showAnimationDuration: 333,
        zoomAnimationDuration: 333,
        escKey: !0,
        arrowKeys: !0,
        trapFocus: !0,
        returnFocus: !0,
        maxWidthToAnimate: 4e3,
        clickToCloseNonZoomable: !0,
        imageClickAction: "zoom-or-close",
        bgClickAction: "close",
        tapAction: "toggle-controls",
        doubleTapAction: "zoom",
        indexIndicatorSep: " / ",
        preloaderDelay: 2e3,
        bgOpacity: .8,
        index: 0,
        errorMsg: "The image cannot be loaded",
        preload: [1, 2],
        easing: "cubic-bezier(.4,0,.22,1)"
    };
    class Rr extends kr {
        constructor(t) {
            super(),
            this.options = this._prepareOptions(t || {}),
            this.offset = {
                x: 0,
                y: 0
            },
            this._prevViewportSize = {
                x: 0,
                y: 0
            },
            this.viewportSize = {
                x: 0,
                y: 0
            },
            this.bgOpacity = 1,
            this.currIndex = 0,
            this.potentialIndex = 0,
            this.isOpen = !1,
            this.isDestroying = !1,
            this.hasMouse = !1,
            this._initialItemData = {},
            this._initialThumbBounds = void 0,
            this.topBar = void 0,
            this.element = void 0,
            this.template = void 0,
            this.container = void 0,
            this.scrollWrap = void 0,
            this.currSlide = void 0,
            this.events = new Xn,
            this.animations = new gr,
            this.mainScroll = new lr(this),
            this.gestures = new ar(this),
            this.opener = new Fr(this),
            this.keyboard = new dr(this),
            this.contentLoader = new Dr(this)
        }
        init() {
            if (this.isOpen || this.isDestroying)
                return !1;
            this.isOpen = !0,
            this.dispatch("init"),
            this.dispatch("beforeOpen"),
            this._createMainStructure();
            let t = "pswp--open";
            return this.gestures.supportsTouch && (t += " pswp--touch"),
            this.options.mainClass && (t += " " + this.options.mainClass),
            this.element && (this.element.className += " " + t),
            this.currIndex = this.options.index || 0,
            this.potentialIndex = this.currIndex,
            this.dispatch("firstUpdate"),
            this.scrollWheel = new vr(this),
            (Number.isNaN(this.currIndex) || this.currIndex < 0 || this.currIndex >= this.getNumItems()) && (this.currIndex = 0),
            this.gestures.supportsTouch || this.mouseDetected(),
            this.updateSize(),
            this.offset.y = window.pageYOffset,
            this._initialItemData = this.getItemData(this.currIndex),
            this.dispatch("gettingData", {
                index: this.currIndex,
                data: this._initialItemData,
                slide: void 0
            }),
            this._initialThumbBounds = this.getThumbBounds(),
            this.dispatch("initialLayout"),
            this.on("openingAnimationEnd", ( () => {
                const {itemHolders: t} = this.mainScroll;
                t[0] && (t[0].el.style.display = "block",
                this.setContent(t[0], this.currIndex - 1)),
                t[2] && (t[2].el.style.display = "block",
                this.setContent(t[2], this.currIndex + 1)),
                this.appendHeavy(),
                this.contentLoader.updateLazy(),
                this.events.add(window, "resize", this._handlePageResize.bind(this)),
                this.events.add(window, "scroll", this._updatePageScrollOffset.bind(this)),
                this.dispatch("bindEvents")
            }
            )),
            this.mainScroll.itemHolders[1] && this.setContent(this.mainScroll.itemHolders[1], this.currIndex),
            this.dispatch("change"),
            this.opener.open(),
            this.dispatch("afterInit"),
            !0
        }
        getLoopedIndex(t) {
            const e = this.getNumItems();
            return this.options.loop && (t > e - 1 && (t -= e),
            t < 0 && (t += e)),
            Nn(t, 0, e - 1)
        }
        appendHeavy() {
            this.mainScroll.itemHolders.forEach((t => {
                var e;
                null === (e = t.slide) || void 0 === e || e.appendHeavy()
            }
            ))
        }
        goTo(t) {
            this.mainScroll.moveIndexBy(this.getLoopedIndex(t) - this.potentialIndex)
        }
        next() {
            this.goTo(this.potentialIndex + 1)
        }
        prev() {
            this.goTo(this.potentialIndex - 1)
        }
        zoomTo(...t) {
            var e;
            null === (e = this.currSlide) || void 0 === e || e.zoomTo(...t)
        }
        toggleZoom() {
            var t;
            null === (t = this.currSlide) || void 0 === t || t.toggleZoom()
        }
        close() {
            this.opener.isOpen && !this.isDestroying && (this.isDestroying = !0,
            this.dispatch("close"),
            this.events.removeAll(),
            this.opener.close())
        }
        destroy() {
            var t;
            if (!this.isDestroying)
                return this.options.showHideAnimationType = "none",
                void this.close();
            this.dispatch("destroy"),
            this._listeners = {},
            this.scrollWrap && (this.scrollWrap.ontouchmove = null,
            this.scrollWrap.ontouchend = null),
            null === (t = this.element) || void 0 === t || t.remove(),
            this.mainScroll.itemHolders.forEach((t => {
                var e;
                null === (e = t.slide) || void 0 === e || e.destroy()
            }
            )),
            this.contentLoader.destroy(),
            this.events.removeAll()
        }
        refreshSlideContent(t) {
            this.contentLoader.removeByIndex(t),
            this.mainScroll.itemHolders.forEach(( (e, i) => {
                var s, n;
                let r = (null !== (s = null === (n = this.currSlide) || void 0 === n ? void 0 : n.index) && void 0 !== s ? s : 0) - 1 + i;
                var o;
                (this.canLoop() && (r = this.getLoopedIndex(r)),
                r === t) && (this.setContent(e, t, !0),
                1 === i && (this.currSlide = e.slide,
                null === (o = e.slide) || void 0 === o || o.setIsActive(!0)))
            }
            )),
            this.dispatch("change")
        }
        setContent(t, e, i) {
            if (this.canLoop() && (e = this.getLoopedIndex(e)),
            t.slide) {
                if (t.slide.index === e && !i)
                    return;
                t.slide.destroy(),
                t.slide = void 0
            }
            if (!this.canLoop() && (e < 0 || e >= this.getNumItems()))
                return;
            const s = this.getItemData(e);
            t.slide = new er(s,e,this),
            e === this.currIndex && (this.currSlide = t.slide),
            t.slide.append(t.el)
        }
        getViewportCenterPoint() {
            return {
                x: this.viewportSize.x / 2,
                y: this.viewportSize.y / 2
            }
        }
        updateSize(t) {
            if (this.isDestroying)
                return;
            const e = Gn(this.options, this);
            !t && Fn(e, this._prevViewportSize) || (Dn(this._prevViewportSize, e),
            this.dispatch("beforeResize"),
            Dn(this.viewportSize, this._prevViewportSize),
            this._updatePageScrollOffset(),
            this.dispatch("viewportSize"),
            this.mainScroll.resize(this.opener.isOpen),
            !this.hasMouse && window.matchMedia("(any-hover: hover)").matches && this.mouseDetected(),
            this.dispatch("resize"))
        }
        applyBgOpacity(t) {
            this.bgOpacity = Math.max(t, 0),
            this.bg && (this.bg.style.opacity = String(this.bgOpacity * this.options.bgOpacity))
        }
        mouseDetected() {
            var t;
            this.hasMouse || (this.hasMouse = !0,
            null === (t = this.element) || void 0 === t || t.classList.add("pswp--has_mouse"))
        }
        _handlePageResize() {
            this.updateSize(),
            /iPhone|iPad|iPod/i.test(window.navigator.userAgent) && setTimeout(( () => {
                this.updateSize()
            }
            ), 500)
        }
        _updatePageScrollOffset() {
            this.setScrollOffset(0, window.pageYOffset)
        }
        setScrollOffset(t, e) {
            this.offset.x = t,
            this.offset.y = e,
            this.dispatch("updateScrollOffset")
        }
        _createMainStructure() {
            this.element = In("pswp", "div"),
            this.element.setAttribute("tabindex", "-1"),
            this.element.setAttribute("role", "dialog"),
            this.template = this.element,
            this.bg = In("pswp__bg", "div", this.element),
            this.scrollWrap = In("pswp__scroll-wrap", "section", this.element),
            this.container = In("pswp__container", "div", this.scrollWrap),
            this.scrollWrap.setAttribute("aria-roledescription", "carousel"),
            this.container.setAttribute("aria-live", "off"),
            this.container.setAttribute("id", "pswp__items"),
            this.mainScroll.appendHolders(),
            this.ui = new Pr(this),
            this.ui.init(),
            (this.options.appendToEl || document.body).appendChild(this.element)
        }
        getThumbBounds() {
            return function(t, e, i) {
                const s = i.dispatch("thumbBounds", {
                    index: t,
                    itemData: e,
                    instance: i
                });
                if (s.thumbBounds)
                    return s.thumbBounds;
                const {element: n} = e;
                let r, o;
                if (n && !1 !== i.options.thumbSelector) {
                    const t = i.options.thumbSelector || "img";
                    o = n.matches(t) ? n : n.querySelector(t)
                }
                return o = i.applyFilters("thumbEl", o, e, t),
                o && (r = e.thumbCropped ? function(t, e, i) {
                    const s = t.getBoundingClientRect()
                      , n = s.width / e
                      , r = s.height / i
                      , o = n > r ? n : r
                      , a = (s.width - e * o) / 2
                      , l = (s.height - i * o) / 2
                      , c = {
                        x: s.left + a,
                        y: s.top + l,
                        w: e * o
                    };
                    return c.innerRect = {
                        w: s.width,
                        h: s.height,
                        x: a,
                        y: l
                    },
                    c
                }(o, e.width || e.w || 0, e.height || e.h || 0) : function(t) {
                    const e = t.getBoundingClientRect();
                    return {
                        x: e.left,
                        y: e.top,
                        w: e.width
                    }
                }(o)),
                i.applyFilters("thumbBounds", r, e, t)
            }(this.currIndex, this.currSlide ? this.currSlide.data : this._initialItemData, this)
        }
        canLoop() {
            return this.options.loop && this.getNumItems() > 2
        }
        _prepareOptions(t) {
            return window.matchMedia("(prefers-reduced-motion), (update: slow)").matches && (t.showHideAnimationType = "none",
            t.zoomAnimationDuration = 0),
            {
                ...Nr,
                ...t
            }
        }
    }
    hn.extend(un),
    Promise.resolve().then((function() {
        return $r
    }
    )),
    Promise.resolve().then((function() {
        return Br
    }
    )),
    Promise.resolve().then((function() {
        return Zr
    }
    )),
    Promise.resolve().then((function() {
        return Vr
    }
    )),
    Promise.resolve().then((function() {
        return qr
    }
    )),
    Promise.resolve().then((function() {
        return Ur
    }
    )),
    Promise.resolve().then((function() {
        return Br
    }
    )),
    Promise.resolve().then((function() {
        return Wr
    }
    ));
    class Yr {
        constructor(t, i) {
            this._seed = sessionStorage.getItem("CUSTOMER_GALLERY_SEED") || Math.round(1e4 * Math.random()),
            sessionStorage.setItem("CUSTOMER_GALLERY_SEED", this._seed),
            this._app = t,
            this._elem = i;
            const s = this._elem.querySelector("[data-switch-apps-customer-gallery-config]");
            this._config = JSON.parse(s.innerHTML),
            matchMedia("(max-width: 834px)").matches && (this._config.filterLayout = "vertical");
            let n = document.querySelector("[data-switch-apps-customer-gallery-custom-content-config]");
            n && (console.log(JSON.parse(n.innerHTML)),
            this._config = e.merge(this._config, JSON.parse(n.innerHTML))),
            this._data = {
                loading: !1,
                gallery: !1,
                sortBy: this._config.sortBy || "created_at:desc",
                viewingItem: null,
                showMainGrid: !1,
                videoMuted: !1,
                filterLayout: this._config.filterLayout,
                config: this._config,
                searchValue: ""
            },
            this._searchAfter = null,
            this._submissionFormElems = this._elem.querySelectorAll("[data-switch-apps-gallery-submission-form]"),
            this._renderElems = this._elem.querySelectorAll("[data-switch-apps-gallery-render]"),
            this._scrollElem = this._elem.querySelector("[data-switch-apps-gallery-item-scroll]"),
            this._filterScrollElem = this._elem.querySelector("[data-switch-apps-filter-scroll]"),
            this._submissionForms = [],
            this._page = 1,
            console.log(this._data)
        }
        async mount() {
            this._tinybind = await Promise.resolve().then((function() {
                return Jr
            }
            )),
            this.doBinders(),
            await this.prepareData(),
            this.render();
            for (let t of this._submissionFormElems) {
                let e = new Ss(this._app,t,this._tinybind,this._data.gallery,this._config);
                e.mount(),
                this._submissionForms.push(e)
            }
            for (let t of this._renderElems)
                t.classList.add("rendered");
            this._doSliderElem(),
            window.addEventListener("keydown", (t => {
                if (this.lightbox?.pswp)
                    return;
                const e = t.key;
                "ArrowLeft" === e && this._data.viewingItem && this._prevPost(),
                "ArrowRight" === e && this._data.viewingItem && this._nextPost()
            }
            )),
            this._config.infiniteLoading && window.addEventListener("scroll", ( () => {
                let t = this._elem.querySelector("[data-s-a-load-more-trigger-container]");
                t && e.anyBitElementInViewport(t) && this.loadMore()
            }
            ), {
                passive: !0
            }),
            "horizontal" === this._data.filterLayout && document.addEventListener("click", (t => {
                if (!t.target.closest(".switch-apps-gallery-main-filter"))
                    for (let t of this._data.gallery?.formattedFilters ?? [])
                        t.open = !1
            }
            )),
            this.refresh(),
            console.log(this._data),
            0 === this._data?.gallery?.galleryItems?.hits?.hits?.length && this._config.hideIfEmpty && (this._elem.style.cssText = "display: none !important;")
        }
        refresh() {
            this._config.isMasonry && this.doMasonry()
        }
        doMasonry() {
            if (this._config.isMasonry) {
                if (this._macy)
                    return console.log("recalculate"),
                    this._macy.reInit(),
                    void this._macy.runOnImageLoad(( () => {
                        this._macy.recalculate(!0, !0)
                    }
                    ), !0);
                this._macy = mn({
                    container: "[data-s-a-masonry]",
                    columns: this._config.itemsPerRow,
                    waitForImages: !1,
                    rtl: "rtl" === document.dir,
                    breakAt: {
                        834: {
                            columns: this._config.itemsPerRowMobile
                        }
                    }
                }),
                this._macy.runOnImageLoad(( () => {
                    this._macy.recalculate(!0, !0)
                }
                ), !0)
            }
        }
        async checkHash() {
            if (window.location.hash.includes("open-gallery-item")) {
                let t = window.location.hash.split("=")[1]
                  , {data: e} = await Rt.get(`${this._app._appHost}/api/public/galleries`, {
                    params: {
                        key: this._config.key || null,
                        shop: window.Shopify.shop,
                        sort: "created_at:desc",
                        id: t
                    }
                });
                console.log("single", e),
                this._viewItem(e?.data?.galleryItems?.hits?.hits?.[0])
            }
        }
        pauseAllVideos() {
            for (let t of this._elem.querySelectorAll("video"))
                t.pause()
        }
        async prepareData(t) {
            if (this._data.loading)
                return;
            this._data.loading = !0;
            let e = !!this._data.gallery && JSON.parse(JSON.stringify(this._data.gallery))
              , i = new URLSearchParams(window.location.search);
            try {
                let s = []
                  , n = [];
                for (let t of i.keys()) {
                    if ("search" === t && (this._data.searchValue = i.get(t)),
                    !t.includes("filter."))
                        continue;
                    if (n.includes(t))
                        continue;
                    let e = t.replace(/^(filter\.)/, "");
                    for (let n of i.getAll(t))
                        s.push(e, n);
                    n.push(t)
                }
                if (this._config.preAppliedFilters) {
                    s = [];
                    for (let t of this._config.preAppliedFilters)
                        s.push(t.key, t.value)
                }
                let {data: r} = await Rt.get(`${this._app._appHost}/api/public/galleries`, {
                    params: {
                        key: this._config.key || null,
                        shop: window.Shopify.shop,
                        sort: this._data.sortBy,
                        filters: s,
                        from: (this._config.limit || 20) * (this._page - 1),
                        limit: this._config.limit,
                        seed: "random" === this._data.sortBy ? this._seed : null,
                        search: this._data.searchValue
                    }
                })
                  , o = r.data;
                console.log(o),
                o.submissionSteps = [],
                this._config.submission && (o.submissionSteps.push({
                    index: o.submissionSteps.length + 1,
                    title: this._config.submission.step_1_title,
                    type: "photos"
                }),
                o.settings.show_product_selector && o.submissionSteps.push({
                    index: o.submissionSteps.length + 1,
                    title: this._config.submission.step_2_title,
                    type: "products"
                }),
                o.fields.length > 0 && o.submissionSteps.push({
                    index: o.submissionSteps.length + 1,
                    title: this._config.submission.step_3_title,
                    type: "custom_information"
                }),
                o.submissionSteps.push({
                    index: o.submissionSteps.length + 1,
                    title: this._config.submission.step_4_title,
                    type: "personal_information"
                }),
                o.currentStep = o.submissionSteps[0]),
                o.submission = {
                    media: [],
                    mediaPreview: [],
                    products: [],
                    display_name: this._config.defaultDisplayName || localStorage.getItem("CUSTOMER_GALLERY_DISPLAY_NAME") || "",
                    email: this._config.defaultEmail || localStorage.getItem("CUSTOMER_GALLERY_EMAIL") || ""
                };
                for (let t of o.fields)
                    t.multiline && (t.type = "textarea"),
                    t.checked && (t.value = !0);
                let {global_filters: a, local_filters: l} = o.galleryItems.aggregations;
                o.localFilters = this.prepareFilters(e, o, l),
                o.formattedFilters = this.prepareFilters(e, o, a, "global");
                let c = `CUSTOMER_GALLERY_VOTES_${new Date(o.created_at).getTime()}`
                  , h = localStorage.getItem(c) ? JSON.parse(localStorage.getItem(c)) : [];
                for (let t of o.galleryItems.hits.hits)
                    t._source.haveVotedFor = h.includes(t._id),
                    t._source.mainImageGallery = t._source.mainImage,
                    t.lazyLoading = "lazy";
                t?.prependItems && (o.galleryItems.hits.hits = [...t.prependItems, ...o.galleryItems.hits.hits]),
                o.hasMoreItems = o.galleryItems.hits.hits.length < o.galleryItems.hits.total.value,
                this._data.gallery = !1,
                this._data.gallery = o,
                Number(this._data.gallery.galleryItemCount) > 0 && (this._data.showMainGrid = !0)
            } catch (t) {
                console.error(t),
                this._data.gallery = !1
            }
            this._data.loading = !1,
            this._data.rendered = !0
        }
        _getPrevPost() {
            if (!this._data.viewingItem)
                return null;
            let t = this._data.gallery.galleryItems.hits.hits
              , e = t.findIndex((t => t._id === this._data.viewingItem._id));
            return t[e - 1]
        }
        _getNextPost() {
            if (!this._data.viewingItem)
                return null;
            let t = this._data.gallery.galleryItems.hits.hits
              , e = t.findIndex((t => t._id === this._data.viewingItem._id));
            return t[e + 1]
        }
        _prevPost() {
            if (!this._data.viewingItem || !this._data.showViewingItemPopup)
                return;
            let t = this._getPrevPost();
            t && this._viewItem(t)
        }
        _nextPost() {
            if (!this._data.viewingItem || !this._data.showViewingItemPopup)
                return;
            let t = this._getNextPost();
            t && this._viewItem(t)
        }
        _doSliderElem() {
            let t = this._elem.querySelector("[data-switch-apps-gallery-slider]");
            if (!t)
                return;
            let e = rn(t, {
                loop: !0,
                align: "start",
                direction: "rtl" === document.dir ? "rtl" : "ltr"
            });
            e.canScrollPrev() || this._elem.querySelector(".s-a-embla__prev")?.remove(),
            e.canScrollNext() || (this._elem.querySelector(".s-a-embla__next")?.remove(),
            t.classList.add("s-a-no-arrows")),
            this._elem.querySelector(".s-a-embla__prev")?.addEventListener("click", e.scrollPrev, !1),
            this._elem.querySelector(".s-a-embla__next")?.addEventListener("click", e.scrollNext, !1),
            window.addEventListener("resize", (i => {
                e.canScrollNext() ? t.classList.remove("s-a-no-arrows") : t.classList.add("s-a-no-arrows")
            }
            ), {
                passive: !0
            })
        }
        async _doPhotoswipe() {
            this._elem.querySelector(".switch-apps-gallery-item-popup"),
            this.lightbox && (this.lightbox.destroy(),
            this.lightbox = null);
            let t = this._data.viewingItem._source.media.filter((t => !t.includes("https://files.switchapps.co"))).map((t => ({
                width: 1500,
                height: 1500,
                src: e.getSizedImageUrl(t, "1500x")
            })));
            t.length && (this.lightbox = new Tn({
                pswpModule: Rr,
                mainClass: "switch-apps",
                dataSource: t,
                padding: {
                    top: 30,
                    bottom: 30,
                    left: 30,
                    right: 30
                },
                preload: [100, 100],
                secondaryZoomLevel: 1.5
            }),
            new Promise((async () => {
                await Promise.all(this._data.viewingItem._source.media.filter((t => !t.includes("https://files.switchapps.co"))).map((async (t, e) => {
                    const {width: i, height: s} = await (n = t,
                    new Promise(( (t, e) => {
                        const i = new Image;
                        i.src = n,
                        i.onload = () => t({
                            width: i.naturalWidth,
                            height: i.naturalHeight
                        }),
                        i.onerror = e
                    }
                    )));
                    var n;
                    console.log(i, s, e),
                    this.lightbox && (console.log("here"),
                    this.lightbox.options.dataSource[e].width = i,
                    this.lightbox.options.dataSource[e].height = s,
                    this.lightbox.pswp && this.lightbox.pswp.refreshSlideContent(this.lightbox.pswp.currSlide.index))
                }
                )))
            }
            )),
            window.lightbox = this.lightbox,
            this.lightbox.init())
        }
        _doItemSliderElems() {
            let t = this._elem.querySelector(".switch-apps-gallery-item-popup");
            if (t) {
                this._emblaApi && this._emblaApi.destroy(),
                this._emblaApi = rn(t.querySelector(".s-a-embla"), {
                    loop: !0,
                    direction: "rtl" === document.dir ? "rtl" : "ltr"
                }),
                this._emblaApiThumb && this._emblaApiThumb.destroy(),
                this._emblaApiThumb = rn(t.querySelector(".s-a-embla-thumbs"), {
                    loop: !0,
                    containScroll: "keepSnaps",
                    dragFree: !0,
                    align: "start",
                    direction: "rtl" === document.dir ? "rtl" : "ltr"
                });
                for (let t of ["select", "init", "reInit", "resize"])
                    this._emblaApi.on(t, (t => {
                        const {slideRegistry: e} = t.internalEngine()
                          , i = e[t.selectedScrollSnap()];
                        let s = t.slideNodes()[i[0]];
                        if (s.querySelector("video"),
                        this._config.dynamicPopupImageSize) {
                            let e = s.querySelector("img")
                              , i = s.querySelector("video");
                            e && (0 === e.clientHeight ? e.addEventListener("load", (i => {
                                t.containerNode().style.height = `${e.clientHeight}px`,
                                console.log("CLIENT HEIGHT IN LOAD", e.clientHeight)
                            }
                            )) : (t.containerNode().style.height = `${e.clientHeight}px`,
                            console.log("CLIENT HEIGHT NORMAL", e.clientHeight))),
                            i && (0 === i.videoHeight ? i.addEventListener("loadedmetadata", (e => {
                                t.containerNode().style.height = i.videoHeight / i.videoWidth * i.clientWidth + "px"
                            }
                            )) : t.containerNode().style.height = i.videoHeight / i.videoWidth * i.clientWidth + "px")
                        }
                    }
                    ));
                for (let t of ["select", "init"])
                    this._emblaApi.on(t, (t => {
                        this.pauseAllVideos();
                        const {slideRegistry: e} = t.internalEngine()
                          , i = e[t.selectedScrollSnap()];
                        let s = t.slideNodes()[i[0]].querySelector("video");
                        s && (s.muted = this._data.videoMuted,
                        s.play())
                    }
                    ));
                const e = function(t, e) {
                    const i = e.slideNodes()
                      , s = i.map(( (e, i) => () => t.scrollTo(i)));
                    return i.forEach(( (t, e) => {
                        t.addEventListener("click", s[e], !1)
                    }
                    )),
                    () => {
                        i.forEach(( (t, e) => {
                            t.removeEventListener("click", s[e], !1)
                        }
                        ))
                    }
                }(this._emblaApi, this._emblaApiThumb)
                  , i = function(t, e) {
                    const i = e.slideNodes()
                      , s = () => {
                        e.scrollTo(t.selectedScrollSnap());
                        const s = t.previousScrollSnap()
                          , n = t.selectedScrollSnap();
                        i[s].classList.remove("embla-thumbs__slide--selected"),
                        i[n].classList.add("embla-thumbs__slide--selected")
                    }
                    ;
                    return t.on("select", s),
                    e.on("init", s),
                    () => {
                        const e = t.selectedScrollSnap();
                        i[e].classList.remove("embla-thumbs__slide--selected")
                    }
                }(this._emblaApi, this._emblaApiThumb);
                this._emblaApi.on("destroy", e).on("destroy", i),
                this._emblaApiThumb.on("destroy", e).on("destroy", i)
            }
        }
        prepareFilters(t, e, i, s) {
            if (e.settings.hide_filters)
                return;
            let n = new URLSearchParams(window.location.search)
              , o = Object.keys(i).filter((t => e.filters.find((e => e.title === t)))).map((e => {
                let s = i[e].buckets.map((t => ({
                    title: t.key,
                    count: t.doc_count,
                    value: t.key
                })));
                if (i[e].buckets.find((t => ["true", "false"].includes(t.key_as_string))) && (s = i[e].buckets.map((t => ({
                    title: t.key_as_string,
                    count: t.doc_count,
                    value: t.key
                }))),
                1 === i[e].buckets.length)) {
                    let t = i[e].buckets.find((t => ["true"].includes(t.key_as_string))) ? "false" : "true";
                    s.push({
                        title: t,
                        count: 0,
                        value: "true" === t
                    });
                    for (let t of s)
                        t.title = t.title.replace("true", "Yes").replace("false", "No"),
                        t.value = 1 === t.value
                }
                let r = "product" === i[e].meta.filter.fieldId ? "products" : i[e].meta.fieldTitle;
                "title" === i[e].meta.filter.fieldId && (r = "title"),
                "display_name" === i[e].meta.filter.fieldId && (r = "display_name");
                for (let t of s)
                    t.active = n.has(`filter.${r}`, t.value);
                let o = t ? t.formattedFilters.find((t => t.title === e))?.open ?? !1 : i[e].meta.filter.open_by_default;
                return s.find((t => t.active)) && (o = !0),
                "horizontal" === this._data.filterLayout && (o = !1),
                {
                    title: e,
                    filterKey: r,
                    values: s.filter((t => t.value.length)),
                    ...i[e].meta.filter,
                    index: i[e].meta.index,
                    open: o
                }
            }
            )).filter((t => t.values.length > 0)).sort(( (t, e) => t.index - e.index));
            for (let t of o)
                "product" === t.fieldId && new Promise((async (e, i) => {
                    t.loading = !0,
                    await Promise.all(t.values.map((async t => {
                        try {
                            t.product = await r.getProduct(t.value)
                        } catch (t) {
                            return console.error("filter error", t),
                            null
                        }
                    }
                    ))),
                    console.log(t.values),
                    t.values = t.values.filter((t => t.product)),
                    t.loading = !1,
                    "global" === s && (this._data.gallery.formattedFilters = this._data.gallery.formattedFilters.filter((t => t.values.length > 0)))
                }
                ));
            return o
        }
        async _viewItem(t) {
            if (!t)
                return;
            history.replaceState({}, "", `#open-gallery-item=${t._id}`),
            this._data.viewingItem = t,
            this._data.showViewingItemPopup = !0;
            let e = this._getPrevPost()
              , i = this._getNextPost();
            e && (e.lazyLoading = "eager"),
            i && (i.lazyLoading = "eager"),
            bs(this._scrollElem, {
                allowTouchMove: t => "TEXTAREA" === t.tagName || t.closest(".s-a-embla")
            }),
            this.whenPopupOpen(),
            this._doItemSliderElems(),
            this._doPhotoswipe(),
            new Promise((async () => {
                this._data.viewingItem.productsLoading = !0,
                this._data.viewingItem._source.productsResolved = [],
                this._data.viewingItem._source.productsResolved = await Promise.all(this._data.viewingItem._source.products.map((async t => {
                    try {
                        let e = await r.getProduct(t)
                          , i = this._data.viewingItem._source.productObjects?.find((e => e.handle === t))?.selected_variant_id;
                        return i && (e.currentVariantId = this._data.viewingItem._source.productObjects?.find((e => e.handle === t))?.selected_variant_id),
                        e
                    } catch (t) {
                        return console.error(t),
                        null
                    }
                }
                ))),
                this._data.viewingItem._source.productsResolved = this._data.viewingItem._source.productsResolved.filter(Boolean),
                this._data.viewingItem.productsLoading = !1
            }
            )),
            new Promise((async () => {
                this._data.viewingItem.commentsLoading = !0;
                let {data: e} = await Rt.get(`${this._app._appHost}/api/public/comments`, {
                    params: {
                        gallery_item_id: t._id,
                        shop: window.Shopify.shop
                    }
                });
                this._data.viewingItem.comments = e?.data ?? [];
                let i = `CUSTOMER_GALLERY_COMMENT_VOTES_${new Date(this._data.gallery.created_at).getTime()}`
                  , s = localStorage.getItem(i) ? JSON.parse(localStorage.getItem(i)) : [];
                for (let t of this._data.viewingItem.comments)
                    t.haveVotedFor = s.includes(t.id);
                this._data.viewingItem.commentsLoading = !1,
                this._data.viewingItem.commentDisplayName = this._config.defaultDisplayName || localStorage.getItem("CUSTOMER_GALLERY_DISPLAY_NAME") || "",
                this._data.viewingItem.commentDisplayNameInitial = this._data.viewingItem.commentDisplayName,
                this._data.viewingItem.commentEmail = this._config.defaultEmail || localStorage.getItem("CUSTOMER_GALLERY_EMAIL") || ""
            }
            ))
        }
        whenPopupOpen() {}
        whenPopupClose() {
            ws()
        }
        async loadMore() {
            if (this._loadingMore)
                return;
            this._loadingMore = !0;
            let t = this._data.gallery.galleryItems.hits.hits;
            this._page++,
            await this.prepareData({
                prependItems: t
            }),
            this.refresh(),
            this._loadingMore = !1
        }
        async render() {
            let t = {
                data: this._data,
                controller: {
                    resizeTextarea: (t, e) => {
                        t.target.style.height = "auto";
                        let i = t.target.scrollHeight;
                        0 === t.target.value.length && (i = 38),
                        t.target.style.height = i + "px"
                    }
                    ,
                    closeFiltersOuter: async (t, e) => {
                        t.target.matches(".switch-apps-gallery-main-filters") && (this._data.filtersOpen = !1,
                        this.whenPopupClose())
                    }
                    ,
                    closeFilters: async (t, e) => {
                        this._data.filtersOpen = !1,
                        this.whenPopupClose()
                    }
                    ,
                    openFilters: async (t, e) => {
                        this._data.filtersOpen = !0,
                        bs(this._filterScrollElem, {
                            allowTouchMove: t => t.closest("[data-switch-apps-touch-move]")
                        }),
                        this.whenPopupOpen()
                    }
                    ,
                    openSubmitPopup: (t, e) => {
                        if (t.preventDefault(),
                        this._data.gallery)
                            for (let t of this._submissionForms)
                                t.open()
                    }
                    ,
                    sortGrid: async (t, e) => {
                        t.preventDefault(),
                        this._searchAfter = null,
                        this._page = 1,
                        await this.prepareData(),
                        this.refresh()
                    }
                    ,
                    toggleFilter: async (t, e) => {
                        if (t.preventDefault(),
                        t.stopPropagation(),
                        e.filter.open = !e.filter.open,
                        "horizontal" === this._data.filterLayout)
                            for (let t of this._data.gallery.formattedFilters)
                                t.id !== e.filter.id && (t.open = !1)
                    }
                    ,
                    clearSearch: async (t, e) => {
                        t.preventDefault(),
                        t.stopPropagation(),
                        this._data.searchValue = "",
                        e.controller.searchGallery(t, e)
                    }
                    ,
                    searchGallery: async (t, e) => {
                        t.preventDefault(),
                        t.stopPropagation(),
                        this._searchAfter = null,
                        this._page = 1;
                        const i = new URL(window.location);
                        i.search = "";
                        let s = this._data.gallery.formattedFilters.filter((t => t.values.find((t => t.active))));
                        for (let t of s)
                            for (let e of t.values.filter((t => t.active)))
                                i.searchParams.append(`filter.${t.filterKey}`, e.value);
                        this._data.searchValue && i.searchParams.append("search", this._data.searchValue),
                        history.pushState(null, "", i),
                        await this.prepareData(),
                        this.refresh()
                    }
                    ,
                    filterClick: async (t, e) => {
                        t.preventDefault(),
                        t.stopPropagation(),
                        this._searchAfter = null,
                        this._page = 1,
                        e.value.active = !e.value.active;
                        const i = new URL(window.location);
                        i.search = "";
                        let s = this._data.gallery.formattedFilters.filter((t => t.values.find((t => t.active))));
                        for (let t of s)
                            for (let e of t.values.filter((t => t.active)))
                                i.searchParams.append(`filter.${t.filterKey}`, e.value);
                        this._data.searchValue && i.searchParams.append("search", this._data.searchValue),
                        history.pushState(null, "", i),
                        await this.prepareData(),
                        this.refresh()
                    }
                    ,
                    toggleChildComments: (t, e) => {
                        t.preventDefault(),
                        e.comment.childCommentsOpen = !e.comment.childCommentsOpen
                    }
                    ,
                    replyToComment: async (t, e) => {
                        t.preventDefault(),
                        this._data.viewingItem.commentTitle = `@${e.comment.display_name} `,
                        this._data.viewingItem.replyingTo = e.comment,
                        t.target.closest(".switch-apps-gallery-item-comments").querySelector("[data-comment-input]").focus()
                    }
                    ,
                    clearReply: async (t, e) => {
                        t.preventDefault(),
                        this._data.viewingItem.commentTitle = "",
                        this._data.viewingItem.replyingTo = null
                    }
                    ,
                    submitComment: async (t, e) => {
                        if (t.preventDefault(),
                        t.target.reportValidity()) {
                            this._data.viewingItem.commentSubmitting = !0;
                            try {
                                let {data: t} = await Rt.post(`${this._app._appHost}/api/public/comments?shop=${window.Shopify.shop}`, {
                                    gallery_item_id: Number(this._data.viewingItem._id),
                                    gallery_id: this._data.gallery.id,
                                    title: this._data.viewingItem.commentTitle,
                                    customer_gid: this._config.customerId ? `gid://shopify/Customer/${this._config.customerId}` : null,
                                    display_name: this._data.viewingItem.commentDisplayName,
                                    email: this._data.viewingItem.commentEmail,
                                    parent_id: this._data.viewingItem.replyingTo?.parent_id ?? this._data.viewingItem.replyingTo?.id,
                                    reply_to_id: this._data.viewingItem.replyingTo?.id
                                });
                                this._data.viewingItem.commentTitle = "",
                                this._data.viewingItem.commentSubmitted = !0,
                                setTimeout(( () => {
                                    this._data.viewingItem.commentSubmitted = !1,
                                    this._data.viewingItem.replyingTo = null
                                }
                                ), 5e3)
                            } catch (t) {
                                console.error(t),
                                alert(t.message)
                            } finally {
                                this._data.viewingItem.commentSubmitting = !1
                            }
                        }
                    }
                    ,
                    deleteComment: async (t, e) => {
                        if (t.preventDefault(),
                        confirm(this._config.comments.delete_confirm)) {
                            this._data.viewingItem.commentsLoading = !0;
                            try {
                                let {data: t} = await Rt.delete(`${this._app._appHost}/api/public/comments/${e.comment.id}?shop=${window.Shopify.shop}`, {
                                    data: {
                                        gallery_item_id: Number(this._data.viewingItem._id),
                                        gallery_id: this._data.gallery.id,
                                        customer_gid: this._config.customerId ? `gid://shopify/Customer/${this._config.customerId}` : null,
                                        customer_hash: this._config.customerHash
                                    }
                                });
                                this._viewItem(this._data.viewingItem)
                            } catch (t) {
                                console.error(t),
                                alert(t.message)
                            } finally {
                                this._data.viewingItem.commentsLoading = !1
                            }
                        }
                    }
                    ,
                    voteForComment: async (t, e) => {
                        t.stopPropagation();
                        let i = e.comment;
                        i.haveVotedFor = !i.haveVotedFor;
                        let s = i.haveVotedFor ? "vote" : "unvote";
                        i.haveVotedFor ? i.votes++ : i.votes--,
                        await Rt.post(`${this._app._appHost}/api/public/comments/${i.id}/vote?shop=${window.Shopify.shop}`, {
                            type: s,
                            gallery_id: this._data.gallery.id,
                            gallery_item_id: Number(this._data.viewingItem._id)
                        });
                        let n = `CUSTOMER_GALLERY_COMMENT_VOTES_${new Date(this._data.gallery.created_at).getTime()}`
                          , r = localStorage.getItem(n) ? JSON.parse(localStorage.getItem(n)) : [];
                        i.haveVotedFor ? r.push(i.id) : r = r.filter((t => t !== i.id)),
                        localStorage.setItem(n, JSON.stringify(r))
                    }
                    ,
                    voteForPost: async (t, e) => {
                        t.stopPropagation();
                        let i = e.item || this._data.viewingItem
                          , s = i._source;
                        s.haveVotedFor = !s.haveVotedFor;
                        let n = s.haveVotedFor ? "vote" : "unvote";
                        s.haveVotedFor ? s.votes++ : s.votes--,
                        await Rt.post(`${this._app._appHost}/api/public/galleries/${this._data.gallery.id}/gallery-items/${i._id}/vote?shop=${window.Shopify.shop}`, {
                            type: n
                        });
                        let r = `CUSTOMER_GALLERY_VOTES_${new Date(this._data.gallery.created_at).getTime()}`
                          , o = localStorage.getItem(r) ? JSON.parse(localStorage.getItem(r)) : [];
                        s.haveVotedFor ? o.push(i._id) : o = o.filter((t => t !== i._id)),
                        localStorage.setItem(r, JSON.stringify(o))
                    }
                    ,
                    loadMore: async (t, e) => {
                        this.loadMore()
                    }
                    ,
                    itemClick: async (t, e) => {
                        t.preventDefault(),
                        this._viewItem(e.item)
                    }
                    ,
                    itemExitOuter: async (t, e) => {
                        t.target.matches(".switch-apps-gallery--popup") && (this._data.showViewingItemPopup = !1,
                        ws(),
                        history.replaceState({}, "", "#"),
                        this.pauseAllVideos())
                    }
                    ,
                    itemExit: async (t, e) => {
                        this._data.showViewingItemPopup = !1,
                        ws(),
                        history.replaceState({}, "", "#"),
                        this.pauseAllVideos()
                    }
                    ,
                    changeMedia: async (t, e) => {
                        this._data.viewingItem._source.mainImageGallery = e.media
                    }
                    ,
                    changeVariant: async (t, e) => {
                        e.product.currentVariant = e.product.variants.find((t => `${t.id}` == `${e.product.currentVariantId}`))
                    }
                    ,
                    nextItem: async (t, e) => {
                        t.preventDefault(),
                        this._nextPost()
                    }
                    ,
                    previousItem: async (t, e) => {
                        t.preventDefault(),
                        this._prevPost()
                    }
                    ,
                    toggleMute: async (t, e) => {
                        t.preventDefault(),
                        this._data.videoMuted = !this._data.videoMuted;
                        for (let t of this._elem.querySelectorAll("video"))
                            t.muted = this._data.videoMuted
                    }
                    ,
                    openPhotoswipe: async (t, i) => {
                        this.lightbox && this.lightbox.loadAndOpen(this.lightbox.options.dataSource.findIndex((t => t.src === e.getSizedImageUrl(i.media, "1500x"))) || 0)
                    }
                    ,
                    sharePost: async (t, e) => {
                        t.preventDefault(),
                        navigator.clipboard.writeText(this.getShareLink(this._data.viewingItem)),
                        this._data.copiedToClipboard = !0,
                        setTimeout(( () => {
                            this._data.copiedToClipboard = !1
                        }
                        ), 5e3)
                    }
                    ,
                    addToCart: async (t, e) => {
                        e.product.adding = !0;
                        try {
                            await r.addToCart({
                                id: `${e.product.currentVariantId}`,
                                quantity: 1,
                                properties: {
                                    "_sa-customer-gallery-id": this._data.gallery.id,
                                    "_sa-customer-gallery-item-id": this._data.viewingItem._id
                                }
                            }),
                            document.dispatchEvent(new Event("SWITCH_APPS_GALLERY_ADDED_TO_CART"));
                            try {
                                Rt.post(`${this._app._appHost}/api/public/galleries/${this._data.gallery.id}/track-event?shop=${window.Shopify.shop}`, {
                                    event_name: "Added to cart",
                                    event_data: {
                                        variant_id: `${e.product.currentVariantId}`,
                                        quantity: 1,
                                        product_id: `${e.product.id}`
                                    }
                                })
                            } catch (t) {
                                console.error(t)
                            }
                            e.product.added = !0
                        } catch (t) {
                            t.response?.data?.description && alert(t.response.data.description)
                        }
                        e.product.adding = !1
                    }
                }
            };
            for (let e of this._renderElems)
                this._tinybind.bind(e, t)
        }
        getShareLink(t) {
            return `${window.location.origin}${window.location.pathname}#open-gallery-item=${t._id}`
        }
        doBinders() {
            this._tinybind.formatters.money = t => e.formatMoney(t, this._config.moneyFormat),
            this._tinybind.formatters.getSizedImage = (t, i) => t ? e.getSizedImageUrl(t, i) : "",
            this._tinybind.formatters.getSrcSet = (t, i) => t ? [320, 640, 750, 820, 1080, 1200, 1440, 1920, 2048, 2600, 3e3].map((i => `${e.getSizedImageUrl(t, `${i}x`)} ${i}w`)).join(", ") : "",
            this._tinybind.formatters.not = t => !t,
            this._tinybind.formatters.or = (t, e) => t || e,
            this._tinybind.formatters.toBool = t => !!t,
            this._tinybind.formatters.length = t => t?.length ?? 0,
            this._tinybind.formatters.eq = (t, e) => t === e,
            this._tinybind.formatters.gt = (t, e) => t > e,
            this._tinybind.formatters.lt = (t, e) => t < e,
            this._tinybind.formatters.pluralize = (t, e, i) => `${t} ${1 === t ? e : i}`,
            this._tinybind.formatters.append = (t, e) => `${t}${e}`,
            this._tinybind.formatters.prepend = (t, e) => `${e}${t}`,
            this._tinybind.formatters.getFieldValue = (t, i) => {
                let s = e.stripHTML(t.value)
                  , n = i?.fieldData?.find((e => e.key === t.key))?.fieldId
                  , r = n ? this._data.gallery.fields.find((t => t.id === n)) : this._data.gallery.fields.find((t => t.label === t.key));
                if (r) {
                    if ("instagram_username" === r.type)
                        return `<a target="_blank" href="https://www.instagram.com/${t.value.replaceAll("@", "")}">${t.value}</a>`;
                    if ("url" === r.type)
                        return s.toLowerCase().startsWith("u/") && (s = `https://reddit.com/${s}`),
                        s.includes("https://") || (s = `https://${s}`),
                        `<a target="_blank" href="${s}">${t.value}</a>`
                }
                return "boolean" == typeof s && (s = s ? "Yes" : "No"),
                s?.replaceAll("\n", "<br />").replace(/(https?:\/\/[^\s]+)/g, '<a target="_blank" href="$1">$1</a>')
            }
            ,
            this._tinybind.formatters.getFieldKey = (t, e) => {
                let i = e?.fieldData?.find((e => e.key === t.key))?.fieldId
                  , s = i ? this._data.gallery.fields.find((t => t.id === i)) : this._data.gallery.fields.find((t => t.originalLabel === t.key || t.label === t.key));
                return s?.display_name || s?.label || t.key
            }
            ,
            this._tinybind.formatters.objToArr = t => t ? Object.keys(t).map((e => ({
                key: e,
                value: t[e]
            }))) : [],
            this._tinybind.formatters.getVisiblePostFields = (t, e) => t?.filter((t => {
                let i = e?.fieldData?.find((e => e.key === t.key))?.fieldId
                  , s = i ? this._data.gallery.fields.find((t => t.id === i)) : this._data.gallery.fields.find((e => e.originalLabel === t.key || e.label === t.key));
                return !s || !s.hide_from_post_display
            }
            )).sort(( (t, i) => {
                let s = e?.fieldData?.findIndex((e => e.key === t.key))?.fieldId
                  , n = e?.fieldData?.findIndex((t => t.key === i.key))?.fieldId;
                return (s ? this._data.gallery.fields.findIndex((t => t.id === s)) : this._data.gallery.fields.findIndex((e => e.originalLabel === t.key || e.label === t.key))) - (n ? this._data.gallery.fields.findIndex((t => t.id === n)) : this._data.gallery.fields.findIndex((t => t.originalLabel === i.key || t.label === i.key)))
            }
            )),
            this._tinybind.formatters.getPostFieldWidth = (t, e) => {
                let i = e?.fieldData?.find((e => e.key === t.key))?.fieldId
                  , s = i ? this._data.gallery.fields.find((t => t.id === i)) : this._data.gallery.fields.find((t => t.originalLabel === t.key || t.label === t.key));
                return s?.field_post_width ?? ""
            }
            ,
            this._tinybind.formatters.where = (t, e, i) => t.filter((t => t[e] === i)),
            this._tinybind.formatters.getFilterValueCount = (t, e, i, s) => s?.find((t => t.id === e.id))?.values?.find((e => e.value === t.value))?.count ?? 0,
            this._tinybind.formatters.pluralize = (t, e, i) => 1 === t ? `${t} ${e}` : `${t} ${i}`,
            this._tinybind.formatters.getVisibleFields = t => t ? t.filter((e => {
                if (!e.is_conditional)
                    return !0;
                let i = "and" === e.condition_selector ? "every" : "some";
                return e.conditions[i]((e => {
                    let i = t.find((t => t.id === e.field))
                      , s = e.value;
                    "checkbox" === i.type && (s = "true" === s);
                    let n = i?.value === s;
                    return "is" === e.operator ? n : !n
                }
                ))
            }
            )) : [],
            this._tinybind.formatters.hasNextItem = t => {
                if (!t)
                    return !1;
                let e = this._data.gallery?.galleryItems?.hits?.hits;
                if (!e)
                    return !1;
                let i = e.findIndex((e => e._id === t._id));
                return !!e[i + 1]
            }
            ,
            this._tinybind.formatters.charAt = (t, e) => t?.charAt(e),
            this._tinybind.formatters.getActiveFilterValues = t => t.filter((t => t.active)),
            this._tinybind.formatters.getFilterValues = (t, e) => {
                let i = new Intl.Collator(void 0,{
                    numeric: !0,
                    sensitivity: "base"
                });
                return "products" === e?.filterKey ? [...t].sort(( (t, e) => i.compare(t.product?.title, e.product?.title))) ?? [] : [...t].sort(( (t, e) => i.compare(t.title, e.title))) ?? []
            }
            ,
            this._tinybind.formatters.isOwnComment = t => t.customer_gid === e.idToGid(this._config.customerId, "Customer"),
            this._tinybind.formatters.fromNow = t => hn(t).locale(window.Shopify.locale).fromNow(),
            this._tinybind.formatters.isVideo = t => t.includes("https://files.switchapps.co"),
            this._tinybind.formatters.getVideoThumbnail = t => t.replace(/\.[^/.]+$/, ".jpg"),
            this._tinybind.formatters.getVideoURL = t => t.replace(/\.[^/.]+$/, ".mp4"),
            this._tinybind.formatters.isNonNativeVideo = t => t.type.includes("video") && !["video/mp4", "video/m4v", "video/webm"].includes(t.type),
            this._tinybind.formatters.showFilters = (t, e) => t?.length > 0,
            this._tinybind.binders["string-to-bg"] = (t, i) => {
                t.style.background = i ? e.stringToColor(i) : "#eee"
            }
            ,
            this._tinybind.formatters.hasPreviousItem = t => {
                if (!t)
                    return !1;
                let e = this._data.gallery?.galleryItems?.hits?.hits;
                if (!e)
                    return !1;
                let i = e.findIndex((e => e._id === t._id));
                return !!e[i - 1]
            }
            ,
            this._tinybind.binders["add-class"] = (t, e) => {
                t.classList.add(e)
            }
            ,
            this._tinybind.binders["add-class-second"] = (t, e) => {
                t.classList.add(e)
            }
            ,
            this._tinybind.binders["set-required"] = (t, e) => {
                e ? t.setAttribute("required", !0) : t.removeAttribute("required")
            }
            ,
            this._tinybind.formatters.getProductImage = (t, e) => {
                let i = t?.variants?.find((t => `${t.id}` == `${e}`));
                return t?.images?.find((t => t.id === i?.image_id))?.src ?? t?.images?.[0].src
            }
        }
    }
    const jr = "SWITCH_APPS_GALLERY";
    class Hr {
        constructor() {
            this._appHost = "https://customer-gallery.switchapps.co",
            "customer-gallery-dev.myshopify.com" === window.Shopify.shop && (this._appHost = "https://theo-app-dev.eu.ngrok.io"),
            this._selectors = {
                render: "[data-switch-apps-customer-gallery-render]"
            },
            this._libraryName = jr,
            this._mainElems = document.querySelectorAll(this._selectors.render)
        }
        async _mount() {
            for (let[t,e] of this._mainElems.entries())
                new Promise((async () => {
                    let i = new Yr(this,e);
                    await i.mount(),
                    0 === t && i.checkHash()
                }
                ));
            this.dawnFix(),
            window[jr] = this
        }
        dawnFix() {
            try {
                for (let t of this._mainElems) {
                    let e = t.closest(".animate--slide-in");
                    e && e.classList.remove("animate--slide-in")
                }
            } catch (t) {}
        }
    }
    (new Hr)._mount();
    !function(t, e) {
        t.exports = function(t) {
            function e(t) {
                return t && "object" == typeof t && "default"in t ? t : {
                    default: t
                }
            }
            var i = e(t)
              , s = {
                name: "fr",
                weekdays: "dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi".split("_"),
                weekdaysShort: "dim._lun._mar._mer._jeu._ven._sam.".split("_"),
                weekdaysMin: "di_lu_ma_me_je_ve_sa".split("_"),
                months: "janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre".split("_"),
                monthsShort: "janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.".split("_"),
                weekStart: 1,
                yearStart: 4,
                formats: {
                    LT: "HH:mm",
                    LTS: "HH:mm:ss",
                    L: "DD/MM/YYYY",
                    LL: "D MMMM YYYY",
                    LLL: "D MMMM YYYY HH:mm",
                    LLLL: "dddd D MMMM YYYY HH:mm"
                },
                relativeTime: {
                    future: "dans %s",
                    past: "il y a %s",
                    s: "quelques secondes",
                    m: "une minute",
                    mm: "%d minutes",
                    h: "une heure",
                    hh: "%d heures",
                    d: "un jour",
                    dd: "%d jours",
                    M: "un mois",
                    MM: "%d mois",
                    y: "un an",
                    yy: "%d ans"
                },
                ordinal: function(t) {
                    return t + (1 === t ? "er" : "")
                }
            };
            return i.default.locale(s, null, !0),
            s
        }(cn())
    }({
        exports: {}
    });
    var $r = Object.freeze({
        __proto__: null
    });
    !function(t, e) {
        t.exports = function(t) {
            function e(t) {
                return t && "object" == typeof t && "default"in t ? t : {
                    default: t
                }
            }
            var i = e(t)
              , s = {
                name: "nl",
                weekdays: "zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag".split("_"),
                weekdaysShort: "zo._ma._di._wo._do._vr._za.".split("_"),
                weekdaysMin: "zo_ma_di_wo_do_vr_za".split("_"),
                months: "januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december".split("_"),
                monthsShort: "jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec".split("_"),
                ordinal: function(t) {
                    return "[" + t + (1 === t || 8 === t || t >= 20 ? "ste" : "de") + "]"
                },
                weekStart: 1,
                yearStart: 4,
                formats: {
                    LT: "HH:mm",
                    LTS: "HH:mm:ss",
                    L: "DD-MM-YYYY",
                    LL: "D MMMM YYYY",
                    LLL: "D MMMM YYYY HH:mm",
                    LLLL: "dddd D MMMM YYYY HH:mm"
                },
                relativeTime: {
                    future: "over %s",
                    past: "%s geleden",
                    s: "een paar seconden",
                    m: "een minuut",
                    mm: "%d minuten",
                    h: "een uur",
                    hh: "%d uur",
                    d: "een dag",
                    dd: "%d dagen",
                    M: "een maand",
                    MM: "%d maanden",
                    y: "een jaar",
                    yy: "%d jaar"
                }
            };
            return i.default.locale(s, null, !0),
            s
        }(cn())
    }({
        exports: {}
    });
    var Br = Object.freeze({
        __proto__: null
    });
    !function(t, e) {
        t.exports = function(t) {
            function e(t) {
                return t && "object" == typeof t && "default"in t ? t : {
                    default: t
                }
            }
            var i = e(t)
              , s = {
                s: "ein paar Sekunden",
                m: ["eine Minute", "einer Minute"],
                mm: "%d Minuten",
                h: ["eine Stunde", "einer Stunde"],
                hh: "%d Stunden",
                d: ["ein Tag", "einem Tag"],
                dd: ["%d Tage", "%d Tagen"],
                M: ["ein Monat", "einem Monat"],
                MM: ["%d Monate", "%d Monaten"],
                y: ["ein Jahr", "einem Jahr"],
                yy: ["%d Jahre", "%d Jahren"]
            };
            function n(t, e, i) {
                var n = s[i];
                return Array.isArray(n) && (n = n[e ? 0 : 1]),
                n.replace("%d", t)
            }
            var r = {
                name: "de",
                weekdays: "Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag".split("_"),
                weekdaysShort: "So._Mo._Di._Mi._Do._Fr._Sa.".split("_"),
                weekdaysMin: "So_Mo_Di_Mi_Do_Fr_Sa".split("_"),
                months: "Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember".split("_"),
                monthsShort: "Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sept._Okt._Nov._Dez.".split("_"),
                ordinal: function(t) {
                    return t + "."
                },
                weekStart: 1,
                yearStart: 4,
                formats: {
                    LTS: "HH:mm:ss",
                    LT: "HH:mm",
                    L: "DD.MM.YYYY",
                    LL: "D. MMMM YYYY",
                    LLL: "D. MMMM YYYY HH:mm",
                    LLLL: "dddd, D. MMMM YYYY HH:mm"
                },
                relativeTime: {
                    future: "in %s",
                    past: "vor %s",
                    s: n,
                    m: n,
                    mm: n,
                    h: n,
                    hh: n,
                    d: n,
                    dd: n,
                    M: n,
                    MM: n,
                    y: n,
                    yy: n
                }
            };
            return i.default.locale(r, null, !0),
            r
        }(cn())
    }({
        exports: {}
    });
    var Zr = Object.freeze({
        __proto__: null
    });
    !function(t, e) {
        t.exports = function(t) {
            function e(t) {
                return t && "object" == typeof t && "default"in t ? t : {
                    default: t
                }
            }
            var i = e(t)
              , s = {
                name: "es",
                monthsShort: "ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic".split("_"),
                weekdays: "domingo_lunes_martes_miércoles_jueves_viernes_sábado".split("_"),
                weekdaysShort: "dom._lun._mar._mié._jue._vie._sáb.".split("_"),
                weekdaysMin: "do_lu_ma_mi_ju_vi_sá".split("_"),
                months: "enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre".split("_"),
                weekStart: 1,
                formats: {
                    LT: "H:mm",
                    LTS: "H:mm:ss",
                    L: "DD/MM/YYYY",
                    LL: "D [de] MMMM [de] YYYY",
                    LLL: "D [de] MMMM [de] YYYY H:mm",
                    LLLL: "dddd, D [de] MMMM [de] YYYY H:mm"
                },
                relativeTime: {
                    future: "en %s",
                    past: "hace %s",
                    s: "unos segundos",
                    m: "un minuto",
                    mm: "%d minutos",
                    h: "una hora",
                    hh: "%d horas",
                    d: "un día",
                    dd: "%d días",
                    M: "un mes",
                    MM: "%d meses",
                    y: "un año",
                    yy: "%d años"
                },
                ordinal: function(t) {
                    return t + "º"
                }
            };
            return i.default.locale(s, null, !0),
            s
        }(cn())
    }({
        exports: {}
    });
    var Vr = Object.freeze({
        __proto__: null
    });
    !function(t, e) {
        t.exports = function(t) {
            function e(t) {
                return t && "object" == typeof t && "default"in t ? t : {
                    default: t
                }
            }
            var i = e(t)
              , s = {
                s: "מספר שניות",
                ss: "%d שניות",
                m: "דקה",
                mm: "%d דקות",
                h: "שעה",
                hh: "%d שעות",
                hh2: "שעתיים",
                d: "יום",
                dd: "%d ימים",
                dd2: "יומיים",
                M: "חודש",
                MM: "%d חודשים",
                MM2: "חודשיים",
                y: "שנה",
                yy: "%d שנים",
                yy2: "שנתיים"
            };
            function n(t, e, i) {
                return (s[i + (2 === t ? "2" : "")] || s[i]).replace("%d", t)
            }
            var r = {
                name: "he",
                weekdays: "ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת".split("_"),
                weekdaysShort: "א׳_ב׳_ג׳_ד׳_ה׳_ו׳_ש׳".split("_"),
                weekdaysMin: "א׳_ב׳_ג׳_ד׳_ה׳_ו_ש׳".split("_"),
                months: "ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר".split("_"),
                monthsShort: "ינו_פבר_מרץ_אפר_מאי_יונ_יול_אוג_ספט_אוק_נוב_דצמ".split("_"),
                relativeTime: {
                    future: "בעוד %s",
                    past: "לפני %s",
                    s: n,
                    m: n,
                    mm: n,
                    h: n,
                    hh: n,
                    d: n,
                    dd: n,
                    M: n,
                    MM: n,
                    y: n,
                    yy: n
                },
                ordinal: function(t) {
                    return t
                },
                format: {
                    LT: "HH:mm",
                    LTS: "HH:mm:ss",
                    L: "DD/MM/YYYY",
                    LL: "D [ב]MMMM YYYY",
                    LLL: "D [ב]MMMM YYYY HH:mm",
                    LLLL: "dddd, D [ב]MMMM YYYY HH:mm",
                    l: "D/M/YYYY",
                    ll: "D MMM YYYY",
                    lll: "D MMM YYYY HH:mm",
                    llll: "ddd, D MMM YYYY HH:mm"
                },
                formats: {
                    LT: "HH:mm",
                    LTS: "HH:mm:ss",
                    L: "DD/MM/YYYY",
                    LL: "D [ב]MMMM YYYY",
                    LLL: "D [ב]MMMM YYYY HH:mm",
                    LLLL: "dddd, D [ב]MMMM YYYY HH:mm",
                    l: "D/M/YYYY",
                    ll: "D MMM YYYY",
                    lll: "D MMM YYYY HH:mm",
                    llll: "ddd, D MMM YYYY HH:mm"
                }
            };
            return i.default.locale(r, null, !0),
            r
        }(cn())
    }({
        exports: {}
    });
    var qr = Object.freeze({
        __proto__: null
    });
    !function(t, e) {
        t.exports = function(t) {
            function e(t) {
                return t && "object" == typeof t && "default"in t ? t : {
                    default: t
                }
            }
            var i = e(t)
              , s = {
                name: "nb",
                weekdays: "søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag".split("_"),
                weekdaysShort: "sø._ma._ti._on._to._fr._lø.".split("_"),
                weekdaysMin: "sø_ma_ti_on_to_fr_lø".split("_"),
                months: "januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember".split("_"),
                monthsShort: "jan._feb._mars_april_mai_juni_juli_aug._sep._okt._nov._des.".split("_"),
                ordinal: function(t) {
                    return t + "."
                },
                weekStart: 1,
                yearStart: 4,
                formats: {
                    LT: "HH:mm",
                    LTS: "HH:mm:ss",
                    L: "DD.MM.YYYY",
                    LL: "D. MMMM YYYY",
                    LLL: "D. MMMM YYYY [kl.] HH:mm",
                    LLLL: "dddd D. MMMM YYYY [kl.] HH:mm"
                },
                relativeTime: {
                    future: "om %s",
                    past: "%s siden",
                    s: "noen sekunder",
                    m: "ett minutt",
                    mm: "%d minutter",
                    h: "en time",
                    hh: "%d timer",
                    d: "en dag",
                    dd: "%d dager",
                    M: "en måned",
                    MM: "%d måneder",
                    y: "ett år",
                    yy: "%d år"
                }
            };
            return i.default.locale(s, null, !0),
            s
        }(cn())
    }({
        exports: {}
    });
    var Ur = Object.freeze({
        __proto__: null
    });
    !function(t, e) {
        t.exports = function(t) {
            function e(t) {
                return t && "object" == typeof t && "default"in t ? t : {
                    default: t
                }
            }
            var i = e(t)
              , s = {
                name: "tr",
                weekdays: "Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi".split("_"),
                weekdaysShort: "Paz_Pts_Sal_Çar_Per_Cum_Cts".split("_"),
                weekdaysMin: "Pz_Pt_Sa_Ça_Pe_Cu_Ct".split("_"),
                months: "Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık".split("_"),
                monthsShort: "Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara".split("_"),
                weekStart: 1,
                formats: {
                    LT: "HH:mm",
                    LTS: "HH:mm:ss",
                    L: "DD.MM.YYYY",
                    LL: "D MMMM YYYY",
                    LLL: "D MMMM YYYY HH:mm",
                    LLLL: "dddd, D MMMM YYYY HH:mm"
                },
                relativeTime: {
                    future: "%s sonra",
                    past: "%s önce",
                    s: "birkaç saniye",
                    m: "bir dakika",
                    mm: "%d dakika",
                    h: "bir saat",
                    hh: "%d saat",
                    d: "bir gün",
                    dd: "%d gün",
                    M: "bir ay",
                    MM: "%d ay",
                    y: "bir yıl",
                    yy: "%d yıl"
                },
                ordinal: function(t) {
                    return t + "."
                }
            };
            return i.default.locale(s, null, !0),
            s
        }(cn())
    }({
        exports: {}
    });
    var Wr = Object.freeze({
        __proto__: null
    })
      , Xr = {
        exports: {}
    };
    !function(t, e) {
        t.exports = function() {
            var t = ["prefix", "templateDelimiters", "rootInterface", "preloadData", "handler"]
              , e = ["binders", "formatters", "adapters"]
              , i = 0
              , s = 1
              , n = 0
              , r = 1
              , o = /^'.*'$|^".*"$/;
            function a(t) {
                var e = i
                  , n = t;
                return o.test(t) ? n = t.slice(1, -1) : "true" === t ? n = !0 : "false" === t ? n = !1 : "null" === t ? n = null : "undefined" === t ? n = void 0 : isNaN(t) ? e = s : n = Number(t),
                {
                    type: e,
                    value: n
                }
            }
            function l(t, e) {
                for (var i, s = t.length, o = 0, a = 0, l = e[0], c = e[1]; a < s; ) {
                    if ((o = t.indexOf(l, a)) < 0) {
                        i && i.push({
                            type: n,
                            value: t.slice(a)
                        });
                        break
                    }
                    if (i || (i = []),
                    o > 0 && a < o && i.push({
                        type: n,
                        value: t.slice(a, o)
                    }),
                    a = o + l.length,
                    (o = t.indexOf(c, a)) < 0) {
                        var h = t.slice(a - c.length)
                          , d = i[i.length - 1];
                        d && d.type === n ? d.value += h : i.push({
                            type: n,
                            value: h
                        });
                        break
                    }
                    var u = t.slice(a, o).trim();
                    i.push({
                        type: r,
                        value: u
                    }),
                    a = o + c.length
                }
                return i
            }
            var c, h, d, u = {
                binders: {},
                formatters: {},
                adapters: {},
                _prefix: "rv",
                _fullPrefix: "rv-",
                get prefix() {
                    return this._prefix
                },
                set prefix(t) {
                    this._prefix = t,
                    this._fullPrefix = t + "-"
                },
                parseTemplate: l,
                parseType: a,
                templateDelimiters: ["{", "}"],
                rootInterface: ".",
                preloadData: !0,
                handler: function(t, e, i) {
                    this.call(t, e, i.view.models)
                },
                fallbackBinder: function(t, e) {
                    null != e ? t.setAttribute(this.type, e) : t.removeAttribute(this.type)
                },
                configure: function(t) {
                    var i = this;
                    t && Object.keys(t).forEach((function(s) {
                        var n = t[s];
                        e.indexOf(s) > -1 ? Object.keys(n).forEach((function(t) {
                            i[s][t] = n[t]
                        }
                        )) : i[s] = n
                    }
                    ))
                }
            };
            function p(t) {
                return "object" == typeof t && null !== t
            }
            function m(t) {
                throw new Error("[Observer] " + t)
            }
            var f = function() {
                function t(t, e, i) {
                    this.keypath = e,
                    this.callback = i,
                    this.objectPath = [],
                    this.parse(),
                    this.obj = this.getRootObject(t),
                    p(this.target = this.realize()) && this.set(!0, this.key, this.target, this.callback)
                }
                t.updateOptions = function(t) {
                    c = t.adapters,
                    h = Object.keys(c),
                    d = t.rootInterface
                }
                ,
                t.tokenize = function(t, e) {
                    var i, s, n = [], r = {
                        i: e,
                        path: ""
                    };
                    for (i = 0; i < t.length; i++)
                        s = t.charAt(i),
                        ~h.indexOf(s) ? (n.push(r),
                        r = {
                            i: s,
                            path: ""
                        }) : r.path += s;
                    return n.push(r),
                    n
                }
                ;
                var e = t.prototype;
                return e.parse = function() {
                    var e, i;
                    h.length || m("Must define at least one adapter interface."),
                    ~h.indexOf(this.keypath[0]) ? (i = this.keypath[0],
                    e = this.keypath.substr(1)) : (i = d,
                    e = this.keypath),
                    this.tokens = t.tokenize(e, i),
                    this.key = this.tokens.pop()
                }
                ,
                e.realize = function() {
                    for (var t, e, i = this.obj, s = -1, n = 0; n < this.tokens.length; n++)
                        e = this.tokens[n],
                        p(i) ? (void 0 !== this.objectPath[n] ? i !== (t = this.objectPath[n]) && (this.set(!1, e, t, this),
                        this.set(!0, e, i, this),
                        this.objectPath[n] = i) : (this.set(!0, e, i, this),
                        this.objectPath[n] = i),
                        i = this.get(e, i)) : (-1 === s && (s = n),
                        (t = this.objectPath[n]) && this.set(!1, e, t, this));
                    return -1 !== s && this.objectPath.splice(s),
                    i
                }
                ,
                e.sync = function() {
                    var t, e, i;
                    (t = this.realize()) !== this.target ? (p(this.target) && this.set(!1, this.key, this.target, this.callback),
                    p(t) && this.set(!0, this.key, t, this.callback),
                    e = this.value(),
                    this.target = t,
                    ((i = this.value()) !== e || i instanceof Function) && this.callback.sync()) : t instanceof Array && this.callback.sync()
                }
                ,
                e.value = function() {
                    if (p(this.target))
                        return this.get(this.key, this.target)
                }
                ,
                e.setValue = function(t) {
                    p(this.target) && c[this.key.i].set(this.target, this.key.path, t)
                }
                ,
                e.get = function(t, e) {
                    return c[t.i].get(e, t.path)
                }
                ,
                e.set = function(t, e, i, s) {
                    var n = t ? "observe" : "unobserve";
                    c[e.i][n](i, e.path, s)
                }
                ,
                e.unobserve = function() {
                    for (var t, e, i = 0; i < this.tokens.length; i++)
                        e = this.tokens[i],
                        (t = this.objectPath[i]) && this.set(!1, e, t, this);
                    p(this.target) && this.set(!1, this.key, this.target, this.callback)
                }
                ,
                e.getRootObject = function(t) {
                    var e, i;
                    if (!t.$parent)
                        return t;
                    for (e = this.tokens.length ? this.tokens[0].path : this.key.path,
                    i = t; i.$parent && void 0 === i[e]; )
                        i = i.$parent;
                    return i
                }
                ,
                t
            }();
            function g(t) {
                if ("checkbox" === t.type)
                    return t.checked;
                if ("select-multiple" === t.type) {
                    for (var e, i = [], s = 0; s < t.options.length; s++)
                        (e = t.options[s]).selected && i.push(e.value);
                    return i
                }
                return t.value
            }
            var v = /[^\s']+|'([^']|'[^\s])*'|"([^"]|"[^\s])*"/g
              , y = /\s+/
              , _ = function() {
                function t(t, e, i, s, n, r, o) {
                    this.view = t,
                    this.el = e,
                    this.type = i,
                    this.keypath = s,
                    this.binder = n,
                    this.arg = r,
                    this.formatters = o,
                    this.formatterObservers = {},
                    this.model = void 0
                }
                var e = t.prototype;
                return e.observe = function(t, e) {
                    return new f(t,e,this)
                }
                ,
                e.parseTarget = function() {
                    if (this.keypath) {
                        var t = a(this.keypath);
                        0 === t.type ? this.value = t.value : (this.observer = this.observe(this.view.models, this.keypath),
                        this.model = this.observer.target)
                    } else
                        this.value = void 0
                }
                ,
                e.parseFormatterArguments = function(t, e) {
                    var i = this;
                    return t.map(a).map((function(t, s) {
                        var n = t.type
                          , r = t.value;
                        if (0 === n)
                            return r;
                        i.formatterObservers[e] || (i.formatterObservers[e] = {});
                        var o = i.formatterObservers[e][s];
                        return o || (o = i.observe(i.view.models, r),
                        i.formatterObservers[e][s] = o),
                        o.value()
                    }
                    ))
                }
                ,
                e.formattedValue = function(t) {
                    var e = this;
                    return this.formatters.reduce((function(t, i, s) {
                        var n = i.match(v)
                          , r = n.shift()
                          , o = e.view.options.formatters[r]
                          , a = e.parseFormatterArguments(n, s);
                        return o && o.read instanceof Function ? t = o.read.apply(o, [t].concat(a)) : o instanceof Function && (t = o.apply(void 0, [t].concat(a))),
                        t
                    }
                    ), t)
                }
                ,
                e.eventHandler = function(t) {
                    var e = this
                      , i = e.view.options.handler;
                    return function(s) {
                        i.call(t, this, s, e)
                    }
                }
                ,
                e.set = function(t) {
                    t = t instanceof Function && !this.binder.function ? this.formattedValue(t.call(this.model)) : this.formattedValue(t);
                    var e = this.binder.routine || this.binder;
                    e instanceof Function && e.call(this, this.el, t)
                }
                ,
                e.sync = function() {
                    this.observer ? (this.model = this.observer.target,
                    this.set(this.observer.value())) : this.set(this.value)
                }
                ,
                e.publish = function() {
                    var t = this;
                    if (this.observer) {
                        var e = this.formatters.reduceRight((function(e, i, s) {
                            var n = i.split(y)
                              , r = n.shift()
                              , o = t.view.options.formatters[r]
                              , a = t.parseFormatterArguments(n, s);
                            return o && o.publish && (e = o.publish.apply(o, [e].concat(a))),
                            e
                        }
                        ), this.getValue(this.el));
                        this.observer.setValue(e)
                    }
                }
                ,
                e.bind = function() {
                    this.parseTarget(),
                    this.binder.hasOwnProperty("bind") && this.binder.bind.call(this, this.el),
                    this.view.options.preloadData && this.sync()
                }
                ,
                e.unbind = function() {
                    var t = this;
                    this.binder.unbind && this.binder.unbind.call(this, this.el),
                    this.observer && this.observer.unobserve(),
                    Object.keys(this.formatterObservers).forEach((function(e) {
                        var i = t.formatterObservers[e];
                        Object.keys(i).forEach((function(t) {
                            i[t].unobserve()
                        }
                        ))
                    }
                    )),
                    this.formatterObservers = {}
                }
                ,
                e.update = function(t) {
                    void 0 === t && (t = {}),
                    this.observer && (this.model = this.observer.target),
                    this.binder.update && this.binder.update.call(this, t)
                }
                ,
                e.getValue = function(t) {
                    return this.binder && this.binder.getValue ? this.binder.getValue.call(this, t) : g(t)
                }
                ,
                t
            }()
              , b = {
                routine: function(t, e) {
                    t.data = null != e ? e : ""
                }
            }
              , w = /((?:'[^']*')*(?:(?:[^\|']*(?:'[^']*')+[^\|']*)+|[^\|]+))|^$/g
              , S = function t(e, i) {
                var s = !1;
                if (3 === i.nodeType) {
                    var n = l(i.data, u.templateDelimiters);
                    if (n) {
                        for (var r = 0; r < n.length; r++) {
                            var o = n[r]
                              , a = document.createTextNode(o.value);
                            i.parentNode.insertBefore(a, i),
                            1 === o.type && e.buildBinding(a, null, o.value, b, null)
                        }
                        i.parentNode.removeChild(i)
                    }
                    s = !0
                } else
                    1 === i.nodeType && (s = e.traverse(i));
                if (!s)
                    for (var c = 0; c < i.childNodes.length; c++)
                        t(e, i.childNodes[c])
            }
              , E = function(t, e) {
                var i = t.binder && t.binder.priority || 0;
                return (e.binder && e.binder.priority || 0) - i
            }
              , x = function(t) {
                return t.trim()
            }
              , L = function() {
                function t(t, e, i) {
                    t.jquery || t instanceof Array ? this.els = t : this.els = [t],
                    this.models = e,
                    this.options = i,
                    this.build()
                }
                var e = t.prototype;
                return e.buildBinding = function(t, e, i, s, n) {
                    var r = i.match(w).map(x)
                      , o = r.shift();
                    this.bindings.push(new _(this,t,e,o,s,n,r))
                }
                ,
                e.build = function() {
                    this.bindings = [];
                    var t, e, i = this.els;
                    for (t = 0,
                    e = i.length; t < e; t++)
                        S(this, i[t]);
                    this.bindings.sort(E)
                }
                ,
                e.traverse = function(t) {
                    for (var e, i, s, n, r = u._fullPrefix, o = "SCRIPT" === t.nodeName || "STYLE" === t.nodeName, a = t.attributes, l = [], c = this.options.starBinders, h = 0, d = a.length; h < d; h++) {
                        var p = a[h];
                        if (0 === p.name.indexOf(r)) {
                            if (e = p.name.slice(r.length),
                            n = void 0,
                            !(i = this.options.binders[e]))
                                for (var m = 0; m < c.length; m++)
                                    if (s = c[m],
                                    e.slice(0, s.length - 1) === s.slice(0, -1)) {
                                        i = this.options.binders[s],
                                        n = e.slice(s.length - 1);
                                        break
                                    }
                            if (i || (i = u.fallbackBinder),
                            i.block)
                                return this.buildBinding(t, e, p.value, i, n),
                                t.removeAttribute(p.name),
                                !0;
                            l.push({
                                attr: p,
                                binder: i,
                                type: e,
                                arg: n
                            })
                        }
                    }
                    for (var f = 0; f < l.length; f++) {
                        var g = l[f];
                        this.buildBinding(t, g.type, g.attr.value, g.binder, g.arg),
                        t.removeAttribute(g.attr.name)
                    }
                    return o
                }
                ,
                e.bind = function() {
                    this.bindings.forEach((function(t) {
                        t.bind()
                    }
                    ))
                }
                ,
                e.unbind = function() {
                    this.bindings.forEach((function(t) {
                        t.unbind()
                    }
                    ))
                }
                ,
                e.sync = function() {
                    this.bindings.forEach((function(t) {
                        t.sync()
                    }
                    ))
                }
                ,
                e.publish = function() {
                    this.bindings.forEach((function(t) {
                        t.binder && t.binder.publishes && t.publish()
                    }
                    ))
                }
                ,
                e.update = function(t) {
                    var e = this;
                    void 0 === t && (t = {}),
                    Object.keys(t).forEach((function(i) {
                        e.models[i] = t[i]
                    }
                    )),
                    this.bindings.forEach((function(e) {
                        e.update && e.update(t)
                    }
                    ))
                }
                ,
                t
            }()
              , O = ["push", "pop", "shift", "unshift", "sort", "reverse", "splice"]
              , P = {
                counter: 0,
                weakmap: {},
                weakReference: function(t) {
                    if (!t.hasOwnProperty("__rv")) {
                        var e = this.counter++;
                        Object.defineProperty(t, "__rv", {
                            value: e
                        })
                    }
                    return this.weakmap[t.__rv] || (this.weakmap[t.__rv] = {
                        callbacks: {}
                    }),
                    this.weakmap[t.__rv]
                },
                cleanupWeakReference: function(t, e) {
                    Object.keys(t.callbacks).length || t.pointers && Object.keys(t.pointers).length || delete this.weakmap[e]
                },
                stubFunction: function(t, e) {
                    var i = t[e]
                      , s = this.weakReference(t)
                      , n = this.weakmap;
                    t[e] = function() {
                        for (var e = arguments.length, r = new Array(e), o = 0; o < e; o++)
                            r[o] = arguments[o];
                        var a = i.apply(t, r);
                        return Object.keys(s.pointers).forEach((function(t) {
                            var e = s.pointers[t];
                            n[t] && n[t].callbacks[e]instanceof Array && n[t].callbacks[e].forEach((function(t) {
                                t.sync()
                            }
                            ))
                        }
                        )),
                        a
                    }
                },
                observeArray: function(t, e, i) {
                    var s = this;
                    if (t instanceof Array) {
                        var n = this.weakReference(t);
                        n.pointers || (n.pointers = {},
                        O.forEach((function(e) {
                            s.stubFunction(t, e)
                        }
                        ))),
                        n.pointers[e] || (n.pointers[e] = []),
                        -1 === n.pointers[e].indexOf(i) && n.pointers[e].push(i)
                    }
                },
                unobserveArray: function(t, e, i) {
                    if (t instanceof Array && null != t.__rv) {
                        var s = this.weakmap[t.__rv];
                        if (s) {
                            var n = s.pointers[e];
                            if (n) {
                                var r = n.indexOf(i);
                                r > -1 && n.splice(r, 1),
                                n.length || delete s.pointers[e],
                                this.cleanupWeakReference(s, t.__rv)
                            }
                        }
                    }
                },
                observe: function(t, e, i) {
                    var s, n = this, r = this.weakReference(t).callbacks;
                    if (!r[e]) {
                        r[e] = [];
                        var o = Object.getOwnPropertyDescriptor(t, e);
                        o && (o.get || o.set || !o.configurable) || (s = t[e],
                        Object.defineProperty(t, e, {
                            enumerable: !0,
                            get: function() {
                                return s
                            },
                            set: function(i) {
                                if (i !== s) {
                                    n.unobserveArray(s, t.__rv, e),
                                    s = i;
                                    var r = n.weakmap[t.__rv];
                                    if (r) {
                                        var o = r.callbacks[e];
                                        o && o.forEach((function(t) {
                                            t.sync()
                                        }
                                        )),
                                        n.observeArray(i, t.__rv, e)
                                    }
                                }
                            }
                        }))
                    }
                    -1 === r[e].indexOf(i) && r[e].push(i),
                    this.observeArray(t[e], t.__rv, e)
                },
                unobserve: function(t, e, i) {
                    var s = this.weakmap[t.__rv];
                    if (s) {
                        var n = s.callbacks[e];
                        if (n) {
                            var r = n.indexOf(i);
                            r > -1 && (n.splice(r, 1),
                            n.length || (delete s.callbacks[e],
                            this.unobserveArray(t[e], t.__rv, e))),
                            this.cleanupWeakReference(s, t.__rv)
                        }
                    }
                },
                get: function(t, e) {
                    return t[e]
                },
                set: function(t, e, i) {
                    t[e] = i
                }
            }
              , C = function(t) {
                return null != t ? t.toString() : void 0
            }
              , A = function(t, e) {
                for (var i = 0; i < t; i++)
                    e()
            };
            function M(t, e, i) {
                var s = t.el.cloneNode(!0)
                  , n = new L(s,e,t.view.options);
                return n.bind(),
                t.marker.parentNode.insertBefore(s, i),
                n
            }
            var T = {
                "on-*": {
                    function: !0,
                    priority: 1e3,
                    unbind: function(t) {
                        this.handler && t.removeEventListener(this.arg, this.handler)
                    },
                    routine: function(t, e) {
                        this.handler && t.removeEventListener(this.arg, this.handler),
                        this.handler = this.eventHandler(e),
                        t.addEventListener(this.arg, this.handler)
                    }
                },
                "each-*": {
                    block: !0,
                    priority: 4e3,
                    bind: function(t) {
                        this.marker ? this.iterated.forEach((function(t) {
                            t.bind()
                        }
                        )) : (this.marker = document.createComment(" tinybind: " + this.type + " "),
                        this.iterated = [],
                        t.parentNode.insertBefore(this.marker, t),
                        t.parentNode.removeChild(t))
                    },
                    unbind: function(t) {
                        this.iterated && this.iterated.forEach((function(t) {
                            t.unbind()
                        }
                        ))
                    },
                    routine: function(t, e) {
                        var i = this
                          , s = this.arg;
                        e = e || [];
                        var n = t.getAttribute("index-property") || "$index";
                        e.forEach((function(t, e) {
                            var r = {
                                $parent: i.view.models
                            };
                            r[n] = e,
                            r[s] = t;
                            var o = i.iterated[e];
                            if (o)
                                if (o.models[s] !== t) {
                                    for (var a, l, c = e + 1; c < i.iterated.length; c++)
                                        if ((l = i.iterated[c]).models[s] === t) {
                                            a = c;
                                            break
                                        }
                                    void 0 !== a ? (i.iterated.splice(a, 1),
                                    i.marker.parentNode.insertBefore(l.els[0], o.els[0]),
                                    l.models[n] = e) : l = M(i, r, o.els[0]),
                                    i.iterated.splice(e, 0, l)
                                } else
                                    o.models[n] = e;
                            else {
                                var h = i.marker;
                                i.iterated.length && (h = i.iterated[i.iterated.length - 1].els[0]),
                                o = M(i, r, h.nextSibling),
                                i.iterated.push(o)
                            }
                        }
                        )),
                        this.iterated.length > e.length && A(this.iterated.length - e.length, (function() {
                            var t = i.iterated.pop();
                            t.unbind(),
                            i.marker.parentNode.removeChild(t.els[0])
                        }
                        )),
                        "OPTION" === t.nodeName && this.view.bindings.forEach((function(t) {
                            t.el === i.marker.parentNode && "value" === t.type && t.sync()
                        }
                        ))
                    },
                    update: function(t) {
                        var e = this
                          , i = {};
                        Object.keys(t).forEach((function(s) {
                            s !== e.arg && (i[s] = t[s])
                        }
                        )),
                        this.iterated.forEach((function(t) {
                            t.update(i)
                        }
                        ))
                    }
                },
                "class-*": function(t, e) {
                    var i = " " + t.className + " ";
                    !e == i.indexOf(" " + this.arg + " ") > -1 && (t.className = e ? t.className + " " + this.arg : i.replace(" " + this.arg + " ", " ").trim())
                },
                text: function(t, e) {
                    t.textContent = null != e ? e : ""
                },
                html: function(t, e) {
                    t.innerHTML = null != e ? e : ""
                },
                show: function(t, e) {
                    t.style.display = e ? "" : "none"
                },
                hide: function(t, e) {
                    t.style.display = e ? "none" : ""
                },
                enabled: function(t, e) {
                    t.disabled = !e
                },
                disabled: function(t, e) {
                    t.disabled = !!e
                },
                checked: {
                    publishes: !0,
                    priority: 2e3,
                    bind: function(t) {
                        var e = this;
                        this.callback || (this.callback = function() {
                            e.publish()
                        }
                        ),
                        t.addEventListener("change", this.callback)
                    },
                    unbind: function(t) {
                        t.removeEventListener("change", this.callback)
                    },
                    routine: function(t, e) {
                        "radio" === t.type ? t.checked = C(t.value) === C(e) : t.checked = !!e
                    }
                },
                value: {
                    publishes: !0,
                    priority: 3e3,
                    bind: function(t) {
                        if (this.isRadio = "INPUT" === t.tagName && "radio" === t.type,
                        !this.isRadio) {
                            this.event = t.getAttribute("event-name") || ("SELECT" === t.tagName ? "change" : "input");
                            var e = this;
                            this.callback || (this.callback = function() {
                                e.publish()
                            }
                            ),
                            t.addEventListener(this.event, this.callback)
                        }
                    },
                    unbind: function(t) {
                        this.isRadio || t.removeEventListener(this.event, this.callback)
                    },
                    routine: function(t, e) {
                        if (this.isRadio)
                            t.setAttribute("value", e);
                        else if ("select-multiple" === t.type) {
                            if (e instanceof Array)
                                for (var i = 0; i < t.length; i++) {
                                    var s = t[i];
                                    s.selected = e.indexOf(s.value) > -1
                                }
                        } else
                            C(e) !== C(t.value) && (t.value = null != e ? e : "")
                    }
                },
                if: {
                    block: !0,
                    priority: 4e3,
                    bind: function(t) {
                        this.marker ? !1 === this.bound && this.nested && this.nested.bind() : (this.marker = document.createComment(" tinybind: " + this.type + " " + this.keypath + " "),
                        this.attached = !1,
                        t.parentNode.insertBefore(this.marker, t),
                        t.parentNode.removeChild(t)),
                        this.bound = !0
                    },
                    unbind: function() {
                        this.nested && (this.nested.unbind(),
                        this.bound = !1)
                    },
                    routine: function(t, e) {
                        !!e !== this.attached && (e ? (this.nested || (this.nested = new L(t,this.view.models,this.view.options),
                        this.nested.bind()),
                        this.marker.parentNode.insertBefore(t, this.marker.nextSibling),
                        this.attached = !0) : (t.parentNode.removeChild(t),
                        this.attached = !1))
                    },
                    update: function(t) {
                        this.nested && this.nested.update(t)
                    }
                }
            }
              , I = {
                watch: function(t) {
                    return t
                },
                not: function(t) {
                    return !t
                },
                negate: function(t) {
                    return !t
                }
            };
            function D(t, e) {
                for (var i = 0; i < e.length; i++) {
                    var s = e[i];
                    s.enumerable = s.enumerable || !1,
                    s.configurable = !0,
                    "value"in s && (s.writable = !0),
                    Object.defineProperty(t, s.key, s)
                }
            }
            function k(t, e, i) {
                return i && D(t, i),
                t
            }
            function z(t, e) {
                t.prototype = Object.create(e.prototype),
                t.prototype.constructor = t,
                t.__proto__ = e
            }
            function F(t) {
                return F = Object.setPrototypeOf ? Object.getPrototypeOf : function(t) {
                    return t.__proto__ || Object.getPrototypeOf(t)
                }
                ,
                F(t)
            }
            function N(t, e) {
                return N = Object.setPrototypeOf || function(t, e) {
                    return t.__proto__ = e,
                    t
                }
                ,
                N(t, e)
            }
            function R() {
                if ("undefined" == typeof Reflect || !Reflect.construct)
                    return !1;
                if (Reflect.construct.sham)
                    return !1;
                if ("function" == typeof Proxy)
                    return !0;
                try {
                    return Date.prototype.toString.call(Reflect.construct(Date, [], (function() {}
                    ))),
                    !0
                } catch (t) {
                    return !1
                }
            }
            function Y(t, e, i) {
                return Y = R() ? Reflect.construct : function(t, e, i) {
                    var s = [null];
                    s.push.apply(s, e);
                    var n = new (Function.bind.apply(t, s));
                    return i && N(n, i.prototype),
                    n
                }
                ,
                Y.apply(null, arguments)
            }
            function j(t) {
                return -1 !== Function.toString.call(t).indexOf("[native code]")
            }
            function H(t) {
                var e = "function" == typeof Map ? new Map : void 0;
                return H = function(t) {
                    if (null === t || !j(t))
                        return t;
                    if ("function" != typeof t)
                        throw new TypeError("Super expression must either be null or a function");
                    if (void 0 !== e) {
                        if (e.has(t))
                            return e.get(t);
                        e.set(t, i)
                    }
                    function i() {
                        return Y(t, arguments, F(this).constructor)
                    }
                    return i.prototype = Object.create(t.prototype, {
                        constructor: {
                            value: i,
                            enumerable: !1,
                            writable: !0,
                            configurable: !0
                        }
                    }),
                    N(i, t)
                }
                ,
                H(t)
            }
            var $ = function(t) {
                function e() {
                    return t.apply(this, arguments) || this
                }
                z(e, t);
                var i = e.prototype;
                return i.connectedCallback = function() {
                    var t = this.constructor.__templateEl.content.cloneNode(!0);
                    for (this.__tinybindView = u.bind(t, this); this.firstChild; )
                        this.removeChild(this.firstChild);
                    this.appendChild(t)
                }
                ,
                i.disconnectedCallback = function() {
                    this.__tinybindView.unbind()
                }
                ,
                i.attributeChangedCallback = function(t, e, i) {
                    e !== i && (this[this.constructor.__propAttributeMap[t]] = i)
                }
                ,
                k(e, null, [{
                    key: "observedAttributes",
                    get: function() {
                        var t = this.template;
                        if (!t)
                            throw new Error("No template declared for " + this.name);
                        this.__templateEl = document.createElement("template"),
                        this.__templateEl.innerHTML = t;
                        var e = this.__propAttributeMap = {}
                          , i = []
                          , s = this.properties;
                        return s && Object.keys(s).forEach((function(t) {
                            var n = s[t]
                              , r = "string" == typeof n ? n : t;
                            e[r] = t,
                            i.push(r)
                        }
                        )),
                        i
                    }
                }]),
                e
            }(H(HTMLElement));
            return u.binders = T,
            u.formatters = I,
            u.adapters["."] = P,
            u.Component = $,
            u.bind = function(i, s, n) {
                var r = {};
                s = s || {},
                n = n || {},
                e.forEach((function(t) {
                    r[t] = Object.create(null),
                    n[t] && Object.keys(n[t]).forEach((function(e) {
                        r[t][e] = n[t][e]
                    }
                    )),
                    Object.keys(u[t]).forEach((function(e) {
                        r[t][e] || (r[t][e] = u[t][e])
                    }
                    ))
                }
                )),
                t.forEach((function(t) {
                    var e = n[t];
                    r[t] = null != e ? e : u[t]
                }
                )),
                r.starBinders = Object.keys(r.binders).filter((function(t) {
                    return t.indexOf("*") > 0
                }
                )),
                f.updateOptions(r);
                var o = new L(i,s,r);
                return o.bind(),
                o
            }
            ,
            u
        }()
    }(Xr);
    var Gr = Xr.exports
      , Jr = t({
        __proto__: null,
        default: on(Gr)
    }, [Gr]);
    return Hr
}();
